function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("MNfxH", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$c969d4155b4e137a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e9YVH;
    var $lw2HC;
    var $ghVG7;
    var $g26cY;
    var $esWw1;
    var $kGNe4;
    var $2Lj35;
    var $2riGj;
    var $4dRjY;
    var $90yGq;
    var $imS60;
    const $c969d4155b4e137a$var$renderKnowledgeHubPageWithCorrectBreadcrumbs = (match, accountId, spaceKey)=>{
        if (match && match.params && match.params.categoryId) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
            name: "knowledge-hub-category-view-article"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kGNe4")).default), {
            id: (0, (0, parcelRequire("2Lj35")).toCategoryGuid)(match.params.categoryId || '')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("esWw1")).default), {
            id: match.params.articleId,
            accountId: accountId,
            spaceKey: spaceKey
        })));
        if (match && match.url && match.url.includes('search')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
            name: "knowledge-hub-search-view-article"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g26cY")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("esWw1")).default), {
            id: match && match.params && match.params.articleId,
            accountId: accountId,
            spaceKey: spaceKey
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imS60")).default), {
            name: "knowledge-hub-browse-view-article"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("esWw1")).default), {
            id: match && match.params && match.params.articleId,
            accountId: accountId,
            spaceKey: spaceKey
        }));
    };
    const $c969d4155b4e137a$var$View = ()=>{
        const [, { resetDraftArticleData: resetDraftArticleData }] = (0, (0, parcelRequire("lw2HC")).useArticleId)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        (0, $5uXOq.useEffect)(()=>()=>{
                resetDraftArticleData(false);
            }, [
            resetDraftArticleData
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dRjY")).MarkProductStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2riGj")).KnowledgeHubAppBase), {
            appName: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE
        }, ({ match: match, query: query })=>{
            const spaceKey = query ? query.spaceKey || query.spacekey : undefined;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ghVG7")).default), null, $c969d4155b4e137a$var$renderKnowledgeHubPageWithCorrectBreadcrumbs(match, accountId, spaceKey));
        }));
    };
    var $c969d4155b4e137a$export$2e2bcd8739ae039 = $c969d4155b4e137a$var$View;
});
parcelRegister("lw2HC", function(module, exports) {
    $parcel$export(module.exports, "initialCreateCategoryData", ()=>$ba746da67c53f4b3$export$4947e9942a5d137c);
    $parcel$export(module.exports, "KnowledgeCommonSubscriber", ()=>$ba746da67c53f4b3$export$d226f0c95b79366b);
    $parcel$export(module.exports, "UserCapabilitiesSubscriber", ()=>$ba746da67c53f4b3$export$42b7b5df8c1dee52);
    $parcel$export(module.exports, "useFlagData", ()=>$ba746da67c53f4b3$export$a9ac4a6dcb7104bf);
    $parcel$export(module.exports, "useGetCategory", ()=>$ba746da67c53f4b3$export$3fa52226f8fff61e);
    $parcel$export(module.exports, "useDraftShareId", ()=>$ba746da67c53f4b3$export$2602997fd4d9b312);
    $parcel$export(module.exports, "useArticleId", ()=>$ba746da67c53f4b3$export$a5eb46485735066a);
    $parcel$export(module.exports, "useIsFetchingDraftDetails", ()=>$ba746da67c53f4b3$export$428db75bed41f9d);
    $parcel$export(module.exports, "useRedirectionData", ()=>$ba746da67c53f4b3$export$e30071c464cba7f9);
    $parcel$export(module.exports, "useUserCapabilities", ()=>$ba746da67c53f4b3$export$7ae10e817e068c57);
    $parcel$export(module.exports, "useIsPermittedSpaces", ()=>$ba746da67c53f4b3$export$60270d772f1f3c76);
    $parcel$export(module.exports, "useCategoriesData", ()=>$ba746da67c53f4b3$export$56b47c5ebac10997);
    $parcel$export(module.exports, "useCreateCategoryData", ()=>$ba746da67c53f4b3$export$1e7300097c003415);
    var $7JoAD = parcelRequire("7JoAD");
    var $kz5Uo;
    var $cSB1I;
    const $ba746da67c53f4b3$export$61e797cf03b496e1 = {
        hasConfluenceLicense: false,
        articleUserCapabilities: {
            canCreateArticle: false
        },
        spaceUserCapabilities: {
            editableSpaces: [],
            readableSpaces: []
        }
    };
    const $ba746da67c53f4b3$export$4947e9942a5d137c = {
        isSubmitting: false,
        formValues: {
            name: '',
            description: ''
        },
        error: {
            formError: undefined,
            fieldErrors: undefined
        },
        createdCategory: null
    };
    const $ba746da67c53f4b3$export$d4c72bab9d6cc13a = {
        draftShareId: '',
        articleId: '',
        published: false,
        closed: false,
        deleted: false,
        redirectionData: {
            onPublishRedirectUrl: '',
            onCloseRedirectUrl: ''
        },
        isFetchingDraftDetails: false,
        spacesPermitted: {
            isLoading: false,
            data: null,
            error: null,
            totalSize: 0
        },
        permittedSpaces: {
            isLoading: false,
            data: null,
            error: null,
            totalSize: 0
        },
        userCapabilities: {
            isLoading: false,
            error: null,
            data: {
                ...$ba746da67c53f4b3$export$61e797cf03b496e1
            }
        },
        linkedSpaces: {
            isLoading: false,
            data: null,
            error: null,
            totalSize: 0
        },
        showConfluenceCreatePageError: false,
        categoriesData: {
            isLoading: true,
            categories: [],
            isCategoriesSupported: false,
            error: null
        },
        createCategoryData: {
            ...$ba746da67c53f4b3$export$4947e9942a5d137c
        },
        spaceKey: '',
        flags: []
    };
    const $ba746da67c53f4b3$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
        initialState: $ba746da67c53f4b3$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("kz5Uo")).actions,
        name: 'KnowledgeCommonStore'
    });
    const $ba746da67c53f4b3$export$d226f0c95b79366b = (0, $7JoAD.createSubscriber)($ba746da67c53f4b3$export$6f57813fe9f31bf9);
    const $ba746da67c53f4b3$export$42b7b5df8c1dee52 = (0, $7JoAD.createSubscriber)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        displayName: 'UserCapabilitiesSubscriber',
        selector: (0, (0, parcelRequire("cSB1I")).getUserCapabilities)
    });
    const $ba746da67c53f4b3$export$a3c47cea95d8bbd1 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getCommonFlags)
    });
    const $ba746da67c53f4b3$export$a9ac4a6dcb7104bf = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getKnowledgeCommonFlags)
    });
    const $ba746da67c53f4b3$export$3fa52226f8fff61e = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getCategory)
    });
    const $ba746da67c53f4b3$export$2602997fd4d9b312 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getDraftShareId)
    });
    const $ba746da67c53f4b3$export$a5eb46485735066a = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getArticleId)
    });
    const $ba746da67c53f4b3$export$428db75bed41f9d = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getIsFetchingDraftDetails)
    });
    const $ba746da67c53f4b3$export$e30071c464cba7f9 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getRedirectionData)
    });
    const $ba746da67c53f4b3$export$7ae10e817e068c57 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getUserCapabilities)
    });
    const $ba746da67c53f4b3$export$60270d772f1f3c76 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getPermittedSpaces)
    });
    const $ba746da67c53f4b3$export$40685b8df387d08 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getLinkedSpaces)
    });
    const $ba746da67c53f4b3$export$56b47c5ebac10997 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getCategoriesData)
    });
    const $ba746da67c53f4b3$export$1e7300097c003415 = (0, $7JoAD.createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getCreateCategoryData)
    });
});
parcelRegister("kz5Uo", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$78ea76781fae4c5f$export$e324594224ef24da);
    var $lx7EO;
    var $heXZI;
    var $dsFMC;
    var $aInVL;
    var $3twc2;
    var $klUDT;
    var $2tTYZ;
    var $ik7FP;
    var $dAXEk;
    var $dIiIO;
    var $gpe3Z;
    var $1TU0Q;
    var $jIuZj;
    var $eP4xZ;
    var $8QyFO;
    var $1VmcQ;
    const $78ea76781fae4c5f$export$e324594224ef24da = {
        setRedirectionData: (0, parcelRequire("1TU0Q")).setRedirectionData,
        resetRedirectionData: (0, parcelRequire("1TU0Q")).resetRedirectionData,
        publishSuccess: (0, parcelRequire("aInVL")).publishSuccess,
        savedSuccess: (0, parcelRequire("3twc2")).savedSuccess,
        fetchDraftAndNavigateToEditor: (0, parcelRequire("ik7FP")).fetchDraftAndNavigateToEditor,
        navigateCreateDraftRoute: (0, parcelRequire("gpe3Z")).navigateCreateDraftRoute,
        fetchCreateArticlePermission: (0, parcelRequire("2tTYZ")).fetchCreateArticlePermission,
        fetchLinkedSpaces: (0, parcelRequire("dAXEk")).fetchLinkedSpaces,
        resetDraftArticleData: (0, parcelRequire("8QyFO")).resetDraftArticleData,
        articleDeleteSuccess: (0, parcelRequire("lx7EO")).articleDeleteSuccess,
        fetchUserCapabilities: (0, parcelRequire("dIiIO")).fetchUserCapabilities,
        fetchCategories: (0, parcelRequire("klUDT")).fetchCategories,
        reorderCategories: (0, parcelRequire("eP4xZ")).reorderCategories,
        createCategory: (0, parcelRequire("heXZI")).createCategory,
        handleFormInputChange: (0, parcelRequire("heXZI")).handleFormInputChange,
        resetCreatedCategory: (0, parcelRequire("heXZI")).resetCreatedCategory,
        updateCategorySuccess: (0, parcelRequire("1VmcQ")).updateCategorySuccess,
        deleteCategorySuccess: (0, parcelRequire("dsFMC")).deleteCategorySuccess,
        removeCommonFlag: (0, parcelRequire("jIuZj")).removeCommonFlag
    };
});
parcelRegister("lx7EO", function(module, exports) {
    $parcel$export(module.exports, "articleDeleteSuccess", ()=>$cfa855108534d4c5$export$7e6f4a244457270c);
    const $cfa855108534d4c5$export$7e6f4a244457270c = (articleId)=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                deleted: true,
                articleId: articleId
            });
        };
});
parcelRegister("heXZI", function(module, exports) {
    $parcel$export(module.exports, "createCategory", ()=>$015500bcb6a585cb$export$7ce9dbcc6d544b1);
    $parcel$export(module.exports, "handleFormInputChange", ()=>$015500bcb6a585cb$export$8e52c4bd9075cb96);
    $parcel$export(module.exports, "resetCreatedCategory", ()=>$015500bcb6a585cb$export$98485bfbe8c8269a);
    var $jcw0u;
    var $8zOmE;
    var $fPjip;
    var $j8qrr;
    var $lw2HC;
    const $015500bcb6a585cb$export$7ce9dbcc6d544b1 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
            const { formValues: formValues } = {
                ...getState().createCategoryData
            };
            setState({
                ...getState(),
                createCategoryData: {
                    ...getState().createCategoryData,
                    isSubmitting: true
                }
            });
            try {
                const category = await (0, (0, parcelRequire("j8qrr")).createCategory)(projectId, formValues, activationId);
                setState({
                    ...getState(),
                    categoriesData: {
                        ...getState().categoriesData,
                        categories: [
                            ...getState().categoriesData.categories,
                            category
                        ]
                    },
                    createCategoryData: {
                        ...(0, (0, parcelRequire("lw2HC")).initialCreateCategoryData),
                        createdCategory: category
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'categoryCreate success');
            } catch (error) {
                const { fieldErrors: fieldErrors, formError: formError } = (0, (0, parcelRequire("fPjip")).toErrors)(error);
                setState({
                    ...getState(),
                    createCategoryData: {
                        ...getState().createCategoryData,
                        isSubmitting: false,
                        error: {
                            formError: formError,
                            fieldErrors: fieldErrors
                        }
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'categoryCreate',
                        packageName: 'jiraServicedeskKnowledgeCommon',
                        teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                    },
                    error: error
                });
            }
        };
    const $015500bcb6a585cb$export$8e52c4bd9075cb96 = (field, value)=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                createCategoryData: {
                    ...getState().createCategoryData,
                    formValues: {
                        ...getState().createCategoryData.formValues,
                        [field]: value
                    }
                }
            });
        };
    const $015500bcb6a585cb$export$98485bfbe8c8269a = ()=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                createCategoryData: {
                    ...getState().createCategoryData,
                    createdCategory: null
                }
            });
        };
});
parcelRegister("fPjip", function(module, exports) {
    $parcel$export(module.exports, "toErrors", ()=>$fdef67eb1eab7980$export$b0ccdd1765e7cb42);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("3q49N");
    parcelRequire("c66Ur");
    var $i2U8h;
    var $guSo6;
    const $fdef67eb1eab7980$var$errorKeyToMessage = {
        'jsd.apollo.error.limit.exceeded': (0, (0, parcelRequire("i2U8h")).default).categoriesLimitExceeded,
        'jsd.apollo.error.project.permission.no.view.project.permission': (0, (0, parcelRequire("i2U8h")).default).categoriesNoPermission,
        'jsd.apollo.field.error.category.name.cannot.be.blank': (0, (0, parcelRequire("i2U8h")).default).categoriesNameFieldBlank,
        'jsd.apollo.field.error.category.exceeded.name.length': (0, (0, parcelRequire("i2U8h")).default).categoriesNameFieldTooLong,
        'jsd.apollo.field.error.category.description.cannot.be.blank': (0, (0, parcelRequire("i2U8h")).default).categoriesDescriptionFieldBlank,
        'jsd.apollo.field.error.category.exceeded.description.length': (0, (0, parcelRequire("i2U8h")).default).categoriesDescriptionFieldTooLong
    };
    const $fdef67eb1eab7980$export$b0ccdd1765e7cb42 = (errorResponse)=>{
        const fieldErrorsResponse = errorResponse.fieldErrors || {};
        const fieldErrors = Object.keys(fieldErrorsResponse).reduce((acc, field)=>({
                ...acc,
                [field]: {
                    message: $fdef67eb1eab7980$var$errorKeyToMessage[fieldErrorsResponse[field].errorKey] || (0, (0, parcelRequire("i2U8h")).default).categoriesGenericMessage
                }
            }), {});
        const formError = errorResponse.errorKey ? {
            message: $fdef67eb1eab7980$var$errorKeyToMessage[errorResponse.errorKey] || (0, (0, parcelRequire("i2U8h")).default).categoriesGenericMessage
        } : undefined;
        return {
            formError: formError,
            fieldErrors: fieldErrors
        };
    };
    const $fdef67eb1eab7980$export$7ce9dbcc6d544b1 = (projectId, activationId, payload)=>(0, (0, parcelRequire("guSo6")).createCategory)(projectId, activationId, payload).catch((errorResponse)=>(0, $kVLXA.Observable).throw({
                nativeError: errorResponse,
                formattedError: $fdef67eb1eab7980$export$b0ccdd1765e7cb42(errorResponse)
            }));
    const $fdef67eb1eab7980$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload)=>(0, (0, parcelRequire("guSo6")).updateCategory)(projectId, categoryId, activationId, payload).catch((errorResponse)=>(0, $kVLXA.Observable).throw($fdef67eb1eab7980$export$b0ccdd1765e7cb42(errorResponse)));
});
parcelRegister("i2U8h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ed327d012ea36dd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6ed327d012ea36dd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        categoriesGenericMessage: {
            "id": "servicedesk-knowledge-services.categories-generic-message",
            "defaultMessage": "We couldn't create the category. Wait a moment, then try again."
        },
        categoriesNoPermission: {
            "id": "servicedesk-knowledge-services.categories-no-permission",
            "defaultMessage": "You'll need to be an agent to create a category. Ask an admin to check your permissions."
        },
        categoriesLimitExceeded: {
            "id": "servicedesk-knowledge-services.categories-limit-exceeded",
            "defaultMessage": "You have exceeded the maximum number of categories for this project. The maximum number of categories per project is 30."
        },
        categoriesNameFieldBlank: {
            "id": "servicedesk-knowledge-services.categories-name-field-blank",
            "defaultMessage": "Name cannot be blank"
        },
        categoriesDescriptionFieldBlank: {
            "id": "servicedesk-knowledge-services.categories-description-field-blank",
            "defaultMessage": "Description cannot be blank"
        },
        categoriesNameFieldTooLong: {
            "id": "servicedesk-knowledge-services.categories-name-field-too-long",
            "defaultMessage": "Name cannot be longer than 100 characters"
        },
        categoriesDescriptionFieldTooLong: {
            "id": "servicedesk-knowledge-services.categories-description-field-too-long",
            "defaultMessage": "Description cannot be longer than 150 characters"
        }
    });
});
parcelRegister("guSo6", function(module, exports) {
    $parcel$export(module.exports, "listCategories", ()=>$61a0664d6d43d351$export$db54be5b1772ef4b);
    $parcel$export(module.exports, "createCategory", ()=>$61a0664d6d43d351$export$7ce9dbcc6d544b1);
    $parcel$export(module.exports, "updateCategory", ()=>$61a0664d6d43d351$export$daaacb0271870c9);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("3q49N");
    parcelRequire("c66Ur");
    var $5OrSA;
    var $2Lj35;
    const $61a0664d6d43d351$export$db54be5b1772ef4b = (projectId, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const categoryPath = `api/project/${projectId}/category`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`);
    };
    const $61a0664d6d43d351$export$c0a90379dccf4f2f = (projectId, categoryId, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const categoryPath = `api/project/${projectId}/category/`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}`, {
            method: 'DELETE'
        });
    };
    const $61a0664d6d43d351$export$7ce9dbcc6d544b1 = (projectId, activationId, payload, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const categoryPath = `api/project/${projectId}/category`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`, {
            method: 'POST',
            body: JSON.stringify(payload)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $61a0664d6d43d351$export$ce3ba7bb235ce057 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        let body = {
            articleId: articleId,
            featured: isFeatured
        };
        body = {
            ...body,
            spaceKey: spaceKey
        };
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}/article`, {
            method: 'POST',
            body: JSON.stringify(body)
        });
    };
    const $61a0664d6d43d351$export$b6002acecf935894 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>(0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}/spaceKey/${spaceKey}/article/${articleId}`, {
            method: 'DELETE'
        });
    const $61a0664d6d43d351$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>(0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}`, {
            method: 'PUT',
            body: JSON.stringify(payload)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    const $61a0664d6d43d351$export$b9f575b5360cf530 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        let body = {
            featured: isFeatured
        };
        body = {
            ...body,
            spaceKey: spaceKey
        };
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}/article/${articleId}`, {
            method: 'PUT',
            body: JSON.stringify(body)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $61a0664d6d43d351$export$e90b3dc42a0ddf96 = ({ projectId: projectId, categories: categories, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>(0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/order`, {
            method: 'PUT',
            body: JSON.stringify(categories)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
});
parcelRegister("5OrSA", function(module, exports) {
    $parcel$export(module.exports, "fetchJson$", ()=>$f90c86f7d1f72b9b$export$2ba52855e389d39e);
    $parcel$export(module.exports, "fetchText$", ()=>$f90c86f7d1f72b9b$export$64ab95a52860b608);
    parcelRequire("3q49N");
    parcelRequire("c66Ur");
    var $561FV = parcelRequire("561FV");
    var $kVLXA = parcelRequire("kVLXA");
    var $487fd;
    var $7f4tk;
    var $7zmUm;
    const $f90c86f7d1f72b9b$var$buildErrorResponse = (message, statusCode, traceId)=>({
            response: {
                errors: [
                    {
                        errorMessage: message
                    }
                ],
                reasonKey: 'generic.error',
                reasonCode: `${statusCode}`
            },
            statusCode: statusCode,
            traceId: traceId
        });
    const $f90c86f7d1f72b9b$var$toAnError = (error)=>{
        const traceId = error.traceId;
        try {
            const response = JSON.parse(error.message);
            if ((0, ($parcel$interopDefault($561FV)))(response, 'message') && (0, ($parcel$interopDefault($561FV)))(response, 'status-code')) return $f90c86f7d1f72b9b$var$buildErrorResponse(response.message, parseInt(response['status-code'], 10), traceId);
            return {
                response: response,
                statusCode: error.statusCode,
                traceId: traceId
            };
        } catch (e) {
            return $f90c86f7d1f72b9b$var$buildErrorResponse(error.message, error.statusCode, traceId);
        }
    };
    const $f90c86f7d1f72b9b$export$6d71b655afe1638d = (url, opts)=>(0, (0, parcelRequire("7f4tk")).default)(url, opts).catch((error)=>Promise.reject($f90c86f7d1f72b9b$var$toAnError(error)));
    const $f90c86f7d1f72b9b$export$2ba52855e389d39e = (url, opts)=>(0, (0, parcelRequire("487fd")).default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));
    const $f90c86f7d1f72b9b$export$64ab95a52860b608 = (url, opts)=>(0, (0, parcelRequire("7zmUm")).default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));
});
parcelRegister("487fd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96196282ac54fa24$export$2e2bcd8739ae039);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("1oQta");
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    var $aDvGo;
    var $x9xyg;
    var $fnyT4;
    var $jJZqs;
    var $8KpGl;
    var $51xpa;
    const $96196282ac54fa24$var$noContentStatus = 204;
    const $96196282ac54fa24$var$transformUrl = (url)=>{
        const lUrl = url.replace(/\//g, '_');
        const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
        return resUrl;
    };
    function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
        const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
        let key;
        const isPerformanceCheckEnabled = !!perf;
        if (isPerformanceCheckEnabled) {
            const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
            key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
            (0, (0, parcelRequire("x9xyg")).setMark)(`BEGIN_${key}`);
        }
        return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, (0, parcelRequire("aDvGo")).default), opts), (0, (0, parcelRequire("51xpa")).makeObservabilityHeaders)(url)))).mergeMap((response)=>{
            if (isPerformanceCheckEnabled) (0, (0, parcelRequire("x9xyg")).setMark)(`END_${key}`);
            if (!response.ok) {
                const { status: status } = response;
                return response.text().then((str)=>{
                    const traceId = response.headers.get((0, (0, parcelRequire("fnyT4")).TRACE_ID_HEADER));
                    if (traceId != null && traceId !== '') throw new (0, (0, parcelRequire("jJZqs")).default)(status, str, traceId);
                    else throw new (0, (0, parcelRequire("jJZqs")).default)(status, str);
                });
            }
            if (typeof headersProcessor === 'function') headersProcessor(response.headers);
            if (response.status === $96196282ac54fa24$var$noContentStatus) return (0, $kVLXA.Observable).of(null);
            return response.json();
        });
    }
    var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;
});
parcelRegister("7zmUm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$198ed207dec01cca$export$2e2bcd8739ae039);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    var $aDvGo;
    var $fnyT4;
    var $jJZqs;
    var $8KpGl;
    var $51xpa;
    const $198ed207dec01cca$var$noContentStatus = 204;
    var $198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, (0, parcelRequire("aDvGo")).default), options), (0, (0, parcelRequire("51xpa")).makeObservabilityHeaders)(url)))).mergeMap((response)=>{
            if (!response.ok) {
                const { status: status } = response;
                const traceId = response.headers.get((0, (0, parcelRequire("fnyT4")).TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, (0, parcelRequire("jJZqs")).default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
                else throw new (0, (0, parcelRequire("jJZqs")).default)(status);
            }
            if (response.status === $198ed207dec01cca$var$noContentStatus) return (0, $kVLXA.Observable).of(null);
            return (0, $kVLXA.Observable).of(response.responseText || 'OK');
        });
});
parcelRegister("2Lj35", function(module, exports) {
    $parcel$export(module.exports, "categoryGuidToString", ()=>$6a4fff955a10b2dc$export$43162cfd3260b2fe);
    $parcel$export(module.exports, "toCategoryGuid", ()=>$6a4fff955a10b2dc$export$be5c80c4ad1faf99);
    const $6a4fff955a10b2dc$export$804bcd2704a6d077 = (appLinkId)=>appLinkId;
    const $6a4fff955a10b2dc$export$43162cfd3260b2fe = (guid)=>guid;
    const $6a4fff955a10b2dc$export$be5c80c4ad1faf99 = (guid)=>guid;
});
const $45c806b56a43da0e$export$8ce6d23ffa1a190a = '/jsd-apollo';
const $45c806b56a43da0e$export$f224912d4ec4705e = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $d7e8e0de2b5415e5$export$d42203c46ecda0b5 = 'ncs';
const $d7e8e0de2b5415e5$export$22ba648868203514 = 'synchrony';
const $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c = 'JSM';
const $d7e8e0de2b5415e5$export$a40257481ddef37e = 'atlassianAccount';
const $d7e8e0de2b5415e5$export$d57b6b390e78d90f = 'jsm-nebula';
const $d7e8e0de2b5415e5$export$85314a8fbb8155e1 = 'MONTHLY';
const $d7e8e0de2b5415e5$export$d1eb58f682ad65ad = 'ANNUAL';
const $d7e8e0de2b5415e5$export$1635bbf8efc1cbc4 = 'INACTIVE';
parcelRegister("j8qrr", function(module, exports) {
    $parcel$export(module.exports, "createCategory", ()=>$50b96e14ac428fad$export$7ce9dbcc6d544b1);
    var $7f4tk;
    const $50b96e14ac428fad$export$f0b37505cff627e3 = (projectId, activationId)=>`${0, $45c806b56a43da0e$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
    const $50b96e14ac428fad$export$7ce9dbcc6d544b1 = (projectId, payload, activationId)=>{
        const url = $50b96e14ac428fad$export$f0b37505cff627e3(projectId, activationId);
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };
});
parcelRegister("dsFMC", function(module, exports) {
    $parcel$export(module.exports, "deleteCategorySuccess", ()=>$3c95377777bb5342$export$aa2eaa46022bd60b);
    const $3c95377777bb5342$export$aa2eaa46022bd60b = (categoryId)=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: [
                        ...getState().categoriesData.categories.filter((category)=>category.id !== categoryId)
                    ]
                }
            });
        };
});
parcelRegister("aInVL", function(module, exports) {
    $parcel$export(module.exports, "publishSuccess", ()=>$7490ef4194dfdc47$export$a435a3808fe5155f);
    const $7490ef4194dfdc47$export$a435a3808fe5155f = ({ articleId: articleId, draftShareId: draftShareId, spaceKey: spaceKey })=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                published: true,
                articleId: articleId,
                draftShareId: draftShareId,
                spaceKey: spaceKey
            });
        };
});
parcelRegister("3twc2", function(module, exports) {
    $parcel$export(module.exports, "savedSuccess", ()=>$7e5a4ff1e4d62f76$export$2bf589c797fe6b4f);
    const $7e5a4ff1e4d62f76$export$2bf589c797fe6b4f = ({ articleId: articleId, draftShareId: draftShareId })=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                closed: true,
                articleId: articleId,
                draftShareId: draftShareId
            });
        };
});
parcelRegister("klUDT", function(module, exports) {
    $parcel$export(module.exports, "fetchCategories", ()=>$1022d05f23af34ff$export$416ec9f5729de215);
    var $jcw0u;
    var $8zOmE;
    var $1d66W;
    const $1022d05f23af34ff$export$416ec9f5729de215 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
            const initialState = {
                ...getState()
            };
            setState({
                ...getState(),
                categoriesData: {
                    ...initialState.categoriesData,
                    isLoading: true
                }
            });
            try {
                const { categories: categories, categoriesSupported: categoriesSupported } = await (0, (0, parcelRequire("1d66W")).fetchCategories)(projectId, activationId);
                setState({
                    ...getState(),
                    categoriesData: {
                        categories: categories,
                        isCategoriesSupported: categoriesSupported,
                        isLoading: false,
                        error: null
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'onFetchCategories success', {
                    projectId: projectId
                });
            } catch (error) {
                setState({
                    ...getState(),
                    categoriesData: {
                        ...initialState.categoriesData,
                        isLoading: false,
                        error: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'onFetchCategoriesFailure',
                        packageName: 'jiraServicedeskKnowledgeCommon',
                        teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                    },
                    error: error
                });
            }
        };
});
parcelRegister("1d66W", function(module, exports) {
    $parcel$export(module.exports, "fetchCategories", ()=>$b7d9de4ee333d2ce$export$416ec9f5729de215);
    var $7f4tk;
    const $b7d9de4ee333d2ce$export$5cf4b2ebebe43941 = (projectId, activationId)=>`${0, $45c806b56a43da0e$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
    const $b7d9de4ee333d2ce$export$416ec9f5729de215 = (projectId, activationId)=>{
        const url = $b7d9de4ee333d2ce$export$5cf4b2ebebe43941(projectId, activationId);
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'GET'
        });
    };
});
parcelRegister("2tTYZ", function(module, exports) {
    $parcel$export(module.exports, "fetchCreateArticlePermission", ()=>$ac71c34762d51de0$export$c5bf032e1fb1ad18);
    var $8zOmE;
    var $cVUDi;
    var $5ukFp;
    const $ac71c34762d51de0$var$EVENT_NAME = 'createPermissionsForSpace';
    const $ac71c34762d51de0$export$c5bf032e1fb1ad18 = ({ cloudId: cloudId, spaceKeys: spaceKeys, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState })=>{
            const initialState = {
                ...getState()
            };
            setState({
                ...initialState,
                spacesPermitted: {
                    ...initialState.spacesPermitted,
                    isLoading: true
                }
            });
            try {
                const { promotedSpaces: promotedSpaces } = await (0, (0, parcelRequire("5ukFp")).getCreatePermissionsForSpace)(cloudId, spaceKeys);
                const permittedSpaces = promotedSpaces.spaces.map(({ id: id, text: text })=>({
                        spaceKey: id,
                        spaceName: text
                    }));
                setState({
                    ...initialState,
                    spacesPermitted: {
                        ...initialState.spacesPermitted,
                        isLoading: false,
                        data: permittedSpaces,
                        totalSize: promotedSpaces.spaces.length
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `${$ac71c34762d51de0$var$EVENT_NAME} succedded`);
            } catch (error) {
                setState({
                    ...initialState,
                    spacesPermitted: {
                        ...initialState.spacesPermitted,
                        isLoading: false,
                        error: error
                    }
                });
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, 'createSpacePermissions', 'knowledgeCommon');
            }
        };
});
parcelRegister("cVUDi", function(module, exports) {
    $parcel$export(module.exports, "fireErrorAnalyticsEvents", ()=>$9d8927ca77b8220f$export$b84e314c48e09c44);
    $parcel$export(module.exports, "getPageOnDelete", ()=>$9d8927ca77b8220f$export$99689dbe56145ad5);
    $parcel$export(module.exports, "fireCustomErrorAnalytics", ()=>$9d8927ca77b8220f$export$3d13cbe76aeaf5e8);
    $parcel$export(module.exports, "getViewArticleUrl", ()=>$9d8927ca77b8220f$export$4b1de73aa951498c);
    $parcel$export(module.exports, "getAllDraftsUrl", ()=>$9d8927ca77b8220f$export$939c0821a1193768);
    $parcel$export(module.exports, "getAllArticlesUrl", ()=>$9d8927ca77b8220f$export$240e98bbb8304c52);
    $parcel$export(module.exports, "getFlag", ()=>$9d8927ca77b8220f$export$a19b74191e00c5e);
    $parcel$export(module.exports, "getCommonFlagData", ()=>$9d8927ca77b8220f$export$f44d45dc3db56277);
    $parcel$export(module.exports, "filterSupportedBillingPeriod", ()=>$9d8927ca77b8220f$export$9f13ed259dc4b1bf);
    $parcel$export(module.exports, "formatTrialEndDate", ()=>$9d8927ca77b8220f$export$da56c66ce2766e02);
    var $jcw0u;
    var $jJZqs;
    var $8zOmE;
    var $fyKAM;
    const $9d8927ca77b8220f$var$TEAM_NAME = 'jsm-nebula';
    const $9d8927ca77b8220f$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
    const $9d8927ca77b8220f$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
    const $9d8927ca77b8220f$export$53ee51427129200c = (statusCode)=>$9d8927ca77b8220f$export$1a5a4674dd906e7e(statusCode) || $9d8927ca77b8220f$export$d31fd506ce75fa65(statusCode);
    const $9d8927ca77b8220f$export$b84e314c48e09c44 = (error, id, packageName, attributes)=>{
        if (error && typeof error.statusCode === 'number') {
            const { statusCode: statusCode } = error;
            const lowPriorityError = statusCode >= 400 && statusCode < 500;
            const errorMetaId = lowPriorityError ? `${id}__4xx` : `${id}`;
            const transformedError = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? error : new (0, (0, parcelRequire("jJZqs")).default)(statusCode);
            const errorObj = {
                error: transformedError,
                meta: {
                    id: errorMetaId,
                    packageName: packageName,
                    teamName: $9d8927ca77b8220f$var$TEAM_NAME
                },
                ...attributes && {
                    attributes: attributes
                }
            };
            (0, (0, parcelRequire("jcw0u")).default)(errorObj);
        } else (0, (0, parcelRequire("jcw0u")).default)({
            error: error instanceof Error ? error : new Error(JSON.stringify(error)),
            meta: {
                id: `${id}__JS_ERROR`,
                packageName: packageName,
                teamName: $9d8927ca77b8220f$var$TEAM_NAME
            },
            ...attributes && {
                attributes: attributes
            }
        });
    };
    const $9d8927ca77b8220f$export$99689dbe56145ad5 = (currentPage, updateDataSize, perPage)=>{
        const lastPage = Math.ceil(updateDataSize / perPage);
        return currentPage > lastPage ? lastPage : currentPage;
    };
    const $9d8927ca77b8220f$export$3d13cbe76aeaf5e8 = ({ error: error, event: event, id: id, packageName: packageName, attributes: attributes })=>{
        if (error && typeof error.statusCode === 'number' && !$9d8927ca77b8220f$export$53ee51427129200c(error.statusCode)) event && (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(event, id);
        $9d8927ca77b8220f$export$b84e314c48e09c44(error, id, packageName, attributes);
    };
    const $9d8927ca77b8220f$export$4b1de73aa951498c = (projectKey, contentId, spaceKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles/${contentId}?spaceKey=${spaceKey}`;
    const $9d8927ca77b8220f$export$939c0821a1193768 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/drafts`;
    const $9d8927ca77b8220f$export$240e98bbb8304c52 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles`;
    const $9d8927ca77b8220f$export$a19b74191e00c5e = (title, description, flagType)=>({
            title: title,
            description: description,
            id: (0, (0, parcelRequire("fyKAM")).generateNanoId)(),
            flagType: flagType
        });
    const $9d8927ca77b8220f$export$a6125e21263de883 = (state)=>{
        const { draftShareId: draftShareId, articleId: articleId, published: published, closed: closed, deleted: deleted } = state;
        const isDraftPublished = Boolean(draftShareId && articleId && published && !closed);
        const isArticleSavedWithUnpublishedChanges = Boolean(!draftShareId && articleId && !published && closed);
        const isDraftSavedWithUnpublishedChanges = Boolean(draftShareId && articleId && closed && !published);
        const isArticleDeleted = Boolean(articleId && deleted);
        return {
            isDraftPublished: isDraftPublished,
            isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges,
            isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges,
            isArticleDeleted: isArticleDeleted
        };
    };
    const $9d8927ca77b8220f$export$f44d45dc3db56277 = (state, messages)=>{
        let flag = {
            id: '',
            title: {
                id: '',
                defaultMessage: '',
                description: ''
            },
            description: {
                id: '',
                defaultMessage: '',
                description: ''
            },
            type: (0, $3026c2757a468eb7$export$f215947b3d76a6b7)
        };
        const { showConfluenceCreatePageError: showConfluenceCreatePageError } = state;
        if (showConfluenceCreatePageError) {
            flag = {
                id: 'draftErrorFlag',
                title: messages.confluenceCreatePageFailureTitle,
                description: messages.confluenceCreatePageFailureDescription,
                type: (0, $3026c2757a468eb7$export$f215947b3d76a6b7)
            };
            return flag;
        }
        const { isDraftPublished: isDraftPublished, isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges, isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges, isArticleDeleted: isArticleDeleted } = $9d8927ca77b8220f$export$a6125e21263de883(state);
        if (isDraftPublished) flag = {
            id: 'draftPublishedFlag',
            title: messages.draftSuccessFlagTitle,
            description: messages.draftSuccessFlagDescription,
            type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
        };
        if (isDraftSavedWithUnpublishedChanges) flag = {
            id: 'draftSavedFlag',
            title: messages.draftSuccessSavedFlagTitle,
            description: messages.draftSuccessSavedFlagDescription || '',
            type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
        };
        if (isArticleSavedWithUnpublishedChanges) flag = {
            id: 'draftPublishedFlag',
            title: messages.articleSuccessSavedFlagTitle,
            description: messages.articleSuccessSavedFlagDescription,
            type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
        };
        if (isArticleDeleted) flag = {
            id: 'articleDeletedFlag',
            title: messages.articleDeletedFlagTitle,
            description: messages.articleDeletedFlagDescription,
            type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
        };
        return flag;
    };
    const $9d8927ca77b8220f$export$9f13ed259dc4b1bf = (billingPeriod)=>{
        if (billingPeriod === (0, $d7e8e0de2b5415e5$export$85314a8fbb8155e1)) return 0, $d7e8e0de2b5415e5$export$85314a8fbb8155e1;
        if (billingPeriod === (0, $d7e8e0de2b5415e5$export$d1eb58f682ad65ad)) return 0, $d7e8e0de2b5415e5$export$d1eb58f682ad65ad;
        return 0, $d7e8e0de2b5415e5$export$1635bbf8efc1cbc4;
    };
    const $9d8927ca77b8220f$export$da56c66ce2766e02 = (trialEndDate)=>{
        if (trialEndDate != null && trialEndDate !== '') return new Date(trialEndDate);
        return null;
    };
});
const $3026c2757a468eb7$export$516433e8a6db7503 = 'SUCCESS';
const $3026c2757a468eb7$export$a0a5e05447abb018 = 'WARNING';
const $3026c2757a468eb7$export$f215947b3d76a6b7 = 'ERROR';
const $3026c2757a468eb7$export$21bdd502a5302e06 = 'INFO';
parcelRegister("fyKAM", function(module, exports) {
    $parcel$export(module.exports, "generateNanoId", ()=>$ef446b866ecb6566$export$a4f5444a5996c185);
    var $9J4h7;
    const $ef446b866ecb6566$export$a4f5444a5996c185 = ()=>(0, (0, parcelRequire("9J4h7")).nanoid)(12);
    const $ef446b866ecb6566$export$e73c8bd0f20705a = ()=>(0, (0, parcelRequire("9J4h7")).nanoid)();
});
parcelRegister("9J4h7", function(module, exports) {
    $parcel$export(module.exports, "nanoid", ()=>$714ba1f43c1bc4b0$export$ac4959f4f1338dfc);
    let $714ba1f43c1bc4b0$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
    let $714ba1f43c1bc4b0$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
        let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
        let step = -~(1.6 * mask * defaultSize / alphabet.length);
        return (size = defaultSize)=>{
            let id = '';
            while(true){
                let bytes = getRandom(step);
                let j = step;
                while(j--){
                    id += alphabet[bytes[j] & mask] || '';
                    if (id.length === size) return id;
                }
            }
        };
    };
    let $714ba1f43c1bc4b0$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$714ba1f43c1bc4b0$export$a5cee9e955a615e5(alphabet, size, $714ba1f43c1bc4b0$export$4385e60b38654f68);
    let $714ba1f43c1bc4b0$export$ac4959f4f1338dfc = (size = 21)=>{
        let id = '';
        let bytes = crypto.getRandomValues(new Uint8Array(size));
        while(size--)id += (0, $11cc6b8f5f8db98c$export$2b646eea95309f00)[bytes[size] & 63];
        return id;
    };
});
const $11cc6b8f5f8db98c$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
parcelRegister("5ukFp", function(module, exports) {
    $parcel$export(module.exports, "getCreatePermissionsForSpace", ()=>$4d7a1d82dc21430a$export$a4d40fb662e5fd46);
    $parcel$export(module.exports, "getLinkedSpaces", ()=>$4d7a1d82dc21430a$export$b764c9ef97480a8e);
    var $ebyGx = parcelRequire("ebyGx");
    var $7f4tk;
    const $4d7a1d82dc21430a$export$a4d40fb662e5fd46 = (cloudId, spaceKeys)=>{
        const queryString = (0, $ebyGx.stringify)({
            promotedSpaceKey: spaceKeys,
            promotedSpacesLimit: spaceKeys.length,
            otherSpacesLimit: 0
        });
        return (0, (0, parcelRequire("7f4tk")).default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/spaces?${queryString}`);
    };
    const $4d7a1d82dc21430a$export$b764c9ef97480a8e = (projectKey)=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/servicedesk/1/servicedesk/${projectKey}/kb`);
});
parcelRegister("ik7FP", function(module, exports) {
    $parcel$export(module.exports, "fetchDraftAndNavigateToEditor", ()=>$76ec8efa1f92f234$export$e8292dc9536b9de8);
    var $dTS1V;
    var $8zOmE;
    var $cVUDi;
    var $gpe3Z;
    var $1TU0Q;
    const $76ec8efa1f92f234$var$EVENT_NAME = 'createNewConfluencePage';
    const $76ec8efa1f92f234$export$e8292dc9536b9de8 = ({ spaceKey: spaceKey, routerActions: routerActions, projectKey: projectKey, projectId: projectId, onCloseRedirectUrl: onCloseRedirectUrl = '', onPublishRedirectUrl: onPublishRedirectUrl = '', analyticsEvent: analyticsEvent, topicId: topicId, topicName: topicName })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            try {
                setState({
                    ...getState(),
                    isFetchingDraftDetails: true
                });
                const createContentParams = {
                    spaceKey: spaceKey,
                    parentProductContentContainerId: String(projectId),
                    parentProduct: (0, $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c),
                    title: topicName
                };
                const { contentId: contentId, draftShareId: draftShareId } = await (0, (0, parcelRequire("dTS1V")).createContent)(createContentParams);
                setState({
                    ...getState(),
                    articleId: contentId,
                    draftShareId: draftShareId,
                    isFetchingDraftDetails: false
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${$76ec8efa1f92f234$var$EVENT_NAME} succedded`, {
                    topicId: topicId
                });
                dispatch((0, (0, parcelRequire("1TU0Q")).setRedirectionData)({
                    onCloseRedirectUrl: onCloseRedirectUrl,
                    onPublishRedirectUrl: onPublishRedirectUrl
                }));
                dispatch((0, (0, parcelRequire("gpe3Z")).navigateCreateDraftRoute)({
                    routerActions: routerActions,
                    projectKey: projectKey,
                    topicId: topicId,
                    selectedSpaceKey: spaceKey
                }));
            } catch (error) {
                setState({
                    ...getState(),
                    isFetchingDraftDetails: false,
                    showConfluenceCreatePageError: true
                });
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, $76ec8efa1f92f234$var$EVENT_NAME, 'knowledgeCommon');
            }
        };
});
parcelRegister("dTS1V", function(module, exports) {
    $parcel$export(module.exports, "createContent", ()=>$2144a235c2b8fe30$export$41c7a4cacf5bab80);
    var $eeFBS;
    const $2144a235c2b8fe30$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS = [
        'parentProduct',
        'parentProductContentContainerId',
        'spaceKey'
    ];
    const $2144a235c2b8fe30$export$4de094b68e927f31 = 'X-Atl-EmbeddablePage-EntityIDs';
    const $2144a235c2b8fe30$export$41c7a4cacf5bab80 = async ({ spaceKey: spaceKey, parentPageId: parentPageId, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, domain: domain = '', title: title, body: body })=>{
        const payload = {
            type: 'page',
            status: 'draft',
            metadata: {
                properties: {
                    editor: {
                        value: 'v2'
                    }
                },
                frontend: {
                    embedded: true
                }
            },
            space: {
                key: spaceKey
            },
            title: title,
            body: body
        };
        if (parentPageId) payload.ancestors = [
            {
                id: parentPageId
            }
        ];
        const baseurl = domain ? `https://${domain}` : domain;
        const unlicensedAccessHeader = $2144a235c2b8fe30$var$getUnlicensedAccessHeader({
            parentProduct: parentProduct,
            parentProductContentContainerId: parentProductContentContainerId,
            spaceKey: spaceKey
        });
        let response;
        try {
            response = await fetch(`${baseurl}/wiki/rest/api/content`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    credentials: 'include',
                    ...unlicensedAccessHeader
                },
                body: JSON.stringify(payload)
            });
        } catch (e) {
            throw new Error(`Network failure ${e}`);
        }
        const responseJson = await response.json();
        if (!response.ok) throw new (0, (0, parcelRequire("eeFBS")).CreateError)(`Status: ${responseJson.statusCode} Message: ${responseJson.message}`, responseJson.statusCode);
        return {
            draftShareId: $2144a235c2b8fe30$var$getDraftShareId(responseJson),
            spaceKey: responseJson?.space?.key,
            contentId: responseJson?.id,
            status: responseJson?.status,
            subType: responseJson?.subType
        };
    };
    const $2144a235c2b8fe30$var$getDraftShareId = (data)=>(data?._links?.editui || '').match(/draftShareId=(.*?)(#|&|$)/)?.[1] || undefined;
    const $2144a235c2b8fe30$var$getUnlicensedAccessHeader = ({ parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, spaceKey: spaceKey })=>{
        const headerValue = {
            parentProduct: parentProduct,
            parentProductContentContainerId: parentProductContentContainerId,
            spaceKey: spaceKey
        };
        const isValidHeader = $2144a235c2b8fe30$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS.every((key)=>Boolean(headerValue[key]));
        return isValidHeader ? {
            [$2144a235c2b8fe30$export$4de094b68e927f31]: JSON.stringify(headerValue)
        } : undefined;
    };
});
parcelRegister("eeFBS", function(module, exports) {
    $parcel$export(module.exports, "CreateError", ()=>$5ee25365aafd3194$export$91ee1703d5a5ab8b);
    class $5ee25365aafd3194$export$91ee1703d5a5ab8b extends Error {
        constructor(message, statusCode){
            super(message);
            this.statusCode = statusCode;
        }
    }
});
parcelRegister("gpe3Z", function(module, exports) {
    $parcel$export(module.exports, "navigateCreateDraftRoute", ()=>$4f804a011e2794bb$export$4e7c7ad076f5f5fc);
    var $6udl5;
    const $4f804a011e2794bb$export$4e7c7ad076f5f5fc = ({ routerActions: routerActions, projectKey: projectKey, selectedSpaceKey: selectedSpaceKey, topicId: topicId })=>async ({ getState: getState })=>{
            const { articleId: articleId, draftShareId: draftShareId } = {
                ...getState()
            };
            const EDIT_DRAFT_ROUTE = (0, (0, parcelRequire("6udl5")).getDraftEditUrl)(projectKey, selectedSpaceKey, articleId, draftShareId, topicId);
            routerActions.push(EDIT_DRAFT_ROUTE);
        };
});
parcelRegister("6udl5", function(module, exports) {
    $parcel$export(module.exports, "getDraftEditUrl", ()=>$ed1cffe35d42c3de$export$5e8433ae3ce7c696);
    $parcel$export(module.exports, "isDraftCreatedWithNCS", ()=>$ed1cffe35d42c3de$export$fc0fa1dc4749f854);
    $parcel$export(module.exports, "findCategory", ()=>$ed1cffe35d42c3de$export$93e9d221203aed67);
    const $ed1cffe35d42c3de$export$5e8433ae3ce7c696 = (projectKey, selectedSpaceKey, articleId, draftShareId, topicId)=>{
        let draftEditUrl = `/jira/servicedesk/projects/${projectKey}/knowledge/space/${selectedSpaceKey}/articles/${articleId}/edit?draftShareId=${draftShareId}`;
        if (topicId) draftEditUrl += `&topicId=${topicId}`;
        return draftEditUrl;
    };
    const $ed1cffe35d42c3de$export$fc0fa1dc4749f854 = (collabService)=>collabService === (0, $d7e8e0de2b5415e5$export$d42203c46ecda0b5);
    const $ed1cffe35d42c3de$export$93e9d221203aed67 = (categoriesData, categoryId)=>{
        if (categoriesData.categories) return categoriesData.categories.find((category)=>category.id === categoryId);
        return undefined;
    };
});
parcelRegister("1TU0Q", function(module, exports) {
    $parcel$export(module.exports, "setRedirectionData", ()=>$35239289cee1669b$export$c026d4a8850c302d);
    $parcel$export(module.exports, "resetRedirectionData", ()=>$35239289cee1669b$export$7c6d6762f8b5b4db);
    const $35239289cee1669b$export$c026d4a8850c302d = (redirectionData)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                redirectionData: redirectionData
            });
        };
    const $35239289cee1669b$export$7c6d6762f8b5b4db = ()=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                redirectionData: {
                    onPublishRedirectUrl: '',
                    onCloseRedirectUrl: ''
                }
            });
        };
});
parcelRegister("dAXEk", function(module, exports) {
    $parcel$export(module.exports, "fetchLinkedSpaces", ()=>$1976703425aa0479$export$1999596e4ea30c16);
    var $5ukFp;
    const $1976703425aa0479$export$1999596e4ea30c16 = (projectKey)=>async ({ setState: setState, getState: getState })=>{
            const initialState = {
                ...getState()
            };
            setState({
                ...initialState,
                linkedSpaces: {
                    ...initialState.linkedSpaces,
                    isLoading: true
                }
            });
            try {
                const response = await (0, (0, parcelRequire("5ukFp")).getLinkedSpaces)(projectKey);
                const linkedSpaces = response.map(({ spaceKey: spaceKey, spaceName: spaceName })=>({
                        spaceKey: spaceKey,
                        spaceName: spaceName
                    }));
                setState({
                    ...initialState,
                    linkedSpaces: {
                        ...initialState.linkedSpaces,
                        isLoading: false,
                        data: linkedSpaces,
                        totalSize: linkedSpaces.length
                    }
                });
            } catch (error) {
                setState({
                    ...initialState,
                    linkedSpaces: {
                        ...initialState.linkedSpaces,
                        isLoading: false,
                        error: error
                    }
                });
            }
        };
});
parcelRegister("dIiIO", function(module, exports) {
    $parcel$export(module.exports, "fetchUserCapabilities", ()=>$c701340a34445280$export$d1eac56717011ed4);
    var $8zOmE;
    var $cVUDi;
    var $8FVnr;
    const $c701340a34445280$var$EVENT_NAME = 'fetchUserCapabilities';
    const $c701340a34445280$export$d1eac56717011ed4 = (projectId, activationId, analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
            const initialState = {
                ...getState()
            };
            setState({
                ...getState(),
                userCapabilities: {
                    ...initialState.userCapabilities,
                    isLoading: true
                }
            });
            try {
                const data = await (0, (0, parcelRequire("8FVnr")).fetchUserCapabilities)(projectId, activationId);
                setState({
                    ...getState(),
                    userCapabilities: {
                        ...initialState.userCapabilities,
                        isLoading: false,
                        data: data,
                        error: null
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${$c701340a34445280$var$EVENT_NAME} succeeded`);
            } catch (error) {
                setState({
                    ...getState(),
                    userCapabilities: {
                        ...initialState.userCapabilities,
                        isLoading: false,
                        error: error
                    }
                });
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, `${$c701340a34445280$var$EVENT_NAME} failed`, 'knowledgeCommon');
            }
        };
});
parcelRegister("8FVnr", function(module, exports) {
    $parcel$export(module.exports, "fetchUserCapabilities", ()=>$11ef201d32e47a4e$export$d1eac56717011ed4);
    var $7f4tk;
    const $11ef201d32e47a4e$export$d1eac56717011ed4 = (projectId, activationId)=>{
        const url = `${(0, $45c806b56a43da0e$export$f224912d4ec4705e)}/${activationId}/api/project/${projectId}/user/capabilities`;
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'GET'
        });
    };
});
parcelRegister("jIuZj", function(module, exports) {
    $parcel$export(module.exports, "removeCommonFlag", ()=>$3807c62af5ab354f$export$a2af96a4f99f3900);
    const $3807c62af5ab354f$export$a2af96a4f99f3900 = (flagId)=>async ({ getState: getState, setState: setState })=>{
            const { flags: currentFlags } = getState();
            const flags = currentFlags.filter(({ id: id })=>id !== flagId);
            setState({
                ...getState(),
                flags: flags
            });
        };
});
parcelRegister("eP4xZ", function(module, exports) {
    $parcel$export(module.exports, "reorderCategories", ()=>$d1c7d54ec7e0876f$export$32f957e287d37daa);
    var $ajpes = parcelRequire("ajpes");
    var $jcw0u;
    var $8zOmE;
    var $261Bl;
    var $1wnS6;
    const $d1c7d54ec7e0876f$export$cde74ed295a2b838 = (categories, fromIndex, toIndex)=>{
        const newCategories = [
            ...categories
        ];
        const movedItem = newCategories.splice(fromIndex, 1)[0];
        if (movedItem !== undefined) newCategories.splice(toIndex, 0, movedItem);
        return newCategories;
    };
    const $d1c7d54ec7e0876f$export$32f957e287d37daa = (projectId, fromIndex, toIndex, analyticsEvent, activationId, onReorderMismatch, onReorderFailure)=>async ({ setState: setState, getState: getState })=>{
            const categoryToBeMovedId = getState().categoriesData.categories[fromIndex].id;
            const initiallyOrderedCategories = [
                ...getState().categoriesData.categories
            ];
            const newlyOrderedCategories = $d1c7d54ec7e0876f$export$cde74ed295a2b838(getState().categoriesData.categories, fromIndex, toIndex);
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: newlyOrderedCategories
                }
            });
            try {
                const { categories: categories } = await (0, (0, parcelRequire("1wnS6")).orderCategories)({
                    projectId: projectId,
                    activationId: activationId,
                    categories: [
                        {
                            categoryId: categoryToBeMovedId,
                            order: toIndex
                        }
                    ]
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'category reordered', {
                    id: (0, (0, parcelRequire("261Bl")).categoryGuidToString)(categoryToBeMovedId)
                });
                const expectedCategoryIdOrder = newlyOrderedCategories.map((category)=>category.id);
                const actualCategoryIdOrder = categories.map((categoryResult)=>categoryResult.id);
                if (!(0, ($parcel$interopDefault($ajpes)))(expectedCategoryIdOrder, actualCategoryIdOrder)) {
                    setState({
                        ...getState(),
                        categoriesData: {
                            ...getState().categoriesData,
                            categories: categories
                        }
                    });
                    onReorderMismatch();
                }
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'reorderCategories',
                        packageName: 'jiraServicedeskKnowledgeCommon',
                        teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                    },
                    error: error
                });
                setState({
                    ...getState(),
                    categoriesData: {
                        ...getState().categoriesData,
                        categories: [
                            ...initiallyOrderedCategories
                        ]
                    }
                });
                onReorderFailure();
            }
        };
});
parcelRegister("261Bl", function(module, exports) {
    $parcel$export(module.exports, "categoryGuidToString", ()=>$21d0c574129f0705$export$43162cfd3260b2fe);
    $parcel$export(module.exports, "toCategoryGuid", ()=>$21d0c574129f0705$export$be5c80c4ad1faf99);
    const $21d0c574129f0705$export$43162cfd3260b2fe = (guid)=>guid;
    const $21d0c574129f0705$export$be5c80c4ad1faf99 = (guid)=>guid;
});
parcelRegister("1wnS6", function(module, exports) {
    $parcel$export(module.exports, "orderCategories", ()=>$56b61b6811b7fda7$export$e90b3dc42a0ddf96);
    var $7f4tk;
    const $56b61b6811b7fda7$export$e90b3dc42a0ddf96 = ({ projectId: projectId, activationId: activationId, categories: categories, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        const url = `${apolloPath}/${activationId}/api/project/${projectId}/category/order`;
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'PUT',
            body: JSON.stringify(categories)
        });
    };
});
parcelRegister("8QyFO", function(module, exports) {
    $parcel$export(module.exports, "resetDraftArticleData", ()=>$c895191ddea664b2$export$e4dbf2710e8c685d);
    const $c895191ddea664b2$export$e4dbf2710e8c685d = (resetDelete)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                draftShareId: '',
                closed: false,
                published: false,
                showConfluenceCreatePageError: false,
                spaceKey: '',
                ...resetDelete && {
                    deleted: false,
                    articleId: ''
                }
            });
        };
});
parcelRegister("1VmcQ", function(module, exports) {
    $parcel$export(module.exports, "updateCategorySuccess", ()=>$10ef8418d41dbca6$export$7d46e556893bba77);
    const $10ef8418d41dbca6$export$7d46e556893bba77 = (updatedCategory)=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: getState().categoriesData.categories.map((category)=>category.id === updatedCategory.id ? updatedCategory : category)
                }
            });
        };
});
parcelRegister("cSB1I", function(module, exports) {
    $parcel$export(module.exports, "getDraftShareId", ()=>$b10361f0e26ced23$export$f31b9480a5e4fdcf);
    $parcel$export(module.exports, "getArticleId", ()=>$b10361f0e26ced23$export$2d21c0faccc1d33f);
    $parcel$export(module.exports, "getIsFetchingDraftDetails", ()=>$b10361f0e26ced23$export$19d926b900e1c065);
    $parcel$export(module.exports, "getRedirectionData", ()=>$b10361f0e26ced23$export$fdde4bb390e025db);
    $parcel$export(module.exports, "getPermittedSpaces", ()=>$b10361f0e26ced23$export$4a419b2d3bb6a3fc);
    $parcel$export(module.exports, "getLinkedSpaces", ()=>$b10361f0e26ced23$export$b764c9ef97480a8e);
    $parcel$export(module.exports, "getUserCapabilities", ()=>$b10361f0e26ced23$export$f7db3ef62579b328);
    $parcel$export(module.exports, "getCategoriesData", ()=>$b10361f0e26ced23$export$b416461ac52d8504);
    $parcel$export(module.exports, "getCreateCategoryData", ()=>$b10361f0e26ced23$export$e0cf4a4b69bbc694);
    $parcel$export(module.exports, "getCategory", ()=>$b10361f0e26ced23$export$410364bbb673ddbc);
    $parcel$export(module.exports, "getCommonFlags", ()=>$b10361f0e26ced23$export$b94d9d28300025a9);
    $parcel$export(module.exports, "getKnowledgeCommonFlags", ()=>$b10361f0e26ced23$export$1a5b9662b382779c);
    var $cVUDi;
    var $6udl5;
    const $b10361f0e26ced23$export$c9cab98530df1a79 = ({ published: published })=>published;
    const $b10361f0e26ced23$export$f31b9480a5e4fdcf = ({ draftShareId: draftShareId })=>draftShareId;
    const $b10361f0e26ced23$export$2d21c0faccc1d33f = ({ articleId: articleId })=>articleId;
    const $b10361f0e26ced23$export$19d926b900e1c065 = ({ isFetchingDraftDetails: isFetchingDraftDetails })=>isFetchingDraftDetails;
    const $b10361f0e26ced23$export$fdde4bb390e025db = (state)=>state.redirectionData;
    const $b10361f0e26ced23$export$4a419b2d3bb6a3fc = (state)=>state.spacesPermitted;
    const $b10361f0e26ced23$export$b764c9ef97480a8e = (state)=>state.linkedSpaces;
    const $b10361f0e26ced23$export$f7db3ef62579b328 = (state)=>state.userCapabilities;
    const $b10361f0e26ced23$export$b416461ac52d8504 = (state)=>state.categoriesData;
    const $b10361f0e26ced23$export$e0cf4a4b69bbc694 = (state)=>state.createCategoryData;
    const $b10361f0e26ced23$export$410364bbb673ddbc = (state, categoryId)=>(0, (0, parcelRequire("6udl5")).findCategory)(state.categoriesData, categoryId);
    const $b10361f0e26ced23$export$b94d9d28300025a9 = ({ flags: flags })=>flags;
    const $b10361f0e26ced23$export$1a5b9662b382779c = (state, messages)=>(0, (0, parcelRequire("cVUDi")).getCommonFlagData)({
            ...state
        }, messages);
});
parcelRegister("ghVG7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$271aace1fac64940$export$2e2bcd8739ae039);
    var $8RXs9;
    var $bC2fB;
    var $gLt7z;
    var $ealBh;
    const $271aace1fac64940$var$mapStateToProps = (state)=>({
            projectKey: (0, (0, parcelRequire("gLt7z")).getProjectKey)(state),
            baseUrl: (0, (0, parcelRequire("gLt7z")).getBaseUrl)(state)
        });
    var $271aace1fac64940$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($271aace1fac64940$var$mapStateToProps, {})((0, (0, parcelRequire("8RXs9")).default)((0, (0, parcelRequire("ealBh")).default)));
});
parcelRegister("gLt7z", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$5ee05ac4f84233bf$export$f654b28f82155665);
    $parcel$export(module.exports, "getLocale", ()=>$5ee05ac4f84233bf$export$180605366c04f0cd);
    $parcel$export(module.exports, "getProjectKey", ()=>$5ee05ac4f84233bf$export$667f2a0f99c75faa);
    $parcel$export(module.exports, "getProjectId", ()=>$5ee05ac4f84233bf$export$89040d072f281f85);
    $parcel$export(module.exports, "getIsProjectSimplified", ()=>$5ee05ac4f84233bf$export$5bde43fbba6edf90);
    $parcel$export(module.exports, "getIsAdmin", ()=>$5ee05ac4f84233bf$export$7d046765d192af80);
    $parcel$export(module.exports, "getActivationId", ()=>$5ee05ac4f84233bf$export$3ad4bb31a1816ff6);
    $parcel$export(module.exports, "getCloudId", ()=>$5ee05ac4f84233bf$export$fdd2c0ba94025c3c);
    const $5ee05ac4f84233bf$export$f654b28f82155665 = (_)=>'';
    const $5ee05ac4f84233bf$export$180605366c04f0cd = (state)=>state.app.locale;
    const $5ee05ac4f84233bf$export$667f2a0f99c75faa = (state)=>state.app.projectKey;
    const $5ee05ac4f84233bf$export$89040d072f281f85 = (state)=>state.app.projectId;
    const $5ee05ac4f84233bf$export$5bde43fbba6edf90 = (state)=>state.app.isProjectSimplified;
    const $5ee05ac4f84233bf$export$7d046765d192af80 = (state)=>state.app.isAdmin;
    const $5ee05ac4f84233bf$export$3ad4bb31a1816ff6 = (state)=>state.app.activationId;
    const $5ee05ac4f84233bf$export$fdd2c0ba94025c3c = (state)=>state.app.cloudId;
});
parcelRegister("ealBh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7526018970629bef$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $jbwMx;
    class $7526018970629bef$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        renderKnowledgeBaseBreadcrumb() {
            const { children: children, baseUrl: baseUrl, projectKey: projectKey, intl: { formatMessage: formatMessage } } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
                breadcrumb: {
                    href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/knowledge`,
                    text: formatMessage((0, (0, parcelRequire("jbwMx")).default).knowledgeBase),
                    type: 'jsd-knowledge-base'
                }
            }, children);
        }
        render() {
            return this.renderKnowledgeBaseBreadcrumb();
        }
    }
});
parcelRegister("jbwMx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7699cc1a8f21589$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e7699cc1a8f21589$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        articlesPageHeader: {
            "id": "servicedesk.knowledge-hub.common.i18n.articles-page-header",
            "defaultMessage": "Articles"
        },
        knowledgeBase: {
            "id": "servicedesk.knowledge-hub.common.i18n.knowledge-base",
            "defaultMessage": "Knowledge base"
        },
        noCategoryText: {
            "id": "servicedesk.knowledge-hub.common.i18n.no-category-text",
            "defaultMessage": "Uncategorized"
        },
        editInConfluence: {
            "id": "servicedesk.knowledge-hub.common.i18n.edit-in-confluence",
            "defaultMessage": "Edit in Confluence"
        }
    });
});
parcelRegister("g26cY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a57b9e40246f918$export$2e2bcd8739ae039);
    var $8RXs9;
    var $bC2fB;
    var $gLt7z;
    var $5ZQ3w;
    const $4a57b9e40246f918$var$mapStateToProps = (state)=>({
            projectKey: (0, (0, parcelRequire("gLt7z")).getProjectKey)(state),
            baseUrl: (0, (0, parcelRequire("gLt7z")).getBaseUrl)(state)
        });
    var $4a57b9e40246f918$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)((0, (0, parcelRequire("bC2fB")).connect)($4a57b9e40246f918$var$mapStateToProps, {})((0, (0, parcelRequire("5ZQ3w")).default)));
});
parcelRegister("5ZQ3w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a35a15843ac8030$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $jTNvW;
    class $1a35a15843ac8030$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        renderKnowledgeBaseSearchBreadcrumb() {
            const { children: children, baseUrl: baseUrl, projectKey: projectKey, intl: { formatMessage: formatMessage } } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
                breadcrumb: {
                    href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/knowledge/search`,
                    text: formatMessage((0, (0, parcelRequire("jTNvW")).default).searchTitle),
                    type: 'jsd-knowledge-base-search'
                }
            }, children);
        }
        render() {
            return this.renderKnowledgeBaseSearchBreadcrumb();
        }
    }
});
parcelRegister("jTNvW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb15fc24ee6709dc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bb15fc24ee6709dc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchTitle: {
            "id": "servicedesk.knowledge-hub.common.knowledge-base-search-breadcrumb.search-title",
            "defaultMessage": "Search"
        }
    });
});
parcelRegister("esWw1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad2847558c189ceb$export$2e2bcd8739ae039);
    var $basmW = parcelRequire("basmW");
    var $cb25w;
    var $iQv12;
    var $bC2fB;
    var $gMZw6;
    var $la4EY;
    var $fCYod;
    var $gXg4u;
    var $gLt7z;
    var $3230b;
    var $ad2847558c189ceb$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))([
        (0, (0, parcelRequire("iQv12")).default)({
            onEditClicked: 'editInConfluence',
            onCopyClicked: 'copyShareUrl'
        }),
        (0, (0, parcelRequire("cb25w")).default)(),
        (0, (0, parcelRequire("bC2fB")).connect)((state, ownProps)=>({
                article: (0, (0, parcelRequire("gXg4u")).getArticle)(state, ownProps.id),
                projectKey: (0, (0, parcelRequire("gLt7z")).getProjectKey)(state),
                projectId: (0, (0, parcelRequire("gLt7z")).getProjectId)(state),
                appLinkState: (0, (0, parcelRequire("fCYod")).getAppLinkState)(state),
                activationId: (0, (0, parcelRequire("gLt7z")).getActivationId)(state)
            }), {
            onFetchArticle: (0, (0, parcelRequire("la4EY")).fetchArticle),
            onFetchAppLink: (0, (0, parcelRequire("gMZw6")).fetchAppLink)
        })
    ])((0, (0, parcelRequire("3230b")).default));
});
parcelRegister("iQv12", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$945500a9598c3ac2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gvRPW;
    const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
        const providedKeys = Object.keys(ConnectedProps).sort();
        const cachedMappedProps = {};
        const cachedConnectedProps = {};
        const getStateFromMappedProps = (mapped)=>{
            providedKeys.forEach((key, index)=>{
                const prop = mapped[index];
                if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
                cachedMappedProps[key] = prop;
                cachedConnectedProps[key] = (...attrs)=>{
                    const analyticsEvent = attrs[attrs.length - 1].clone();
                    const connectedProp = ConnectedProps[key];
                    if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                        name: connectedProp,
                        analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                    }).fire();
                    else if (typeof connectedProp === 'function') {
                        const update = connectedProp(...attrs);
                        analyticsEvent.update({
                            ...update,
                            analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                        }).fire();
                    }
                    if (typeof prop === 'function') prop(...attrs);
                };
            });
            return cachedConnectedProps;
        };
        return (WrappedComponent)=>class WithAnalytics extends (0, $5uXOq.Component) {
                static{
                    this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
                }
                render() {
                    const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                        ...this.props,
                        ...newMappedProps
                    });
                }
            };
    };
    var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;
});
parcelRegister("gMZw6", function(module, exports) {
    $parcel$export(module.exports, "FETCH_APPLINK", ()=>$ed5b7c76bdf86da2$export$da6ab0fd0c34565f);
    $parcel$export(module.exports, "fetchAppLink", ()=>$ed5b7c76bdf86da2$export$6bb78bb661cf0859);
    const $ed5b7c76bdf86da2$export$da6ab0fd0c34565f = 'state.actions.fetch-applink.FETCH_APPLINK';
    const $ed5b7c76bdf86da2$export$6bb78bb661cf0859 = ()=>({
            type: $ed5b7c76bdf86da2$export$da6ab0fd0c34565f
        });
});
parcelRegister("la4EY", function(module, exports) {
    $parcel$export(module.exports, "FETCH_ARTICLE", ()=>$fdce37e75ad78af2$export$a55f0530be417648);
    $parcel$export(module.exports, "fetchArticle", ()=>$fdce37e75ad78af2$export$b455945318d7989e);
    const $fdce37e75ad78af2$export$a55f0530be417648 = 'state.actions.fetch-article.FETCH_ARTICLE';
    const $fdce37e75ad78af2$export$b455945318d7989e = (id, articleType, accountId, createAnalyticsEvent)=>({
            type: $fdce37e75ad78af2$export$a55f0530be417648,
            payload: {
                id: id,
                articleType: articleType,
                accountId: accountId,
                createAnalyticsEvent: createAnalyticsEvent
            }
        });
});
parcelRegister("fCYod", function(module, exports) {
    $parcel$export(module.exports, "getAppLinkState", ()=>$681898a3e978aa85$export$5017a5295f2c0e75);
    $parcel$export(module.exports, "getAppLinkOrError", ()=>$681898a3e978aa85$export$f313f4d9202e0f4e);
    const $681898a3e978aa85$export$5017a5295f2c0e75 = (state)=>state.entities.appLink;
    const $681898a3e978aa85$export$7d919ca1f3c09dd = (state)=>state.entities.appLink?.appLink;
    const $681898a3e978aa85$export$56510b4953c6542b = (state)=>state.entities.appLink?.isLoaded || false;
    const $681898a3e978aa85$export$f313f4d9202e0f4e = (state)=>{
        const { isLoaded: isLoaded, error: error, appLink: appLink } = state.entities.appLink || {};
        if (isLoaded && appLink) return appLink;
        if (error) return {
            error: error
        };
        return undefined;
    };
});
parcelRegister("gXg4u", function(module, exports) {
    $parcel$export(module.exports, "getFeaturedInCategoryIds", ()=>$daacc015e0475ec6$export$413b305383a0e001);
    $parcel$export(module.exports, "getArticle", ()=>$daacc015e0475ec6$export$f8c0d0a39b0d7d4e);
    $parcel$export(module.exports, "getCategoriesForArticle", ()=>$daacc015e0475ec6$export$458f158173f65de8);
    $parcel$export(module.exports, "getCategoriesForArticleBulkUpdate", ()=>$daacc015e0475ec6$export$360e12e07ffc1cb0);
    $parcel$export(module.exports, "getArticlesByIds", ()=>$daacc015e0475ec6$export$ba941551d0dc160c);
    $parcel$export(module.exports, "getIsShowingBulkCategoryAdder", ()=>$daacc015e0475ec6$export$483e222b9f194c8a);
    $parcel$export(module.exports, "getCategoriesInBulkCategoryAdder", ()=>$daacc015e0475ec6$export$d1f02a9ddd87bcc6);
    $parcel$export(module.exports, "getSpaceKeyForArticle", ()=>$daacc015e0475ec6$export$ccf898e36d51a9bc);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $7qDUb = parcelRequire("7qDUb");
    var $5fBrW;
    const $daacc015e0475ec6$export$413b305383a0e001 = (state, articleId)=>state.entities.articles[articleId] && state.entities.articles[articleId].featuredInCategories && state.entities.articles[articleId].featuredInCategories;
    const $daacc015e0475ec6$var$getArticleCategories = (allCategories, article)=>{
        if (article.categories) {
            const categories = article.categories.map((categoryId)=>allCategories.categories.find((category)=>category.id === categoryId)).filter(Boolean);
            const featuredInCategoryIds = article.featuredInCategories || [];
            if (featuredInCategoryIds.length === 0) return categories;
            return (0, ($parcel$interopDefault($7qDUb)))(categories, (cat)=>!featuredInCategoryIds.includes(cat.id));
        }
        return undefined;
    };
    const $daacc015e0475ec6$export$f8c0d0a39b0d7d4e = (0, $dGvGJ.createSelector)((state, articleId)=>state.entities.articles[articleId], (state)=>state.entities.categories, (articleOrError, allCategories)=>{
        if (!articleOrError) return undefined;
        if ('error' in articleOrError) return articleOrError;
        const article = articleOrError;
        const categories = $daacc015e0475ec6$var$getArticleCategories(allCategories, article);
        const { categories: _, ...articleWithoutCategory } = article;
        return {
            ...articleWithoutCategory,
            categories: categories
        };
    });
    const $daacc015e0475ec6$var$getUpdatingCategoriesForArticle = (state, articleId)=>state.ui.articles[articleId] && state.ui.articles[articleId].categoryIds && state.ui.articles[articleId].categoryIds.map((id)=>(0, (0, parcelRequire("5fBrW")).getCategory)(state, id)).filter(Boolean);
    const $daacc015e0475ec6$export$458f158173f65de8 = (state, articleId)=>{
        const article = $daacc015e0475ec6$export$f8c0d0a39b0d7d4e(state, articleId);
        if (!article) return [];
        if (article.error) return [];
        return article.categories || [];
    };
    const $daacc015e0475ec6$export$360e12e07ffc1cb0 = (state, articleId)=>{
        const updatingCategories = $daacc015e0475ec6$var$getUpdatingCategoriesForArticle(state, articleId);
        if (updatingCategories) return updatingCategories;
        return $daacc015e0475ec6$export$458f158173f65de8(state, articleId);
    };
    const $daacc015e0475ec6$export$ba941551d0dc160c = (state, articleIds)=>articleIds.map((articleId)=>$daacc015e0475ec6$export$f8c0d0a39b0d7d4e(state, articleId)).filter(Boolean);
    const $daacc015e0475ec6$export$483e222b9f194c8a = (state, articleId)=>state.ui.articles[articleId] && !!state.ui.articles[articleId].isShowingBulkCategoryAdder;
    const $daacc015e0475ec6$export$d1f02a9ddd87bcc6 = (state, articleId)=>{
        if (!state.ui.articles[articleId]) return [];
        return state.ui.articles[articleId].categoriesInBulkCategoryAdder || [];
    };
    const $daacc015e0475ec6$export$ccf898e36d51a9bc = (state, articleId)=>{
        const article = $daacc015e0475ec6$export$f8c0d0a39b0d7d4e(state, articleId);
        if (!article) return '';
        if (article.spaceKey) return article.spaceKey;
        return '';
    };
});
parcelRegister("5fBrW", function(module, exports) {
    $parcel$export(module.exports, "getCategory", ()=>$45a4a0df582a0d3a$export$410364bbb673ddbc);
    $parcel$export(module.exports, "getCategoryName", ()=>$45a4a0df582a0d3a$export$67267455149572c9);
    $parcel$export(module.exports, "getAllCategories", ()=>$45a4a0df582a0d3a$export$36bfd9279b3a24b7);
    const $45a4a0df582a0d3a$export$410364bbb673ddbc = (state, id)=>state.entities.categories.categories.find((category)=>category.id === id);
    const $45a4a0df582a0d3a$export$67267455149572c9 = (state, id)=>{
        const category = $45a4a0df582a0d3a$export$410364bbb673ddbc(state, id);
        if (category) return category.name;
        return undefined;
    };
    const $45a4a0df582a0d3a$export$36bfd9279b3a24b7 = (state)=>state.entities.categories.categories;
});
parcelRegister("3230b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$828bab14d335ddc0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $h6QPt;
    var $1u3Jv;
    var $79GY5;
    var $lw2HC;
    var $l8ruj;
    var $1AZST;
    var $5Mrj8;
    var $fxVD7;
    var $8WALy;
    var $i3iLe;
    class $828bab14d335ddc0$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                projectKey: undefined,
                onEditClicked: undefined,
                onCopyClicked: undefined
            };
        }
        componentDidMount() {
            const { id: id, appLinkState: appLinkState, onFetchArticle: onFetchArticle, onFetchAppLink: onFetchAppLink, accountId: accountId, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            onFetchArticle(id, 'article', accountId, createAnalyticsEvent);
            if (!appLinkState?.isLoaded) onFetchAppLink();
        }
        componentDidUpdate(prevProps) {
            const { id: id, onFetchArticle: onFetchArticle, accountId: accountId, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (prevProps.id !== id) onFetchArticle(id, 'article', accountId, createAnalyticsEvent);
        }
        render() {
            const { article: article, appLinkState: appLinkState, onFetchArticle: _, onFetchAppLink: __, id: id, projectId: projectId, activationId: activationId, createAnalyticsEvent: createAnalyticsEvent, accountId: accountId, ...passThroughProps } = this.props;
            const showAppLinkLoading = !appLinkState?.isLoaded;
            const showSpinner = showAppLinkLoading;
            if (showSpinner) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("79GY5")).default), null);
            if (appLinkState?.error) {
                (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).markFMP();
                (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).failure({
                    force: true
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fxVD7")).default), null);
            }
            if (appLinkState?.appLink?.requireCredentials) {
                const onAuthenticate = async ()=>{
                    try {
                        await (0, (0, parcelRequire("h6QPt")).default)(appLinkState?.appLink?.authUrl || '');
                        this.props.onFetchAppLink();
                        this.props.onFetchArticle(this.props.id, 'article', accountId, createAnalyticsEvent);
                    } catch (error) {}
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Mrj8")).default), {
                    onAuthenticate: onAuthenticate,
                    showDefaultTitle: true
                });
            }
            if (article && article.error) {
                (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).markFMP();
                (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).failure({
                    force: true
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8WALy")).default), {
                    error: article.error,
                    screenName: "knowledgeArticleError",
                    attributes: {
                        isConfluenceServer: appLinkState?.appLink?.isServer ?? false
                    }
                });
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
                name: "knowledge-hub-view-article"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lw2HC")).UserCapabilitiesSubscriber), null, ({ data: data }, { fetchUserCapabilities: fetchUserCapabilities })=>{
                const { hasConfluenceLicense: hasConfluenceLicense } = data;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
                    op: fetchUserCapabilities,
                    args: [
                        projectId,
                        activationId,
                        createAnalyticsEvent({})
                    ]
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i3iLe")).default), {
                    ...passThroughProps,
                    isServer: appLinkState?.appLink?.isServer,
                    article: article,
                    onIFrameLoaded: this.onIFrameLoaded,
                    iframeLoading: this.state.iframeLoading,
                    canViewSpaceUrl: hasConfluenceLicense,
                    articleId: this.props.id
                }));
            }));
        }
        constructor(...args){
            super(...args);
            this.state = {
                iframeLoading: true
            };
            this.onIFrameLoaded = ()=>{
                this.setState({
                    iframeLoading: false
                });
            };
        }
    }
});
parcelRegister("h6QPt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c756de6db687f03$export$2e2bcd8739ae039);
    const $0c756de6db687f03$var$authenticateUsingAppLinks = (url)=>{
        if (window.oauthCallback) return null;
        const result = new Promise((resolve, reject)=>{
            let oauthWindow;
            let timer;
            let isPending = true;
            const oauthCallback = {
                success: ()=>{
                    clearInterval(timer);
                    resolve();
                    isPending = false;
                    delete window.oauthCallback;
                    oauthWindow && oauthWindow.close();
                },
                failure: ()=>{
                    clearInterval(timer);
                    reject(Error('Failed to authenticate with applinks'));
                    isPending = false;
                    delete window.oauthCallback;
                    oauthWindow && oauthWindow.close();
                }
            };
            window.oauthCallback = oauthCallback;
            oauthWindow = window.open(url, 'com_atlassian_applinks_authentication');
            timer = setInterval(()=>{
                if (oauthWindow && oauthWindow.closed && isPending) {
                    delete window.oauthCallback;
                    reject(Error('Failed to authenticate with applinks'));
                    clearInterval(timer);
                }
            }, 500);
        });
        return result;
    };
    var $0c756de6db687f03$export$2e2bcd8739ae039 = $0c756de6db687f03$var$authenticateUsingAppLinks;
});
parcelRegister("79GY5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7bdab3bb4aeae840$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    const $7bdab3bb4aeae840$var$LoadingSpinner = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($7bdab3bb4aeae840$var$SpinnerContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large",
            testId: "servicedesk-common.ui.components.page-spinner.spinner"
        }));
    var $7bdab3bb4aeae840$export$2e2bcd8739ae039 = $7bdab3bb4aeae840$var$LoadingSpinner;
    const $7bdab3bb4aeae840$var$SpinnerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154i1jfw _1bsb1osq _y3gn1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5Mrj8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d594bd1436f5525e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $6z7Gx;
    var $7PiB9;
    const $d594bd1436f5525e$var$AuthenticationPanelWithBreadcrumbsAndAnalytics = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                attributes: {
                    context: (0, (0, parcelRequire("6z7Gx")).ANALYTIC_CONTEXTS).KNOWLEDGE
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7PiB9")).default), props));
    var $d594bd1436f5525e$export$2e2bcd8739ae039 = $d594bd1436f5525e$var$AuthenticationPanelWithBreadcrumbsAndAnalytics;
});
parcelRegister("6z7Gx", function(module, exports) {
    $parcel$export(module.exports, "ANALYTIC_CONTEXTS", ()=>$c0766aa675d05766$export$ca021921d5c56515);
    $parcel$export(module.exports, "ttiRecommendedSlo", ()=>$c0766aa675d05766$export$dc391c7d81907d3a);
    $parcel$export(module.exports, "trackJsdFetchErrors", ()=>$c0766aa675d05766$export$ebdbd98df5a27905);
    var $jcw0u;
    var $a7EYT;
    const $c0766aa675d05766$export$ca021921d5c56515 = {
        AUTOMATION_SETTINGS: 'AutomationSettings',
        KNOWLEDGE: 'Knowledge',
        QUEUES: 'Queues',
        CSAT: 'Csat'
    };
    const $c0766aa675d05766$export$cca3c4e11cb0a5ce = 1000;
    const $c0766aa675d05766$export$dc391c7d81907d3a = 4000;
    const $c0766aa675d05766$export$ebdbd98df5a27905 = async (payload)=>{
        const { error: error, attributes: attributes } = payload;
        if (error instanceof (0, (0, parcelRequire("a7EYT")).JsdFetchError)) {
            const { reasonKey: reasonKey } = error;
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                ...payload,
                attributes: {
                    ...attributes,
                    reasonKey: reasonKey
                }
            });
            return;
        }
        (0, (0, parcelRequire("jcw0u")).trackFetchErrors)(payload);
    };
});
parcelRegister("a7EYT", function(module, exports) {
    $parcel$export(module.exports, "JsdFetchError", ()=>$99def0fa5fc488a1$export$fee0012ae6cb3438);
    $parcel$export(module.exports, "performGetRequest", ()=>$99def0fa5fc488a1$export$4a53ae1be8ec80c7);
    $parcel$export(module.exports, "performPutRequest", ()=>$99def0fa5fc488a1$export$9ead1f9103e6de6b);
    $parcel$export(module.exports, "performPostRequest", ()=>$99def0fa5fc488a1$export$692a4d9808143175);
    $parcel$export(module.exports, "performDeleteRequest", ()=>$99def0fa5fc488a1$export$8ef51cba9d28f819);
    var $gccSB = parcelRequire("gccSB");
    var $cjFoH = parcelRequire("cjFoH");
    var $aDvGo;
    var $fnyT4;
    var $jJZqs;
    var $eusud;
    const $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY = 'validation.error';
    class $99def0fa5fc488a1$export$fee0012ae6cb3438 extends (0, (0, parcelRequire("jJZqs")).default) {
        constructor(statusCode, message, reasonKey, response){
            super(statusCode, (0, ($parcel$interopDefault($gccSB)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
            this.name = 'JsdFetchError';
            if (!(0, ($parcel$interopDefault($cjFoH)))(reasonKey)) this.reasonKey = reasonKey;
            if (!(0, ($parcel$interopDefault($cjFoH)))(response)) this.response = response;
        }
    }
    const $99def0fa5fc488a1$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
            messages.push(errorMessage);
            return messages;
        }, []).join(' ');
    const $99def0fa5fc488a1$var$putOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PUT'
    };
    const $99def0fa5fc488a1$var$postOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'POST'
    };
    const $99def0fa5fc488a1$var$deleteOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'DELETE'
    };
    const $99def0fa5fc488a1$var$patchOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PATCH'
    };
    const $99def0fa5fc488a1$var$processResponse = async (response)=>{
        if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status) {
            const jsonResponse = await response.json();
            const { errors: errors, reasonKey: reasonKey } = jsonResponse;
            if (reasonKey === $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY) throw (0, (0, parcelRequire("eusud")).transformValidationErrorFromServer)(jsonResponse);
            const message = $99def0fa5fc488a1$var$transformMessageErrorsFromServer(errors);
            throw new $99def0fa5fc488a1$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
        }
        if (!response.ok) {
            const traceId = response.headers.get((0, (0, parcelRequire("fnyT4")).TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`, traceId);
            else throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`);
        }
        if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
        return response.text().then((text)=>text ? JSON.parse(text) : null);
    };
    const $99def0fa5fc488a1$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
    const $99def0fa5fc488a1$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
            ...$99def0fa5fc488a1$var$putOptions,
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
    const $99def0fa5fc488a1$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
            ...$99def0fa5fc488a1$var$postOptions,
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
    const $99def0fa5fc488a1$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
            ...$99def0fa5fc488a1$var$deleteOptions,
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
    const $99def0fa5fc488a1$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
            ...$99def0fa5fc488a1$var$patchOptions,
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;
parcelRegister("7PiB9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$773127266287e63c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bJcWY;
    var $aZdfU;
    var $6geWD;
    var $OuhAr;
    const $773127266287e63c$export$5269a8ea972747c7 = ({ onAuthenticate: onAuthenticate, showDefaultTitle: showDefaultTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bJcWY")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZdfU")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6geWD")).default), {
            truncateTitle: true,
            showDefaultTitle: showDefaultTitle
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("OuhAr")).default), {
            onAuthenticate: onAuthenticate
        })));
    var $773127266287e63c$export$2e2bcd8739ae039 = $773127266287e63c$export$5269a8ea972747c7;
});
parcelRegister("bJcWY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08fe944bdcd177c2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f1WIN;
    var $itnZ9;
    var $aZdfU;
    var $ephoW;
    const $08fe944bdcd177c2$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
        const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ephoW")).GridContext));
        const { medium: medium } = (0, $5uXOq.useContext)((0, (0, parcelRequire("aZdfU")).GridColumnContext));
        const defaultColumns = medium > 0 ? medium : (0, (0, parcelRequire("f1WIN")).defaultGridColumns);
        const spacing = spacingProp ?? theme?.spacing ?? (0, (0, parcelRequire("f1WIN")).defaultSpacing);
        const columns = columnsProp ?? theme?.columns ?? defaultColumns;
        const isNested = theme?.isNestedGrid ?? !isRoot;
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                isRoot: false,
                isNested: isNested,
                spacing: spacing,
                columns: columns
            }), [
            spacing,
            columns,
            isNested
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ephoW")).GridContext).Provider, {
            value: contextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("itnZ9")).Grid), {
            layout: layout,
            testId: testId
        }, children));
    };
    var $08fe944bdcd177c2$export$2e2bcd8739ae039 = $08fe944bdcd177c2$var$GridWrapper;
});
parcelRegister("f1WIN", function(module, exports) {
    $parcel$export(module.exports, "defaultGridColumns", ()=>$196a11a7b8c2fbef$export$74797698e12f8baa);
    $parcel$export(module.exports, "defaultGridColumnWidth", ()=>$196a11a7b8c2fbef$export$b8241a1616ab1b96);
    $parcel$export(module.exports, "spacingMapping", ()=>$196a11a7b8c2fbef$export$2a89a65a43bab52d);
    $parcel$export(module.exports, "defaultSpacing", ()=>$196a11a7b8c2fbef$export$8ec7372efd74b753);
    $parcel$export(module.exports, "defaultBannerHeight", ()=>$196a11a7b8c2fbef$export$d77f83c3d17a7b8a);
    $parcel$export(module.exports, "defaultMedium", ()=>$196a11a7b8c2fbef$export$f8725d21f81f3e01);
    $parcel$export(module.exports, "defaultLayout", ()=>$196a11a7b8c2fbef$export$2303d2bd9eeff99a);
    $parcel$export(module.exports, "varColumnsNum", ()=>$196a11a7b8c2fbef$export$9ddc3632bbfb8966);
    $parcel$export(module.exports, "varColumnSpan", ()=>$196a11a7b8c2fbef$export$8b7e31f391e6e681);
    $parcel$export(module.exports, "varGridSpacing", ()=>$196a11a7b8c2fbef$export$936829b4511db3e4);
    const $196a11a7b8c2fbef$export$3aaf3a78c909ea56 = 8;
    const $196a11a7b8c2fbef$export$74797698e12f8baa = 12;
    const $196a11a7b8c2fbef$export$b8241a1616ab1b96 = $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 10;
    const $196a11a7b8c2fbef$export$2a89a65a43bab52d = {
        comfortable: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 5,
        cosy: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 2,
        compact: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 0.5
    };
    const $196a11a7b8c2fbef$export$8ec7372efd74b753 = 'cosy';
    const $196a11a7b8c2fbef$export$d77f83c3d17a7b8a = 52;
    const $196a11a7b8c2fbef$export$f8725d21f81f3e01 = 0;
    const $196a11a7b8c2fbef$export$2303d2bd9eeff99a = 'fixed';
    const $196a11a7b8c2fbef$export$9ddc3632bbfb8966 = '--ds-columns-num';
    const $196a11a7b8c2fbef$export$8b7e31f391e6e681 = '--ds-column-span';
    const $196a11a7b8c2fbef$export$936829b4511db3e4 = '--ds-grid-spacing';
});
parcelRegister("itnZ9", function(module, exports) {
    $parcel$export(module.exports, "Grid", ()=>$92e4fcbfc398e3a4$export$ef2184bd89960b14);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $f1WIN;
    var $ephoW;
    function $92e4fcbfc398e3a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $92e4fcbfc398e3a4$var$gridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        margin: '0 auto',
        padding: `0 calc(var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}) / 2)`,
        position: 'relative',
        alignItems: 'flex-start',
        flexWrap: 'wrap'
    });
    const $92e4fcbfc398e3a4$var$gridLayoutStyles = {
        fixed: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(var(${(0, (0, parcelRequire("f1WIN")).varColumnsNum)}) * ${(0, (0, parcelRequire("f1WIN")).defaultGridColumnWidth)}px)`
        }),
        fluid: {
            name: "qhxz92",
            styles: "max-width:100%"
        }
    };
    const $92e4fcbfc398e3a4$var$nestedGridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `0 calc(-1 * var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`
    });
    const $92e4fcbfc398e3a4$export$ef2184bd89960b14 = ({ layout: layout = (0, (0, parcelRequire("f1WIN")).defaultLayout), testId: testId, children: children })=>{
        const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ephoW")).GridContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $92e4fcbfc398e3a4$var$gridStyles,
                $92e4fcbfc398e3a4$var$gridLayoutStyles[layout],
                isNested && $92e4fcbfc398e3a4$var$nestedGridStyles
            ],
            style: {
                [(0, (0, parcelRequire("f1WIN")).varColumnsNum)]: columns,
                [(0, (0, parcelRequire("f1WIN")).varGridSpacing)]: `${(0, (0, parcelRequire("f1WIN")).spacingMapping)[spacing]}px`
            },
            "data-testid": testId
        }, children);
    };
});
parcelRegister("ephoW", function(module, exports) {
    $parcel$export(module.exports, "GridContext", ()=>$529bf77650fbff0f$export$11cae3e04ab99fae);
    var $5uXOq = parcelRequire("5uXOq");
    var $f1WIN;
    const $529bf77650fbff0f$export$11cae3e04ab99fae = (0, $5uXOq.createContext)({
        isRoot: true,
        isNested: false,
        spacing: (0, (0, parcelRequire("f1WIN")).defaultSpacing),
        columns: (0, (0, parcelRequire("f1WIN")).defaultGridColumns)
    });
});
parcelRegister("aZdfU", function(module, exports) {
    $parcel$export(module.exports, "GridColumnContext", ()=>$11b791725219e059$export$1229ad7112b989f5);
    $parcel$export(module.exports, "default", ()=>$11b791725219e059$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $f1WIN;
    var $ephoW;
    var $11b791725219e059$var$ColumnVariant;
    (function(ColumnVariant) {
        ColumnVariant["Auto"] = "auto";
        ColumnVariant["Bounded"] = "bounded";
        ColumnVariant["FullWidth"] = "fullWidth";
    })($11b791725219e059$var$ColumnVariant || ($11b791725219e059$var$ColumnVariant = {}));
    const $11b791725219e059$var$getVariant = ({ medium: medium, columns: columns })=>{
        if (medium === (0, (0, parcelRequire("f1WIN")).defaultMedium)) return "auto";
        else if (medium < columns) return "bounded";
        return "fullWidth";
    };
    const $11b791725219e059$var$availableWidth = '99.9999%';
    const $11b791725219e059$var$singleColumnWidth = `(${$11b791725219e059$var$availableWidth} / var(${(0, (0, parcelRequire("f1WIN")).varColumnsNum)}))`;
    const $11b791725219e059$var$gridColumnStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: `calc(${$11b791725219e059$var$singleColumnWidth} - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
        margin: `0 calc(var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}) / 2)`,
        flexGrow: 1,
        flexShrink: 0,
        wordWrap: 'break-word'
    });
    const $11b791725219e059$var$gridColumnWidthStyles = {
        ["auto"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
            flexBasis: `auto`
        }),
        ["bounded"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(${$11b791725219e059$var$singleColumnWidth} *  var(${(0, (0, parcelRequire("f1WIN")).varColumnSpan)}) - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
            flexBasis: `100%`
        }),
        ["fullWidth"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
            flexBasis: `100%`
        })
    };
    const $11b791725219e059$export$1229ad7112b989f5 = (0, $5uXOq.createContext)({
        medium: (0, (0, parcelRequire("f1WIN")).defaultMedium)
    });
    const $11b791725219e059$var$GridColumn = ({ medium: medium = (0, (0, parcelRequire("f1WIN")).defaultMedium), children: children, testId: testId })=>{
        const { columns: columns } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ephoW")).GridContext));
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                medium: medium
            }), [
            medium
        ]);
        const colSpan = Math.max(1, Math.min(medium, columns));
        const variant = $11b791725219e059$var$getVariant({
            medium: medium,
            columns: columns
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)($11b791725219e059$export$1229ad7112b989f5.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $11b791725219e059$var$gridColumnStyles,
                $11b791725219e059$var$gridColumnWidthStyles[variant]
            ],
            style: {
                [(0, (0, parcelRequire("f1WIN")).varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
            },
            "data-testid": testId
        }, children));
    };
    var $11b791725219e059$export$2e2bcd8739ae039 = $11b791725219e059$var$GridColumn;
});
parcelRegister("6geWD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$805b9f255efa1904$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jS4lj;
    var $cS37j;
    var $koVbs;
    var $jbwMx;
    function $805b9f255efa1904$export$fea23bd0b48d9710(props) {
        const { children: children, description: description, showDefaultTitle: showDefaultTitle, bottomBar: bottomBar, ...restProps } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), {
            truncateTitle: true,
            bottomBar: description ? (0, ($parcel$interopDefault($5uXOq))).createElement($805b9f255efa1904$var$Description, null, description) : bottomBar,
            breadcrumbs: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null),
            ...restProps
        }, children || (showDefaultTitle ? formatMessage((0, (0, parcelRequire("jbwMx")).default).knowledgeBase) : null));
    }
    $805b9f255efa1904$export$fea23bd0b48d9710.defaultProps = {
        actions: undefined,
        bottomBar: undefined,
        children: null,
        showDefaultTitle: true,
        description: undefined,
        onBreadcrumbClicked: undefined
    };
    var $805b9f255efa1904$export$2e2bcd8739ae039 = $805b9f255efa1904$export$fea23bd0b48d9710;
    const $805b9f255efa1904$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkmgjw _1i4q1hna",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cS37j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a15efb09f101ecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $57MwZ;
    const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57MwZ")).default), {
            ...props,
            actions: actions ? (0, ($parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
        });
    var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
    const $2a15efb09f101ecb$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("57MwZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9694e728fd1ea060$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eeGIy;
    const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;
});
parcelRegister("eeGIy", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$0c196d37a4e8266c$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$0c196d37a4e8266c$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$0c196d37a4e8266c$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$0c196d37a4e8266c$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$0c196d37a4e8266c$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$0c196d37a4e8266c$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $8CUq3;
    function $0c196d37a4e8266c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0c196d37a4e8266c$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $0c196d37a4e8266c$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $0c196d37a4e8266c$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $0c196d37a4e8266c$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $0c196d37a4e8266c$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $0c196d37a4e8266c$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $0c196d37a4e8266c$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $0c196d37a4e8266c$var$bottomBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$outerStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $0c196d37a4e8266c$var$titleStyles,
                truncateTitle && $0c196d37a4e8266c$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleWrapperStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleContainerStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$actionStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0c196d37a4e8266c$var$bottomBarStyles
        }, children);
    };
});
parcelRegister("OuhAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19f2d1dc625a92a7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $6z7Gx;
    var $8xabp;
    const $19f2d1dc625a92a7$var$AuthenticationPanelWithAnalytics = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                context: (0, (0, parcelRequire("6z7Gx")).ANALYTIC_CONTEXTS).KNOWLEDGE
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8xabp")).default), props));
    var $19f2d1dc625a92a7$export$2e2bcd8739ae039 = $19f2d1dc625a92a7$var$AuthenticationPanelWithAnalytics;
});
parcelRegister("8xabp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4394b6b9f879006e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $gs7PQ;
    var $koVbs;
    var $i9Ubb = parcelRequire("i9Ubb");
    var $13x0I;
    var $jam2I;
    const $4394b6b9f879006e$export$9277c11b36960dfe = ({ onAuthenticate: onAuthenticate })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onActionClick = ()=>{
            onAuthenticate();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("13x0I")).default), {
            imageUrl: (0, ($parcel$interopDefault($i9Ubb))),
            header: "",
            description: formatMessage((0, (0, parcelRequire("jam2I")).default).pageDescription),
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gs7PQ"))))), {
                    label: "authenticate"
                }),
                appearance: "primary",
                onClick: onActionClick
            }, formatMessage((0, (0, parcelRequire("jam2I")).default).primaryAction))
        });
    };
    var $4394b6b9f879006e$export$2e2bcd8739ae039 = $4394b6b9f879006e$export$9277c11b36960dfe;
});
parcelRegister("gs7PQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bfa556ca72f8a34c$var$_react = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $bfa556ca72f8a34c$var$_lockLocked = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("bwyQI")));
    function $bfa556ca72f8a34c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bfa556ca72f8a34c$var$LockFilledIcon = (props)=>$bfa556ca72f8a34c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
        }, props, {
            newIcon: $bfa556ca72f8a34c$var$_lockLocked.default
        }));
    $bfa556ca72f8a34c$var$LockFilledIcon.displayName = 'LockFilledIcon';
    var $bfa556ca72f8a34c$var$_default = module.exports.default = $bfa556ca72f8a34c$var$LockFilledIcon;
});
parcelRegister("bwyQI", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $863db7350f859785$var$_UNSAFE_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $863db7350f859785$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $863db7350f859785$var$LockLockedIcon = (props)=>$863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
        }, props));
    $863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
    var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;
});
parcelRegister("i9Ubb", function(module, exports) {
    module.exports = new URL("authenticate-confluence.4d07da41.svg", import.meta.url).toString();
});
parcelRegister("13x0I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13dd6aa4f4b38a0c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $hTEpF;
    var $gwIPs;
    function $13dd6aa4f4b38a0c$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement($13dd6aa4f4b38a0c$export$be92b6f5f03c0fe9, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            maxImageWidth: $13dd6aa4f4b38a0c$export$7e3df82ee760448c,
            maxImageHeight: $13dd6aa4f4b38a0c$export$ac607276a8fe9f0a,
            ...props
        }));
    }
    $13dd6aa4f4b38a0c$export$2e2bcd8739ae039.defaultProps = {
        isLoading: false,
        primaryAction: undefined,
        secondaryAction: undefined,
        tertiaryAction: undefined
    };
    const $13dd6aa4f4b38a0c$export$ac607276a8fe9f0a = (0, (0, parcelRequire("gwIPs")).gridSize) * 20.5;
    const $13dd6aa4f4b38a0c$export$7e3df82ee760448c = (0, (0, parcelRequire("gwIPs")).gridSize) * 48;
    const $13dd6aa4f4b38a0c$export$be92b6f5f03c0fe9 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ik51pl1 _bhl91wug _qci81jje",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jam2I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a812dd379bbb5f8f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a812dd379bbb5f8f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        pageDescription: {
            "id": "servicedesk.knowledge-hub.common.applink-authentication.authentication-panel.page-description",
            "defaultMessage": "Authenticate with Confluence to access articles from your linked spaces."
        },
        primaryAction: {
            "id": "servicedesk.knowledge-hub.common.applink-authentication.authentication-panel.primary-action",
            "defaultMessage": "Authenticate"
        }
    });
});
parcelRegister("fxVD7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$112a70946b83e16d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $6z7Gx;
    var $cIhXH;
    const $112a70946b83e16d$var$AppLinkErrorPanelWithAnalytics = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                attributes: {
                    context: (0, (0, parcelRequire("6z7Gx")).ANALYTIC_CONTEXTS).KNOWLEDGE
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cIhXH")).default), props));
    var $112a70946b83e16d$export$2e2bcd8739ae039 = $112a70946b83e16d$var$AppLinkErrorPanelWithAnalytics;
});
parcelRegister("cIhXH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$889aaaaf1f3263e7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $75gFv = parcelRequire("75gFv");
    var $13x0I;
    var $hW1Vu;
    const $889aaaaf1f3263e7$export$e0621c26812fcde2 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("13x0I")).default), {
            imageUrl: (0, ($parcel$interopDefault($75gFv))),
            header: formatMessage((0, (0, parcelRequire("hW1Vu")).default).applinkErrorHeader),
            description: formatMessage((0, (0, parcelRequire("hW1Vu")).default).applinkErrorMessage)
        });
    };
    var $889aaaaf1f3263e7$export$2e2bcd8739ae039 = $889aaaaf1f3263e7$export$e0621c26812fcde2;
});
parcelRegister("75gFv", function(module, exports) {
    module.exports = new URL("error.5b530682.svg", import.meta.url).toString();
});
parcelRegister("hW1Vu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbfeba0604b7d141$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fbfeba0604b7d141$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        applinkErrorHeader: {
            "id": "servicedesk.knowledge-hub.common.applink-error-panel.applink-error-header",
            "defaultMessage": "We couldn\u2019t load this article"
        },
        applinkErrorMessage: {
            "id": "servicedesk.knowledge-hub.common.applink-error-panel.applink-error-message",
            "defaultMessage": "Refresh and try again"
        }
    });
});
parcelRegister("8WALy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4715523505b99e61$export$2e2bcd8739ae039);
    var $9tOEo;
    var $6z7Gx;
    var $axsl2;
    const $4715523505b99e61$var$ErrorPageWithAnalytics = (0, (0, parcelRequire("9tOEo")).default)({
        attributes: {
            context: (0, (0, parcelRequire("6z7Gx")).ANALYTIC_CONTEXTS).KNOWLEDGE
        }
    })((0, (0, parcelRequire("axsl2")).default));
    var $4715523505b99e61$export$2e2bcd8739ae039 = $4715523505b99e61$var$ErrorPageWithAnalytics;
});
parcelRegister("9tOEo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d2220d181f8eca1$export$2e2bcd8739ae039);
    var $994MI;
    var $i4iBk;
    var $0d2220d181f8eca1$export$2e2bcd8739ae039 = (payload)=>(WrappedComponent)=>(0, (0, parcelRequire("994MI")).default)((0, (0, parcelRequire("i4iBk")).default)(payload))(WrappedComponent);
});
parcelRegister("axsl2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c66f766909105fb1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $bJcWY;
    var $aZdfU;
    var $hZHze;
    var $jS4lj;
    var $6Ndma;
    var $8RXs9;
    var $75gFv = parcelRequire("75gFv");
    var $iDMMZ;
    var $13x0I;
    var $6geWD;
    function $c66f766909105fb1$export$c120a0e80fd44ca6(props) {
        const { intl: intl, error: error, screenName: screenName, attributes: attributes } = props;
        const isKBRouteWithHorizontalNav = (0, (0, parcelRequire("6Ndma")).useIsKBRouteWithHorizontalNav)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                source: `${screenName}${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`,
                attributes: attributes ? {
                    ...attributes
                } : {}
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bJcWY")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZdfU")).default), null, !isKBRouteWithHorizontalNav && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6geWD")).default), {
            truncateTitle: true,
            breadcrumbs: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("13x0I")).default), {
            imageUrl: (0, ($parcel$interopDefault($75gFv))),
            header: intl.formatMessage(error.header),
            description: intl.formatMessage(error.message),
            primaryAction: error.ctaLink && error.ctaText ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iDMMZ")).default), {
                to: error.ctaLink || ''
            }, intl.formatMessage(error.ctaText)) : undefined
        }))));
    }
    var $c66f766909105fb1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($c66f766909105fb1$export$c120a0e80fd44ca6);
});
parcelRegister("hZHze", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69dc4a27be9f367e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $994MI;
    var $cb25w;
    var $gvRPW;
    class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.props.onMount();
        }
        render() {
            return null;
        }
    }
    const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'view-tracker'
    })((0, (0, parcelRequire("cb25w")).default)({
        onMount: (createEvent)=>createEvent({
                action: (0, (0, parcelRequire("gvRPW")).PAGE_EVENT_ACTION)
            }).fire()
    })($69dc4a27be9f367e$var$ViewTracker));
    var $69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
            onMount: (0, ($parcel$interopDefault($8Rkzz)))
        });
});
parcelRegister("6Ndma", function(module, exports) {
    $parcel$export(module.exports, "useIsKBRouteWithHorizontalNav", ()=>$76f1b69b9a6db003$export$49e43abdbfaa6622);
    var $65Ltd;
    var $jIAHH;
    var $cPiXk;
    var $3HwlS;
    var $6jY6G;
    const $76f1b69b9a6db003$export$49e43abdbfaa6622 = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const HorizontalNavComponent = (0, (0, parcelRequire("cPiXk")).useHorizontalNavComponent)();
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && route.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK) && HorizontalNavComponent === (0, (0, parcelRequire("jIAHH")).AsyncKbNav);
    };
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("iDMMZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8906b3331e8371f5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cS0Qm;
    var $dIdda = parcelRequire("dIdda");
    const $8906b3331e8371f5$var$KnowledgeHubSpaLink = (props)=>{
        const { RouterSubscriber: RouterSubscriber, to: to, children: children, innerRef: innerRef, style: style, replace: replace } = props;
        const path = to.charAt(0) === '/' ? to : `/${to}`;
        return __SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement(RouterSubscriber, null, ({ match: match })=>match && match.params && match.params.projectKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
                href: `/jira/servicedesk/projects/${match.params.projectKey}${path}`,
                replace: replace
            }, children || null) : null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS0Qm")).default), {
            to: to,
            innerRef: innerRef,
            style: style,
            replace: replace
        }, children);
    };
    $8906b3331e8371f5$var$KnowledgeHubSpaLink.defaultProps = {
        RouterSubscriber: (0, $dIdda.RouterSubscriber)
    };
    var $8906b3331e8371f5$export$2e2bcd8739ae039 = $8906b3331e8371f5$var$KnowledgeHubSpaLink;
});
parcelRegister("cS0Qm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95eb2eaf9d2a8414$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $aE1Lc = parcelRequire("aE1Lc");
    var $7bpAK = parcelRequire("7bpAK");
    var $95eb2eaf9d2a8414$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function $95eb2eaf9d2a8414$var$_objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function $95eb2eaf9d2a8414$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $95eb2eaf9d2a8414$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $95eb2eaf9d2a8414$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $95eb2eaf9d2a8414$var$isModifiedEvent = function isModifiedEvent(event) {
        return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
    };
    var $95eb2eaf9d2a8414$var$Link = function(_React$Component) {
        $95eb2eaf9d2a8414$var$_inherits(Link, _React$Component);
        function Link() {
            var _temp, _this, _ret;
            $95eb2eaf9d2a8414$var$_classCallCheck(this, Link);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $95eb2eaf9d2a8414$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
                this
            ].concat(args))), _this), _this.handleClick = function(event) {
                if (_this.props.onClick) _this.props.onClick(event);
                if (!event.defaultPrevented && event.button === 0 && !_this.props.target && !$95eb2eaf9d2a8414$var$isModifiedEvent(event)) {
                    event.preventDefault();
                    var history = _this.context.router.history;
                    var _this$props = _this.props, replace = _this$props.replace, to = _this$props.to;
                    if (replace) history.replace(to);
                    else history.push(to);
                }
            }, _temp), $95eb2eaf9d2a8414$var$_possibleConstructorReturn(_this, _ret);
        }
        Link.prototype.render = function render() {
            var _props = this.props, replace = _props.replace, to = _props.to, innerRef = _props.innerRef, props = $95eb2eaf9d2a8414$var$_objectWithoutProperties(_props, [
                "replace",
                "to",
                "innerRef"
            ]);
            (0, ($parcel$interopDefault($aE1Lc)))(this.context.router, "You should not use <Link> outside a <Router>");
            (0, ($parcel$interopDefault($aE1Lc)))(to !== undefined, 'You must specify the "to" property');
            var history = this.context.router.history;
            var location = typeof to === "string" ? (0, $7bpAK.createLocation)(to, null, null, history.location) : to;
            var href = history.createHref(location);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("a", $95eb2eaf9d2a8414$var$_extends({}, props, {
                onClick: this.handleClick,
                href: href,
                ref: innerRef
            }));
        };
        return Link;
    }((0, ($parcel$interopDefault($5uXOq))).Component);
    $95eb2eaf9d2a8414$var$Link.propTypes = {
        onClick: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func,
        target: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string,
        replace: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).bool,
        to: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).oneOfType([
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string,
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
        ]).isRequired,
        innerRef: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).oneOfType([
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).string,
            (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func
        ])
    };
    $95eb2eaf9d2a8414$var$Link.defaultProps = {
        replace: false
    };
    $95eb2eaf9d2a8414$var$Link.contextTypes = {
        router: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).shape({
            history: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).shape({
                push: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func.isRequired,
                replace: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func.isRequired,
                createHref: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).func.isRequired
            }).isRequired
        }).isRequired
    };
    var $95eb2eaf9d2a8414$export$2e2bcd8739ae039 = $95eb2eaf9d2a8414$var$Link;
});
parcelRegister("i3iLe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41c7ee176a3c4624$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $9tOEo;
    var $jzjy1;
    var $heNNl;
    var $lfTZh;
    var $bC2fB;
    var $6z7Gx;
    var $kxZPA;
    var $jkPmE;
    const $41c7ee176a3c4624$var$LazyKnowledgeHubArticleCategoryList = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("lcClb")), {
        moduleId: "./src/packages/servicedesk/knowledge-hub/src/view/knowledge-hub-article-category-list/index.tsx"
    });
    const $41c7ee176a3c4624$var$KnowledgeHubArticleCategoryListAsync = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "knowledge-hub-article-category-list",
            packageName: "@atlassian/jira-servicedesk-knowledge-hub"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "knowledge-hub-article-category-list",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($41c7ee176a3c4624$var$LazyKnowledgeHubArticleCategoryList, props)));
    const $41c7ee176a3c4624$var$LazyKnowledgeHubArticleLabelList = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("88JeF")), {
        moduleId: "./src/packages/servicedesk/knowledge-hub/src/view/knowledge-hub-article-label-list/index.tsx"
    });
    const $41c7ee176a3c4624$var$KnowledgeHubArticleLabelListAsync = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "knowledge-hub-article-label-list",
            packageName: "@atlassian/jira-servicedesk-knowledge-hub"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "knowledge-hub-article-label-list",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($41c7ee176a3c4624$var$LazyKnowledgeHubArticleLabelList, props)));
    var $41c7ee176a3c4624$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($basmW)))((0, (0, parcelRequire("9tOEo")).default)({
        attributes: {
            context: (0, (0, parcelRequire("6z7Gx")).ANALYTIC_CONTEXTS).KNOWLEDGE
        }
    }), (0, (0, parcelRequire("jzjy1")).AnalyticsSubject)('article'), (0, (0, parcelRequire("bC2fB")).connect)(()=>({
            KnowledgeHubArticleCategoryList: $41c7ee176a3c4624$var$KnowledgeHubArticleCategoryListAsync,
            KnowledgeHubArticleLabelList: $41c7ee176a3c4624$var$KnowledgeHubArticleLabelListAsync
        }), {}))((0, (0, parcelRequire("jkPmE")).default));
});
parcelRegister("jkPmE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3c9661f02a259bd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $daJ0i;
    var $fVnbM;
    var $1dJ6S;
    var $bJcWY;
    var $aZdfU;
    var $3bDjY;
    var $jKL06;
    var $hZHze;
    var $b6nbP;
    var $8RXs9;
    var $8n9Eh;
    var $3TpKp;
    var $6w1ky;
    var $1AZST;
    var $c9JME;
    var $jbwMx;
    var $6geWD;
    var $8qDpT;
    var $6y0Ij;
    class $a3c9661f02a259bd$export$f4355f2899a3af98 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onEditClicked: undefined,
                onCopyClicked: undefined
            };
        }
        getCategoryIds() {
            if (!this.props.article) return '';
            const categoryIds = this.props.article.categories?.map((category)=>category.id).join(',') || '';
            return categoryIds;
        }
        render() {
            const { intl: intl, onCopyClicked: onCopyClicked, onEditClicked: onEditClicked, KnowledgeHubArticleCategoryList: KnowledgeHubArticleCategoryList, KnowledgeHubArticleLabelList: KnowledgeHubArticleLabelList, onIFrameLoaded: onIFrameLoaded, iframeLoading: iframeLoading, isServer: isServer, projectKey: projectKey, article: article, canViewSpaceUrl: canViewSpaceUrl, spaceKey: propSpaceKey, articleId: articleId } = this.props;
            const { viewUrl: viewUrl, shareUrl: shareUrl, editUrl: editUrl, title: title, categories: categories, id: id, spaceKey: apiSpaceKey, spaceName: spaceName, spaceUrl: spaceUrl, spaceId: spaceId, categoriesSupported: categoriesSupported, isBusy: isBusy, labelState: labelState, isEditable: isEditable } = article || {};
            const isConfluenceServerArticle = isServer;
            const showConfluenceEditLink = isConfluenceServerArticle;
            const hideKnowledgeHubArticleCategoryList = categoriesSupported === false;
            const spaceKey = apiSpaceKey || propSpaceKey;
            if (!iframeLoading) (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).markFMP();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
                data: {
                    source: `knowledgeArticle${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`,
                    attributes: {
                        'Category Ids': this.getCategoryIds(),
                        source: 'KB Hub',
                        isConfluenceServer: isServer,
                        spaceId: spaceId
                    }
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$FullPageWidthContainer, null, article && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jKL06")).default), {
                embeddedProduct: "confluence"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: this.breadcrumbsRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bJcWY")).default), {
                layout: "fluid"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZdfU")).default), null, article && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6geWD")).default), {
                showDefaultTitle: false
            }, !isConfluenceServerArticle ? null : title)))), (0, ($parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$GridContainerWithStickyLastGridColumn, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bJcWY")).default), {
                layout: "fluid"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZdfU")).default), {
                medium: 8
            }, article || spaceKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !isConfluenceServerArticle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8qDpT")).ConfluenceEmbeddedViewWrapper), {
                spaceKey: spaceKey,
                pageId: articleId,
                breadcrumbsRef: this.breadcrumbsRef,
                projectKey: projectKey,
                spaceId: spaceId,
                onIFrameLoaded: onIFrameLoaded
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$StyledConfluenceArticle, {
                src: viewUrl,
                onIFrameLoaded: onIFrameLoaded
            })) : null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZdfU")).default), {
                medium: 4
            }, article && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$Aside, null, showConfluenceEditLink && (0, ($parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$AsideSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8n9Eh")).default), {
                href: editUrl,
                onClick: onEditClicked
            }, intl.formatMessage((0, (0, parcelRequire("jbwMx")).default).editInConfluence))), (0, ($parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$AsideSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                size: "small"
            }, intl.formatMessage((0, (0, parcelRequire("6y0Ij")).default).shareArticle)), (0, ($parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$StyledFieldCopyText, {
                shouldFitContainer: true,
                label: intl.formatMessage((0, (0, parcelRequire("6y0Ij")).default).shareableUrlLabel),
                tooltipLabel: intl.formatMessage((0, (0, parcelRequire("6y0Ij")).default).copyArticleUrlLabel),
                value: shareUrl,
                onCopyClick: onCopyClicked
            })), spaceName && (0, ($parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$AsideSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1dJ6S")).default), {
                size: "small"
            }, intl.formatMessage((0, (0, parcelRequire("6y0Ij")).default).belongsToThisSpace)), canViewSpaceUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$StyledSpaceInfo, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: intl.formatMessage((0, (0, parcelRequire("6y0Ij")).default).tooltipText)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                href: spaceUrl,
                target: "_blank",
                appearance: "link",
                rel: "noopener noreferrer nofollow",
                spacing: "none"
            }, spaceName))) : (0, ($parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$StyledSpaceInfo, null, spaceName)), categories && !hideKnowledgeHubArticleCategoryList && (0, ($parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$AsideSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement(KnowledgeHubArticleCategoryList, {
                articleId: id,
                currentCategories: categories,
                isUpdatingCategories: isBusy,
                isEditable: !!isEditable
            })), !isConfluenceServerArticle && labelState && (0, ($parcel$interopDefault($5uXOq))).createElement($a3c9661f02a259bd$var$AsideSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement(KnowledgeHubArticleLabelList, {
                isEditable: !!isEditable,
                labelState: labelState,
                projectKey: projectKey || '',
                articleId: id,
                spaceKey: spaceKey || ''
            }))))))), !iframeLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3TpKp")).JsmPageInteractiveEvent), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c9JME")).DraftArticleSuccessFlags), null)));
        }
        constructor(...args){
            super(...args);
            this.breadcrumbsRef = (0, $5uXOq.createRef)();
        }
    }
    var $a3c9661f02a259bd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($a3c9661f02a259bd$export$f4355f2899a3af98);
    const $a3c9661f02a259bd$var$Aside = (0, $5uXOq.forwardRef)(({ as: C = "aside", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01ejb",
                __cmplp.className
            ])
        });
    });
    const $a3c9661f02a259bd$var$AsideSection = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n3td1ejb",
                __cmplp.className
            ])
        });
    });
    const $a3c9661f02a259bd$var$FullPageWidthContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1kx0 _19pkidpf _2hwx1wug _otyridpf _18u01wug",
                __cmplp.className
            ])
        });
    });
    const $a3c9661f02a259bd$var$GridContainerWithStickyLastGridColumn = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16tz1if8 _1u0cxy5q",
                __cmplp.className
            ])
        });
    });
    const $a3c9661f02a259bd$var$StyledSpaceInfo = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qpxbi",
                __cmplp.className
            ])
        });
    });
    const $a3c9661f02a259bd$var$StyledFieldCopyText = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("b6nbP")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkr5cr",
                __cmplp.className
            ])
        });
    });
    const $a3c9661f02a259bd$var$StyledConfluenceArticle = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("6w1ky")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyrpxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jKL06", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1592c614284434f1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8wYzC;
    class $1592c614284434f1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidMount() {
            (0, (0, parcelRequire("8wYzC")).set)(this.props.embeddedProduct).catch((0, ($parcel$interopDefault($8Rkzz))));
        }
        componentWillUnmount() {
            (0, (0, parcelRequire("8wYzC")).clear)().catch((0, ($parcel$interopDefault($8Rkzz))));
        }
        render() {
            return null;
        }
    }
});
parcelRegister("8wYzC", function(module, exports) {
    $parcel$export(module.exports, "set", ()=>$49f86daa66e50eb0$export$adaa4cf7ef1b65be);
    $parcel$export(module.exports, "clear", ()=>$49f86daa66e50eb0$export$42ffd38884aecdac);
    var $6BZYo;
    var $dJl1T;
    var $g9E9n;
    const $49f86daa66e50eb0$export$7271276960377470 = 'jira.analytics.embedded-product';
    let $49f86daa66e50eb0$var$cachedResolver;
    const $49f86daa66e50eb0$export$5a1ebbbe9b82546e = ()=>{
        if ($49f86daa66e50eb0$var$cachedResolver) return $49f86daa66e50eb0$var$cachedResolver;
        const wrmKeys = [
            'wrc!jira.webresources:top-same-origin-window',
            'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
        ];
        $49f86daa66e50eb0$var$cachedResolver = (0, (0, parcelRequire("6BZYo")).loadBridge)({
            name: 'jira/analytics/embedded-product-resolver',
            wrmKeys: wrmKeys,
            shouldLogError: false
        }).then((embeddedProductResolver)=>{
            const updateValue = (embeddedProduct)=>{
                embeddedProduct ? (0, (0, parcelRequire("g9E9n")).getAnalyticsWebClient)().setEmbeddedProduct(embeddedProduct) : (0, (0, parcelRequire("g9E9n")).getAnalyticsWebClient)().clearEmbeddedProduct();
            };
            updateValue(embeddedProductResolver.get());
            embeddedProductResolver.onChange(updateValue);
            return embeddedProductResolver;
        }).catch((e)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($49f86daa66e50eb0$export$7271276960377470, 'Cannot get embedded product resolver via bridge', e);
            throw e;
        });
        return $49f86daa66e50eb0$var$cachedResolver;
    };
    const $49f86daa66e50eb0$export$adaa4cf7ef1b65be = (embeddedProduct)=>$49f86daa66e50eb0$export$5a1ebbbe9b82546e().then((resolver)=>resolver.set(embeddedProduct));
    const $49f86daa66e50eb0$export$42ffd38884aecdac = ()=>$49f86daa66e50eb0$export$5a1ebbbe9b82546e().then((resolver)=>resolver.clear());
    const $49f86daa66e50eb0$export$5428ebc594af9d04 = (value)=>{
        $49f86daa66e50eb0$var$cachedResolver = value;
    };
});
parcelRegister("b6nbP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f75a19e3ebf5c6c9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7EEmi;
    class $f75a19e3ebf5c6c9$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                className: undefined,
                shouldFitContainer: false,
                hideFieldText: false,
                onCopyClick: undefined,
                onCopyReset: undefined,
                tooltipDelay: undefined,
                remountOnChange: false,
                tooltipDisabled: false
            };
        }
        componentWillUnmount() {
            clearTimeout(this.timeoutId);
        }
        render() {
            const { id: id, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, value: value, className: className, shouldFitContainer: shouldFitContainer, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled } = this.props;
            const fieldValue = hideFieldText ? '' : value;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7EEmi")).default), {
                id: id,
                label: label,
                tooltipLabel: tooltipLabel,
                tooltipLabelPosition: tooltipLabelPosition,
                tooltipDelay: tooltipDelay,
                remountOnChange: remountOnChange,
                fieldKey: value,
                value: fieldValue,
                className: className,
                shouldFitContainer: shouldFitContainer,
                hideFieldText: hideFieldText,
                ...this.state,
                onCopyClick: this.onCopyClick,
                innerInputRef: this.onRef,
                tooltipDisabled: tooltipDisabled
            }, this.props.children);
        }
        constructor(...args){
            super(...args);
            this.state = {
                copied: false,
                copyFailed: false
            };
            this.onCopyClick = (event, analyticsEvent)=>{
                if (!this.inputTextRef || !this.inputTextRef.current) return;
                this.props.onCopyClick && this.props.onCopyClick(event, analyticsEvent);
                if (this.props.hideFieldText) this.inputTextRef.current.value = this.props.value;
                this.inputTextRef.current.select();
                let success = false;
                try {
                    success = document.execCommand('copy');
                    this.setState({
                        copied: true
                    });
                    this.props.onClickChange && this.props.onClickChange(true);
                } catch (e) {
                    success = false;
                }
                if (!success) this.setState({
                    copyFailed: true
                });
                this.timeoutId = setTimeout(()=>{
                    this.setState({
                        copied: false,
                        copyFailed: false
                    });
                    this.props.onCopyReset && this.props.onCopyReset();
                }, 3000);
                if (this.props.onCopyFinish) this.props.onCopyFinish();
            };
            this.onRef = (ref)=>{
                this.inputTextRef = ref;
            };
        }
    }
});
parcelRegister("7EEmi", function(module, exports) {
    $parcel$export(module.exports, "StyledButton", ()=>$4e1842edd397110a$export$2d5d2ba3c7c8c40b);
    $parcel$export(module.exports, "default", ()=>$4e1842edd397110a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3Fq5M;
    var $5ILhZ;
    var $8CUq3;
    var $kY99m;
    var $3bDjY;
    var $fVAPR;
    var $az4zD;
    var $gT8ZY;
    var $9iXoh;
    class $4e1842edd397110a$export$71579edc8f362e35 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                id: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
                className: undefined,
                copyFailed: false,
                shouldFitContainer: false,
                hideFieldText: false,
                tooltipDelay: 100,
                remountOnChange: false
            };
        }
        constructor(props){
            super(props);
            this.textInput = (0, $5uXOq.createRef)();
            this.props.innerInputRef(this.textInput);
        }
        renderDefaultButton() {
            const { tooltipLabel: tooltipLabel, onCopyClick: onCopyClick } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$export$2d5d2ba3c7c8c40b, {
                onClick: onCopyClick
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3Fq5M"))))), {
                color: "currentColor",
                label: tooltipLabel
            }));
        }
        render() {
            const { id: id, fieldKey: fieldKey, value: value, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, intl: intl, copied: copied, onCopyClick: onCopyClick, shouldFitContainer: shouldFitContainer, copyFailed: copyFailed, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled, ...props } = this.props;
            let actualTooltipLabel = tooltipLabel;
            if (copied) actualTooltipLabel = intl.formatMessage((0, (0, parcelRequire("gT8ZY")).default).copied);
            else if (copyFailed) actualTooltipLabel = intl.formatMessage((0, (0, parcelRequire("gT8ZY")).default).copyFailed);
            const copyButton = !this.props.children ? null : (0, $5uXOq.cloneElement)((0, $5uXOq.Children).only(this.props.children), {
                onClick: onCopyClick
            });
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9iXoh")).Root), props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9iXoh")).FieldContainer), {
                shouldFitContainer: shouldFitContainer,
                hideFieldText: hideFieldText
            }, label && !hideFieldText && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVAPR")).FieldLabel), {
                htmlFor: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
                label: label
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                "aria-hidden": hideFieldText ? 'true' : undefined,
                key: fieldKey,
                id: id,
                name: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
                label: label,
                value: value,
                isReadOnly: true,
                ref: this.textInput,
                tabIndex: hideFieldText ? -1 : undefined
            })), tooltipDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$var$FlexGrow, null, copyButton || this.renderDefaultButton()) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                tag: "span",
                key: remountOnChange ? actualTooltipLabel : undefined,
                delay: tooltipDelay,
                position: tooltipLabelPosition,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    "aria-live": "assertive"
                }, actualTooltipLabel)
            }, copyButton || this.renderDefaultButton())));
        }
    }
    var $4e1842edd397110a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($4e1842edd397110a$export$71579edc8f362e35);
    const $4e1842edd397110a$export$2d5d2ba3c7c8c40b = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ...props,
            xcss: $4e1842edd397110a$var$pressableStyles
        });
    $4e1842edd397110a$export$2d5d2ba3c7c8c40b.displayName = 'StyledButton';
    const $4e1842edd397110a$var$FlexGrow = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $4e1842edd397110a$var$pressableStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '40px',
        width: '40px',
        borderRadius: "var(--ds-border-radius, 3px)",
        ':hover': {
            background: "var(--ds-background-neutral-hovered, #091E4224)"
        },
        ':active': {
            background: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    });
});
parcelRegister("3Fq5M", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));
    var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
    function $2ab970d264bef26f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ab970d264bef26f$var$CopyIcon = (props)=>$2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
            LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
        }, props));
    $2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
    var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;
});
parcelRegister("8w53e", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $63353af41c1756be$var$_UNSAFE_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $63353af41c1756be$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63353af41c1756be$var$CopyIcon = (props)=>$63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
    var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;
});
parcelRegister("eE13R", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
    function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $aa959fe1f5a86e24$var$CopyIcon = (props)=>$aa959fe1f5a86e24$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
        }, props, {
            newIcon: $aa959fe1f5a86e24$var$_copy.default
        }));
    $aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
    var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("fVAPR", function(module, exports) {
    $parcel$export(module.exports, "FieldLabel", ()=>$97462970d1593b07$export$1acdcf5a973a8414);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $3RZIb;
    var $gwIPs;
    const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
            htmlFor: htmlFor
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$LabelText, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? (0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$RequiredIndicator, {
            role: "presentation"
        }, "*") : null));
    const $97462970d1593b07$var$Label = (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule",
                __cmplp.className
            ])
        });
    });
    const $97462970d1593b07$var$LabelText = (0, $47bDC.default).div.withConfig({
        componentId: "sc-9kgl5s-0"
    })`${(0, (0, parcelRequire("3RZIb")).h200)()} display:block;font-family:${(0, (0, parcelRequire("gwIPs")).fontFamily)};margin:0;${(0, $47bDC.css)({
        padding: `${"var(--ds-space-250, 20px)"} 0px ${"var(--ds-space-050, 4px)"} 0px`
    })}`;
    const $97462970d1593b07$var$RequiredIndicator = (0, $47bDC.default).span.withConfig({
        componentId: "sc-9kgl5s-1"
    })({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$exports).R400})`,
        fontFamily: (0, parcelRequire("gwIPs")).fontFamily,
        paddingLeft: "var(--ds-space-025, 2px)"
    });
    $97462970d1593b07$var$RequiredIndicator.displayName = 'RequiredIndicator';
});
const $68788ede79b59f1f$export$4f0520e0d7c4c7b0 = 'field-copy-text';
parcelRegister("gT8ZY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb069c8c90804ba8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fb069c8c90804ba8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copied: {
            "id": "common.field-copy-text.copied",
            "defaultMessage": "Copied!"
        },
        copyFailed: {
            "id": "common.field-copy-text.copy-failed",
            "defaultMessage": "Couldn't copy to clipboard"
        }
    });
});
parcelRegister("9iXoh", function(module, exports) {
    $parcel$export(module.exports, "Root", ()=>$d3bb6eb164541ffa$export$be92b6f5f03c0fe9);
    $parcel$export(module.exports, "FieldContainer", ()=>$d3bb6eb164541ffa$export$b5c4b0e7cd7f148b);
    var $47bDC = parcelRequire("47bDC");
    const $d3bb6eb164541ffa$export$be92b6f5f03c0fe9 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1g0si8d-0"
    })({
        display: 'flex',
        alignItems: 'flex-end'
    }, (props)=>props.hideFieldText === true ? (0, $47bDC.css)({
            userSelect: 'none'
        }) : '');
    const $d3bb6eb164541ffa$export$b5c4b0e7cd7f148b = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1g0si8d-1"
    })({
        marginRight: "var(--ds-space-100, 8px)"
    }, (props)=>props.shouldFitContainer ? (0, $47bDC.css)({
            flexGrow: 1
        }) : '', (props)=>props.hideFieldText === true ? (0, $47bDC.css)({
            position: 'absolute',
            left: '-9999px',
            height: 0,
            opacity: 0,
            pointerEvents: 'none',
            userSelect: 'none'
        }) : '');
});
parcelRegister("8n9Eh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ef60ceb7a2a29db$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $17Ngn;
    var $dC5iT;
    var $8CUq3;
    var $3bDjY;
    var $az4zD;
    var $jsotm;
    const $0ef60ceb7a2a29db$export$2c7b2957f409c48f = ({ href: href, children: children, intl: intl, onClick: onClick, appearance: appearance, spacing: spacing, showShortcutIcon: showShortcutIcon })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            tag: "span",
            content: intl.formatMessage((0, (0, parcelRequire("jsotm")).default).opensInNewWindow),
            position: "mouse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            href: href,
            appearance: appearance,
            target: "_blank",
            spacing: spacing,
            onClick: onClick,
            iconAfter: showShortcutIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $0ef60ceb7a2a29db$var$iconContainerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("17Ngn"))))), {
                size: "small",
                label: intl.formatMessage((0, (0, parcelRequire("jsotm")).default).opensInNewWindow)
            })) : undefined
        }, children));
    $0ef60ceb7a2a29db$export$2c7b2957f409c48f.defaultProps = {
        onClick: undefined,
        showShortcutIcon: true,
        appearance: 'link',
        spacing: 'none'
    };
    var $0ef60ceb7a2a29db$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($0ef60ceb7a2a29db$export$2c7b2957f409c48f);
    const $0ef60ceb7a2a29db$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.100'
    });
});
parcelRegister("jsotm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$15876084b060a35f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $15876084b060a35f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        opensInNewWindow: {
            "id": "packages-components-external-link-button.opens-in-new-window",
            "defaultMessage": "Opens in a new window"
        }
    });
});
parcelRegister("3TpKp", function(module, exports) {
    $parcel$export(module.exports, "JsmPageInteractiveEvent", ()=>$bbb7386cf97044f2$export$c4ba40c380ee9a11);
    var $5uXOq = parcelRequire("5uXOq");
    var $5rqex;
    const $bbb7386cf97044f2$export$c4ba40c380ee9a11 = (args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), args);
    $bbb7386cf97044f2$export$c4ba40c380ee9a11.defaultProps = {
        isExpectedToHaveSsr: false,
        withMarks: [],
        extra: {}
    };
    $bbb7386cf97044f2$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $aOr3t;
    var $1u4q7;
    var $co1wz;
    var $1AZST;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aOr3t")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("1u4q7")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $21pfT;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("21pfT")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1AZST;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $1u4q7;
    var $bFU4G;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $1u4q7;
    var $bFU4G;
    var $1AZST;
    var $49z18;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("49z18")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("6w1ky", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a6a1affcd2a8451$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4hHHl;
    var $9TfOG;
    class $1a6a1affcd2a8451$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                className: undefined
            };
        }
        static attachHostOffsetOverride(window1) {
            const calculateDepth = (hostWindow, offset = 0)=>{
                let hostFrameOffset = 0;
                while(hostWindow !== window1.top){
                    hostFrameOffset += 1;
                    hostWindow = hostWindow.parent;
                }
                return hostFrameOffset - offset;
            };
            const containerDepth = calculateDepth(window1);
            window1.top.getHostOffsetFunctionOverride = (hostWindow)=>calculateDepth(hostWindow, containerDepth + 1);
        }
        static detachHostOffsetOverride() {
            if (window.top && window.top.getHostOffsetFunctionOverride) delete window.top.getHostOffsetFunctionOverride;
        }
        componentDidMount() {
            $1a6a1affcd2a8451$export$2e2bcd8739ae039.attachHostOffsetOverride(window);
        }
        componentWillUnmount() {
            $1a6a1affcd2a8451$export$2e2bcd8739ae039.detachHostOffsetOverride();
        }
        render() {
            const { src: src, onIFrameLoaded: onIFrameLoaded, ...props } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($1a6a1affcd2a8451$var$Article, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9TfOG")).default), {
                title: "confluence-article-iframe",
                src: src,
                sameOriginResize: true,
                resizePoll: true,
                onIFrameLoaded: onIFrameLoaded
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hHHl")).default), {
                src: src
            }));
        }
    }
    const $1a6a1affcd2a8451$var$Article = (0, $5uXOq.forwardRef)(({ as: C = "article", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0c7mi _19pkc7mi _2hwxc7mi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4hHHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86ba579c57f80b0c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $dZw8H;
    class $86ba579c57f80b0c$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidMount() {
            window.addEventListener('message', this.onResizing);
            this.timeoutId = setTimeout(this.onEstimatedIframeReady, 500);
        }
        shouldComponentUpdate() {
            return !this.state.resizing;
        }
        componentWillUnmount() {
            clearTimeout(this.timeoutId);
            window.removeEventListener('message', this.onResizing);
        }
        render() {
            const { resizing: resizing } = this.state;
            return resizing ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null) : null;
        }
        constructor(...args){
            super(...args);
            this.state = {
                resizing: false
            };
            this.onResizing = (ev)=>{
                if (ev.data.fn === 'resize' && (0, ($parcel$interopDefault($aZsz6)))(ev.origin).hostname === (0, ($parcel$interopDefault($aZsz6)))(this.props.src).hostname) {
                    this.onEstimatedIframeReady();
                    window.removeEventListener('message', this.onResizing);
                    clearTimeout(this.timeoutId);
                }
            };
            this.onEstimatedIframeReady = ()=>{
                this.setState({
                    resizing: true
                });
            };
        }
    }
});
parcelRegister("9TfOG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c6e2013fd63a854$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $34ck9 = parcelRequire("34ck9");
    var $iALll;
    class $5c6e2013fd63a854$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                sameOriginResize: false,
                resizePoll: false,
                resizePollInterval: 500
            };
        }
        componentWillUnmount() {
            this.removeResizeListener();
            this.removeResizePolling();
        }
        render() {
            const { src: src, title: title } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iALll")).IFrame), {
                title: title,
                ref: this.setIFrameRef,
                key: src,
                src: src,
                onLoad: this.onLoaded
            });
        }
        constructor(...args){
            super(...args);
            this.onLoaded = ()=>{
                this.props.onIFrameLoaded && this.props.onIFrameLoaded();
                if (this.props.sameOriginResize && this.props.src.startsWith(window.location.origin)) {
                    this.resizeIFrameHeight();
                    this.removeResizeListener();
                    window.addEventListener('resize', this.resizeIFrameHeight);
                    this.removeResizeListener = ()=>window.removeEventListener('resize', this.resizeIFrameHeight);
                    this.removeResizePolling();
                    this.beginResizePolling();
                }
            };
            this.setIFrameRef = (ref)=>{
                this.iFrameRef = ref;
                this.resizeIFrameHeight();
                this.beginResizePolling();
            };
            this.removeResizeListener = (0, ($parcel$interopDefault($8Rkzz)));
            this.removeResizePolling = (0, ($parcel$interopDefault($8Rkzz)));
            this.beginResizePolling = ()=>{
                if (this.props.resizePoll) {
                    this.removeResizePolling();
                    const intervalId = setInterval(this.resizeIFrameHeight, this.props.resizePollInterval);
                    this.removeResizePolling = ()=>clearInterval(intervalId);
                }
            };
            this.resizeIFrameHeight = (0, ($parcel$interopDefault($34ck9)))(()=>{
                if (this.iFrameRef && this.iFrameRef.contentWindow && this.iFrameRef.contentWindow.document && this.iFrameRef.contentWindow.document.body) {
                    const iframeBody = this.iFrameRef.contentWindow.document.body;
                    this.iFrameRef.height = `${iframeBody.clientHeight}px`;
                    iframeBody.style.overflowY = 'hidden';
                }
            });
        }
    }
});
parcelRegister("iALll", function(module, exports) {
    $parcel$export(module.exports, "IFrame", ()=>$51b8681a9830dbe2$export$b32b5f1ee4493319);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $51b8681a9830dbe2$export$b32b5f1ee4493319 = (0, $5uXOq.forwardRef)(({ as: C = "iframe", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("c9JME", function(module, exports) {
    $parcel$export(module.exports, "DraftArticleSuccessFlags", ()=>$e2abc86780787baa$export$a396c03fd23667ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $9UIxp;
    var $rzE3E;
    var $6hrB4;
    const $e2abc86780787baa$export$a396c03fd23667ef = ()=>{
        const [kbCommonflags, resetDraftArticleData] = (0, (0, parcelRequire("9UIxp")).useKnowledgeCommonFlagHook)((0, (0, parcelRequire("6hrB4")).default));
        const onDismissed = ()=>{
            resetDraftArticleData(true);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("rzE3E")).KbFlags), {
            flags: kbCommonflags,
            onDismissed: onDismissed
        });
    };
});
parcelRegister("9UIxp", function(module, exports) {
    $parcel$export(module.exports, "useKnowledgeCommonFlagHook", ()=>$68535e79aa4458dd$export$71a682bd55aae872);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $lw2HC;
    const $68535e79aa4458dd$export$71a682bd55aae872 = (messages)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ id: id, type: type, title: title, description: description }, { resetDraftArticleData: resetDraftArticleData }] = (0, (0, parcelRequire("lw2HC")).useFlagData)(messages);
        const knowledgeCommonflags = id ? [
            {
                description: typeof description === 'string' ? '' : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), description),
                flagType: type,
                id: id,
                title: formatMessage(title)
            }
        ] : [];
        return [
            knowledgeCommonflags,
            resetDraftArticleData
        ];
    };
});
parcelRegister("rzE3E", function(module, exports) {
    $parcel$export(module.exports, "KbFlags", ()=>$a0b6ad285d45eb5a$export$3934d8be12f752d2);
    var $5uXOq = parcelRequire("5uXOq");
    var $dp5jO;
    var $dD7Zc;
    var $7R4eB;
    var $f2BYd;
    const $a0b6ad285d45eb5a$export$3934d8be12f752d2 = ({ flags: flags, onDismissed: onDismissed })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f2BYd")).default), {
            onDismissed: (id)=>{
                onDismissed(id);
            }
        }, flags.map(({ flagType: flagType, title: title, description: description, id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7R4eB")).default), {
                id: id,
                icon: flagType && flagType === (0, $3026c2757a468eb7$export$516433e8a6db7503) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dp5jO"))))), {
                    label: "Success",
                    color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))), {
                    label: "Error",
                    color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                }),
                key: id,
                title: title,
                description: description
            })));
    var $a0b6ad285d45eb5a$export$2e2bcd8739ae039 = $a0b6ad285d45eb5a$export$3934d8be12f752d2;
});
parcelRegister("dp5jO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9c21bc4d0ace2e1e$var$_react = $9c21bc4d0ace2e1e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9c21bc4d0ace2e1e$var$_checkCircle = $9c21bc4d0ace2e1e$var$_interopRequireDefault((parcelRequire("34OIV")));
    var $9c21bc4d0ace2e1e$var$_checkCircle2 = $9c21bc4d0ace2e1e$var$_interopRequireDefault((parcelRequire("btivG")));
    function $9c21bc4d0ace2e1e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9c21bc4d0ace2e1e$var$CheckCircleIcon = (props)=>$9c21bc4d0ace2e1e$var$_react.default.createElement($9c21bc4d0ace2e1e$var$_checkCircle.default, Object.assign({
            LEGACY_fallbackIcon: $9c21bc4d0ace2e1e$var$_checkCircle2.default
        }, props));
    $9c21bc4d0ace2e1e$var$CheckCircleIcon.Name = 'CheckCircleIconMigration';
    var $9c21bc4d0ace2e1e$var$_default = module.exports.default = $9c21bc4d0ace2e1e$var$CheckCircleIcon;
});
parcelRegister("34OIV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $23d917767cf5e6f4$var$_react = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $23d917767cf5e6f4$var$_UNSAFE_baseNew = $23d917767cf5e6f4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $23d917767cf5e6f4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $23d917767cf5e6f4$var$CheckCircleIcon = (props)=>$23d917767cf5e6f4$var$_react.default.createElement($23d917767cf5e6f4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
        }, props));
    $23d917767cf5e6f4$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
    var $23d917767cf5e6f4$var$_default = module.exports.default = $23d917767cf5e6f4$var$CheckCircleIcon;
});
parcelRegister("7R4eB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$435170f9f2349b2e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $3KRpp;
    const $435170f9f2349b2e$var$AkAutoDismissFlag = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).CommonFlag), {
            isAutoDismiss: true,
            ...props,
            flagType: "info"
        }));
    var $435170f9f2349b2e$export$2e2bcd8739ae039 = $435170f9f2349b2e$var$AkAutoDismissFlag;
});
parcelRegister("3KRpp", function(module, exports) {
    $parcel$export(module.exports, "CommonFlag", ()=>$ef767762d5402ccf$export$13d73238a031436b);
    $parcel$export(module.exports, "ErrorFlag", ()=>$ef767762d5402ccf$export$518ba8e0e60f145f);
    $parcel$export(module.exports, "ErrorAutoDismissFlag", ()=>$ef767762d5402ccf$export$3f75672bb90a4431);
    $parcel$export(module.exports, "InfoFlag", ()=>$ef767762d5402ccf$export$6a55b52e74c1e48e);
    $parcel$export(module.exports, "SuccessAutoDismissFlag", ()=>$ef767762d5402ccf$export$74a3c0748aa31355);
    $parcel$export(module.exports, "SuccessFlag", ()=>$ef767762d5402ccf$export$93bd4963a1d00fd5);
    $parcel$export(module.exports, "WarningFlag", ()=>$ef767762d5402ccf$export$23695d8281998f27);
    $parcel$export(module.exports, "FlagGroup", ()=>$ef767762d5402ccf$export$a2c3479950310d7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $kxZPA;
    const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);
    const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
    const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
    const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            ...props
        }));
    const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "info",
            ...props
        }));
    const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            ...props
        }));
    const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "warning",
            ...props
        }));
    const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));
});
parcelRegister("lKKug", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4yB9l")
    ]).then(()=>parcelRequire('8ZHDV'));
});
parcelRegister("fhw5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));
});
parcelRegister("f2BYd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3780c7e328dbb70e$export$2e2bcd8739ae039);
    var $3KRpp;
    var $3780c7e328dbb70e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).FlagGroup);
});
parcelRegister("6hrB4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$218f2273ae394fb2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $218f2273ae394fb2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        draftSuccessFlagTitle: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-flag-title",
            "defaultMessage": "Article published"
        },
        draftSuccessFlagDescription: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-flag-description",
            "defaultMessage": "This article has been added to your knowledge base. Your articles list will update soon."
        },
        draftSuccessSavedFlagTitle: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-saved-flag-title",
            "defaultMessage": "Draft saved"
        },
        draftSuccessSavedFlagDescription: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.draft-success-saved-flag-description",
            "defaultMessage": "Find it in Drafts in your knowledge base."
        },
        articleSuccessSavedFlagTitle: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-success-saved-flag-title",
            "defaultMessage": "We\u2019ve saved your unpublished changes"
        },
        articleSuccessSavedFlagDescription: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-success-saved-flag-description",
            "defaultMessage": "You can edit the article and publish these changes later."
        },
        confluenceCreatePageFailureTitle: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.confluence-create-page-failure-title",
            "defaultMessage": "We're having trouble creating the article"
        },
        confluenceCreatePageFailureDescription: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.confluence-create-page-failure-description",
            "defaultMessage": "Wait for a few minutes and try creating the article again."
        },
        articleDeletedFlagTitle: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-deleted-flag-title",
            "defaultMessage": "Article deleted"
        },
        articleDeletedFlagDescription: {
            "id": "servicedesk.knowledge-hub.common.draft-article-flags.article-deleted-flag-description",
            "defaultMessage": "This article has been deleted from your knowledge base. Your articles list will update soon."
        }
    });
});
parcelRegister("8qDpT", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceEmbeddedViewWrapper", ()=>$962e9d2227fc279d$export$4b02582fe8eba18f);
    var $5uXOq = parcelRequire("5uXOq");
    var $34ck9 = parcelRequire("34ck9");
    var $hxoiH;
    var $pf8Kz;
    var $ha42n;
    var $bSOOm;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $dAfqg;
    var $lw2HC;
    var $koeKL;
    var $9OXo1;
    var $dIdda = parcelRequire("dIdda");
    var $1AZST;
    var $hirE8;
    var $4ccEG;
    var $irQht;
    const $962e9d2227fc279d$var$WINDOW_RESIZE_THROTTLE = 350;
    const $962e9d2227fc279d$var$SHIM_URL = '/plugins/servlet/servicedesk/customer/confluence/shim/';
    const $962e9d2227fc279d$export$4b02582fe8eba18f = ({ spaceKey: spaceKey, pageId: pageId, breadcrumbsRef: breadcrumbsRef, projectKey: projectKey, spaceId: spaceId, onIFrameLoaded: onIFrameLoaded })=>{
        const [experienceTracker] = (0, $5uXOq.useState)(new (0, (0, parcelRequire("ha42n")).ExperienceTracker)());
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { atlassianAccountId: atlassianAccountId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const projectId = projectContext?.projectId;
        const [breadcrumbsHeight, setBreadcrumbsHeight] = (0, $5uXOq.useState)(0);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, routerActions] = (0, $dIdda.useRouter)();
        const [, { articleDeleteSuccess: articleDeleteSuccess }] = (0, (0, parcelRequire("lw2HC")).useArticleId)();
        const themeState = (0, (0, parcelRequire("hxoiH")).default)();
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const navigateToEmbeddedEditor = ()=>{
            if (spaceKey != null && projectKey != null) {
                const EDIT_ARTICLE_URL = `/jira/servicedesk/projects/${projectKey}/knowledge/space/${spaceKey}/articles/${pageId}/edit`;
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'onEditClikedInEPView success', {
                    articleId: pageId,
                    spaceId: spaceId,
                    userId: atlassianAccountId,
                    tenantId: cloudId
                });
                routerActions.push(EDIT_ARTICLE_URL);
            }
        };
        const isCreatedInEmbeddedEditor = (url)=>url.includes('edit-embed');
        const debouncedHandleResize = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($34ck9)))(()=>{
            if (breadcrumbsRef?.current) setBreadcrumbsHeight(breadcrumbsRef.current.clientHeight);
        }, $962e9d2227fc279d$var$WINDOW_RESIZE_THROTTLE), []);
        const handleViewPageLoadFailure = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).markFMP();
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).failure({
                force: true
            });
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("irQht")).epViewLoad).start();
            const viewSuccessCallback = ()=>{
                (0, (0, parcelRequire("irQht")).epViewLoad).stop();
                onIFrameLoaded();
            };
            const unsubscribe = experienceTracker.subscribe((payload)=>(0, (0, parcelRequire("4ccEG")).experienceTrackerCallback)({
                    payload: payload,
                    projectKey: projectKey,
                    pageId: pageId,
                    routerActions: routerActions,
                    analyticsEvent: createAnalyticsEvent({}),
                    deleteSuccessCallback: articleDeleteSuccess,
                    viewSuccessCallback: viewSuccessCallback,
                    onViewPageLoadFailure: handleViewPageLoadFailure
                }));
            return unsubscribe;
        }, [
            experienceTracker,
            pageId,
            routerActions,
            projectKey,
            createAnalyticsEvent,
            articleDeleteSuccess,
            onIFrameLoaded,
            handleViewPageLoadFailure
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (breadcrumbsRef?.current) setBreadcrumbsHeight(breadcrumbsRef.current.clientHeight);
            window.addEventListener('resize', debouncedHandleResize);
            return ()=>{
                window.removeEventListener('resize', debouncedHandleResize);
            };
        }, [
            debouncedHandleResize,
            breadcrumbsRef
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hirE8")).StyledEmbeddedConfluenceContainer), {
            topOffset: breadcrumbsHeight
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bSOOm")).ExperienceTrackerContext).Provider, {
            value: experienceTracker
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("pf8Kz")).ViewPage), {
            locale: locale,
            spaceKey: spaceKey,
            contentId: pageId,
            allowedFeatures: [
                'byline-contributors',
                'sticky-header',
                'edit',
                'delete',
                'disable-share'
            ],
            parentProduct: (0, $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c),
            navigationPolicy: {
                shimUrl: $962e9d2227fc279d$var$SHIM_URL,
                navigate: (url, modifiers, defaultNavigate)=>{
                    if (isCreatedInEmbeddedEditor(url)) return navigateToEmbeddedEditor();
                    return defaultNavigate(url, modifiers);
                }
            },
            parentProductContentContainerId: `${projectId}`,
            userInfo: {
                userId: atlassianAccountId || '',
                userIdType: (0, $d7e8e0de2b5415e5$export$a40257481ddef37e)
            },
            themeState: themeState
        })));
    };
});
parcelRegister("pf8Kz", function(module, exports) {
    $parcel$export(module.exports, "ViewPage", ()=>$242f5dff0675cac8$export$767e3006bdbb424a);
    var $5uXOq = parcelRequire("5uXOq");
    var $kc9vJ = parcelRequire("kc9vJ");
    var $6mfaC;
    var $kMusA;
    var $aDZtw;
    const $242f5dff0675cac8$var$LazyViewPage = (0, $kc9vJ.lazyForPaint)(()=>(parcelRequire("gKACE")));
    const $242f5dff0675cac8$export$767e3006bdbb424a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kMusA")).I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, (0, parcelRequire("aDZtw")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kc9vJ.LazySuspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6mfaC")).LazyLoadFallback), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($242f5dff0675cac8$var$LazyViewPage, props)));
});
parcelRegister("6mfaC", function(module, exports) {
    $parcel$export(module.exports, "LazyLoadFallback", ()=>$82e2fe790898e154$export$da581bf12e325888);
    var $bWGt6 = parcelRequire("bWGt6");
    function $82e2fe790898e154$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $82e2fe790898e154$export$da581bf12e325888 = (0, $bWGt6.default)("div", {
        target: "egw45yn0"
    })({
        name: "w1atjl",
        styles: "width:100%;height:100%"
    });
});
parcelRegister("kMusA", function(module, exports) {
    $parcel$export(module.exports, "I18nProvider", ()=>$f904dd1e90d25852$export$a54013f0d02a8f82);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $jmOm3;
    const $f904dd1e90d25852$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, (0, parcelRequire("jmOm3")).DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
        const [messages, setMessages] = (0, $5uXOq.useState)();
        const locale = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("jmOm3")).normalizeLocale)(incomingLocale), [
            incomingLocale
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const loadTranslations = async ()=>{
                const localeMessages = await fetchTranslations(locale);
                setMessages(localeMessages);
            };
            loadTranslations();
        }, [
            fetchTranslations,
            locale
        ]);
        if (!messages) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: locale,
            messages: messages,
            defaultLocale: (0, (0, parcelRequire("jmOm3")).DEFAULT_LOCALE)
        }, children);
    };
});
parcelRegister("jmOm3", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_LOCALE", ()=>$60196e800e53edb0$export$1af4c7e47ad72f44);
    $parcel$export(module.exports, "normalizeLocale", ()=>$60196e800e53edb0$export$dca0327c9b9c6498);
    const $60196e800e53edb0$var$DEFAULT_LANGUAGE = 'en';
    const $60196e800e53edb0$var$DEFAULT_REGION = 'US';
    const $60196e800e53edb0$export$1af4c7e47ad72f44 = `${$60196e800e53edb0$var$DEFAULT_LANGUAGE}-${$60196e800e53edb0$var$DEFAULT_REGION}`;
    const $60196e800e53edb0$var$languageToLongLocaleCode = {
        cs: 'cs-CZ',
        da: 'da-DK',
        de: 'de-DE',
        en: 'en-US',
        es: 'es-ES',
        fi: 'fi-FI',
        fr: 'fr-FR',
        hu: 'hu-HU',
        it: 'it-IT',
        ja: 'ja-JP',
        ko: 'ko-KR',
        no: 'no-NO',
        nb: 'no-NO',
        nl: 'nl-NL',
        pl: 'pl-PL',
        ru: 'ru-RU',
        sv: 'sv-SE',
        th: 'th-TH',
        tr: 'tr-TR',
        uk: 'uk-UA',
        vi: 'vi-VN',
        zh: 'zh-CN'
    };
    const $60196e800e53edb0$export$dca0327c9b9c6498 = (locale)=>{
        if (!locale) return $60196e800e53edb0$export$1af4c7e47ad72f44;
        const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
        if (!match) throw Error('Unable to get language and country from the supplied locale.');
        const [, language, region] = match;
        const normalizedLanguage = (language ?? '').toLowerCase();
        const normalizedRegion = (region ?? '').toUpperCase();
        if (normalizedLanguage && normalizedRegion) return [
            normalizedLanguage,
            normalizedRegion
        ].join('-');
        const longLocaleCode = $60196e800e53edb0$var$languageToLongLocaleCode[normalizedLanguage];
        return longLocaleCode ?? $60196e800e53edb0$export$1af4c7e47ad72f44;
    };
});
parcelRegister("aDZtw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9df194a880c612c7$export$2e2bcd8739ae039);
    const $9df194a880c612c7$var$importTranslations = async (locale)=>{
        switch(locale){
            case 'cs-CZ':
                return (parcelRequire("a4JdB"));
            case 'da-DK':
                return (parcelRequire("g1G9e"));
            case 'de-DE':
                return (parcelRequire("hvoJe"));
            case 'en-US':
                return (parcelRequire("jQrKJ"));
            case 'en-GB':
                return (parcelRequire("4vSMl"));
            case 'en-ZZ':
                return (parcelRequire("hmiN6"));
            case 'es-ES':
                return (parcelRequire("1InhH"));
            case 'fi-FI':
                return (parcelRequire("7o0gw"));
            case 'fr-FR':
                return (parcelRequire("lRAyu"));
            case 'hu-HU':
                return (parcelRequire("8MP6a"));
            case 'it-IT':
                return (parcelRequire("1QDZT"));
            case 'ja-JP':
                return (parcelRequire("4QxoJ"));
            case 'ko-KR':
                return (parcelRequire("dT8Go"));
            case 'no-NO':
                return (parcelRequire("lpDu9"));
            case 'nl-NL':
                return (parcelRequire("b0i4j"));
            case 'pl-PL':
                return (parcelRequire("3kqwE"));
            case 'pt-BR':
                return (parcelRequire("7C5LM"));
            case 'ru-RU':
                return (parcelRequire("62Bcf"));
            case 'sv-SE':
                return (parcelRequire("dB0wl"));
            case 'tr-TR':
                return (parcelRequire("9pfpB"));
            case 'th-TH':
                return (parcelRequire("lXmwN"));
            case 'uk-UA':
                return (parcelRequire("5pq9j"));
            case 'vi-VN':
                return (parcelRequire("g4gFL"));
            case 'zh-TW':
                return (parcelRequire("1OuwZ"));
            case 'zh-CN':
                return (parcelRequire("pETPh"));
            default:
                return Promise.resolve({
                    default: {}
                });
        }
    };
    const $9df194a880c612c7$var$fetchTranslations = async (locale)=>{
        const module = await $9df194a880c612c7$var$importTranslations(locale);
        return module.default;
    };
    var $9df194a880c612c7$export$2e2bcd8739ae039 = $9df194a880c612c7$var$fetchTranslations;
});
parcelRegister("a4JdB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4xqbW").then(()=>parcelRequire('6pfpU'));
});
parcelRegister("g1G9e", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("em37p").then(()=>parcelRequire('7w5UY'));
});
parcelRegister("hvoJe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lBuU4").then(()=>parcelRequire('aWztu'));
});
parcelRegister("jQrKJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jODZK").then(()=>parcelRequire('jHFq0'));
});
parcelRegister("4vSMl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fGLw2").then(()=>parcelRequire('1PCsF'));
});
parcelRegister("hmiN6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7oMlP").then(()=>parcelRequire('dICEU'));
});
parcelRegister("1InhH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5Sy7n").then(()=>parcelRequire('f9W42'));
});
parcelRegister("7o0gw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iIFSt").then(()=>parcelRequire('g7kLj'));
});
parcelRegister("lRAyu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5KOo7").then(()=>parcelRequire('c7UhG'));
});
parcelRegister("8MP6a", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eRbrW").then(()=>parcelRequire('bP2JM'));
});
parcelRegister("1QDZT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("85URL").then(()=>parcelRequire('e4t9o'));
});
parcelRegister("4QxoJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("biorN").then(()=>parcelRequire('9BGDf'));
});
parcelRegister("dT8Go", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7jFsl").then(()=>parcelRequire('6GBqB'));
});
parcelRegister("lpDu9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("77Fmz").then(()=>parcelRequire('jfYJF'));
});
parcelRegister("b0i4j", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fgrKz").then(()=>parcelRequire('ka9xb'));
});
parcelRegister("3kqwE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("daf9m").then(()=>parcelRequire('hurod'));
});
parcelRegister("7C5LM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9tkdt").then(()=>parcelRequire('eTC68'));
});
parcelRegister("62Bcf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fSjfN").then(()=>parcelRequire('gdlzK'));
});
parcelRegister("dB0wl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1eMf5").then(()=>parcelRequire('aNceL'));
});
parcelRegister("9pfpB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7BVpq").then(()=>parcelRequire('lTlB8'));
});
parcelRegister("lXmwN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5ZkeS").then(()=>parcelRequire('ghLdK'));
});
parcelRegister("5pq9j", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4bWxy").then(()=>parcelRequire('4f25c'));
});
parcelRegister("g4gFL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3qjyw").then(()=>parcelRequire('awmIb'));
});
parcelRegister("1OuwZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cboem").then(()=>parcelRequire('gvwZP'));
});
parcelRegister("pETPh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5eRP6").then(()=>parcelRequire('coNGC'));
});
parcelRegister("gKACE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kfWf3")
    ]).then(()=>parcelRequire('2xla2'));
});
parcelRegister("hirE8", function(module, exports) {
    $parcel$export(module.exports, "StyledEmbeddedConfluenceContainer", ()=>$c2ec46a621396b62$export$ae185cb8762590a8);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $44v1T;
    const $c2ec46a621396b62$export$ae185cb8762590a8 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { topOffset: topOffset, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1s93bfy": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("44v1T")).PAGE_LAYOUT_OFFSET_TOP)),
                "--_imrwx": (0, (0, parcelRequire("lD23V")).default)(__cmplp.topOffset, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3irbb1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4ccEG", function(module, exports) {
    $parcel$export(module.exports, "experienceTrackerCallback", ()=>$3762a589d4720dda$export$ede22ae60b43f8c);
    var $8zOmE;
    const $3762a589d4720dda$export$9a4ff2d809fc4156 = 'delete-page';
    const $3762a589d4720dda$export$9257b5b55c8e2555 = 'view-page';
    const $3762a589d4720dda$export$ede22ae60b43f8c = (params)=>{
        const { payload: payload, projectKey: projectKey, pageId: pageId, routerActions: routerActions, analyticsEvent: analyticsEvent, deleteSuccessCallback: deleteSuccessCallback, viewSuccessCallback: viewSuccessCallback, onViewPageLoadFailure: onViewPageLoadFailure } = params;
        const { action: action, name: name, attributes: attributes } = payload;
        switch(action){
            case 'taskStart':
                if (name === $3762a589d4720dda$export$9a4ff2d809fc4156 && attributes?.contentId === pageId) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'deleteButton clicked', {
                    articleId: pageId
                });
                break;
            case 'taskSuccess':
                if (name === $3762a589d4720dda$export$9a4ff2d809fc4156 && attributes?.contentId === pageId && projectKey !== undefined) {
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'onArticleDelete success', {
                        articleId: pageId
                    });
                    deleteSuccessCallback(pageId);
                    routerActions.push(`/jira/servicedesk/projects/${projectKey}/knowledge/articles`);
                }
                if (name === $3762a589d4720dda$export$9257b5b55c8e2555 && attributes?.contentId === pageId) {
                    viewSuccessCallback();
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'epViewPage success', {
                        articleId: pageId
                    });
                }
                break;
            case 'taskFail':
                if (name === $3762a589d4720dda$export$9a4ff2d809fc4156 && attributes?.contentId === pageId) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'onArticleDelete failure', {
                    articleId: pageId
                });
                if (name === $3762a589d4720dda$export$9257b5b55c8e2555 && attributes?.contentId === pageId) {
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'epViewPage failure', {
                        articleId: pageId
                    });
                    onViewPageLoadFailure();
                }
                break;
            default:
                break;
        }
    };
});
parcelRegister("irQht", function(module, exports) {
    $parcel$export(module.exports, "epViewLoad", ()=>$24aa99e291c015aa$export$1ba81ebb50ee85e9);
    var $dGrdR;
    const $24aa99e291c015aa$export$1ba81ebb50ee85e9 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'service-management.ep-view.load'
    });
});
parcelRegister("6y0Ij", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c25676f4d8a9574$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1c25676f4d8a9574$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shareArticle: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-article-stateless.share-article",
            "defaultMessage": "Share this article"
        },
        shareableUrlLabel: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-article-stateless.shareable-url-label",
            "defaultMessage": "Shareable URL"
        },
        copyArticleUrlLabel: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-article-stateless.copy-article-url-label",
            "defaultMessage": "Copy article link"
        },
        belongsToThisSpace: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-article-stateless.belongs-to-this-space",
            "defaultMessage": "Space"
        },
        labels: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-article-stateless.labels",
            "defaultMessage": "Labels"
        },
        tooltipText: {
            "id": "servicedesk.knowledge-hub.knowledge-hub-article-stateless.tooltip-text",
            "defaultMessage": "Opens in new tab"
        }
    });
});
parcelRegister("lcClb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("9bA5E")
    ]).then(()=>parcelRequire('iD6ft'));
});
parcelRegister("88JeF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("jnvZA")
    ]).then(()=>parcelRequire('6vnDB'));
});
parcelRegister("kGNe4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22a3f7642e2f7278$export$2e2bcd8739ae039);
    var $bC2fB;
    var $gLt7z;
    var $5fBrW;
    var $9AWQZ;
    var $22a3f7642e2f7278$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)((state, props)=>({
            name: (0, (0, parcelRequire("5fBrW")).getCategoryName)(state, props.id),
            projectKey: (0, (0, parcelRequire("gLt7z")).getProjectKey)(state),
            baseUrl: (0, (0, parcelRequire("gLt7z")).getBaseUrl)(state)
        }), {})((0, (0, parcelRequire("9AWQZ")).default));
});
parcelRegister("9AWQZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f1ae94aada8bab44$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $2Lj35;
    function $f1ae94aada8bab44$export$2e2bcd8739ae039({ id: id, name: name, children: children, baseUrl: baseUrl, projectKey: projectKey }) {
        if (name === undefined) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                href: `${baseUrl}/jira/servicedesk/projects/${projectKey}/knowledge/categories/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(id)}`,
                text: name,
                type: 'jsd-category-link'
            }
        }, children);
    }
});
parcelRegister("2riGj", function(module, exports) {
    $parcel$export(module.exports, "KnowledgeHubAppBase", ()=>$cda69d9cd68a5197$export$f848f52481042e56);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $e0Brz;
    var $gEFwt;
    var $kb4zh;
    var $9sGI6;
    var $97Kan;
    var $3HwlS;
    var $2NMNM;
    var $5MiFc;
    var $cf7yQ;
    var $lw2HC;
    var $cbMay;
    var $h4S6Q;
    var $hYd1f;
    var $1eweq;
    var $1xzCS;
    var $7FkcY;
    var $6GLlD;
    var $e33py;
    var $6FTcZ;
    var $gq0sA;
    var $4S0uJ;
    var $dIdda = parcelRequire("dIdda");
    const $cda69d9cd68a5197$var$KnowledgeHubAppBaseView = (props)=>{
        const { initialActions: initialActions, KnowledgeHubContainer: KnowledgeHubContainer, appName: appName, shouldRemoveMargin: shouldRemoveMargin = false } = props;
        const [{ match: match, query: query }] = (0, $dIdda.useRouter)();
        const [{ data: pageContextData, error: pageContextError }] = (0, (0, parcelRequire("gq0sA")).usePageContext)();
        const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
        const { projectKey: projectKey, projectName: projectName, projectId: projectId } = projectContext || {};
        const [{ data: confluenceLink, error: confluenceLinkError }] = (0, (0, parcelRequire("6FTcZ")).useKbConfluenceContext)(projectKey);
        const [{ categories: categories, isCategoriesSupported: isCategoriesSupported }, { fetchCategories: fetchCategories }] = (0, (0, parcelRequire("lw2HC")).useCategoriesData)();
        const { activationId: activationId } = tenantContext || {};
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) return;
            projectId && activationId && fetchCategories(projectId, createAnalyticsEvent({}), activationId);
        }, [
            projectId,
            fetchCategories,
            createAnalyticsEvent,
            activationId
        ]);
        if (!confluenceLink && !confluenceLinkError || !pageContextData && !pageContextError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        const stateAppProps = {
            app: {
                ...tenantContext,
                ...projectContext,
                ...serviceDeskContext
            }
        };
        const CustomizedPageStyle = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && shouldRemoveMargin ? (0, (0, parcelRequire("dC5iT")).default) : (0, (0, parcelRequire("4S0uJ")).PageStyle);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6GLlD")).default), {
            appName: appName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(KnowledgeHubContainer, {
            scope: projectKey
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eweq")).KnowledgeHubActionsSubscriber), null, (_, scopedKnowledgeActions)=>{
            const initialState = {
                ...scopedKnowledgeActions.getStoreState(),
                ...stateAppProps
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5MiFc")).ReduxConnector), {
                storeName: "servicedesk-knowledge-hub",
                initialState: initialState,
                rootReducer: (0, (0, parcelRequire("1xzCS")).default)(scopedKnowledgeActions.updateStore),
                rootEpic: (0, (0, parcelRequire("hYd1f")).default),
                initialActions: initialActions
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7FkcY")).default), {
                ...confluenceLink,
                categories: categories,
                isCategoriesSupported: isCategoriesSupported
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e33py")).ServiceDeskDocumentTitle), {
                projectName: projectName,
                section: "knowledge"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbMay")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0Brz")).BreadcrumbManager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEFwt")).default), {
                baseUrl: "",
                projectKey: projectKey,
                projectName: projectName
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(CustomizedPageStyle, null, props.children({
                match: match,
                query: query,
                pageContext: {
                    ...stateAppProps.app
                }
            })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("97Kan")).FlagsDispatcher), {
                mapper: (0, (0, parcelRequire("h4S6Q")).default)
            })));
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cf7yQ")).JsdGettingStartedPanelShouldRender), null));
    };
    const $cda69d9cd68a5197$export$f848f52481042e56 = (0, (0, parcelRequire("9sGI6")).default)($cda69d9cd68a5197$var$KnowledgeHubAppBaseView, {
        initialActions: [],
        KnowledgeHubContainer: (0, (0, parcelRequire("1eweq")).KnowledgeHubContainer)
    });
    var $cda69d9cd68a5197$export$2e2bcd8739ae039 = $cda69d9cd68a5197$export$f848f52481042e56;
});
parcelRegister("97Kan", function(module, exports) {
    $parcel$export(module.exports, "FlagsDispatcher", ()=>$4ddeb9f500a62e17$export$9e60e3d40b6e758f);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $fpHHI;
    const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fpHHI")).Dispatcher), {
            store: store,
            mapper: mapper,
            showFlag: (0, (0, parcelRequire("pa9q9")).showFlag),
            dismissFlag: (0, (0, parcelRequire("pa9q9")).dismissFlag)
        });
});
parcelRegister("fpHHI", function(module, exports) {
    $parcel$export(module.exports, "Dispatcher", ()=>$eef6139685bfb64e$export$ab054a1ef92eeb01);
    var $5uXOq = parcelRequire("5uXOq");
    var $1kijq;
    const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
        const { store: store, ...dispatcherProps } = props;
        const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
        if (store !== lastStore) setLastStore(store);
        const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1kijq")).createDispatcher)(store), [
            store
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
    };
});
parcelRegister("1kijq", function(module, exports) {
    $parcel$export(module.exports, "createDispatcher", ()=>$c324e875f8c6fe8f$export$7b259d28468da15b);
    var $5uXOq = parcelRequire("5uXOq");
    var $kVVL1 = parcelRequire("kVVL1");
    var $pa9q9;
    const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
        if (!store) throw new Error('Store not available through direct injection or Provider context');
        if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
        return store;
    };
    const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
        if (!result) return;
        if ((0, (0, parcelRequire("pa9q9")).isDismissFlag)(result)) dismissFlag(result);
        else if ((0, (0, parcelRequire("pa9q9")).isFlagComponent)(result)) {
            const FlagComponent = result;
            const FlagComponentWithProvider = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                    store: store
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
            showFlag(FlagComponentWithProvider);
        } else showFlag(result);
    };
    const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
        if ((0, (0, parcelRequire("pa9q9")).isBatchAction)(action)) action.payload.forEach((childAction)=>{
            if (childAction.type && typeof childAction.type === 'string') {
                const childResult = mapper(childAction, state);
                $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
            }
        });
        else {
            const result = mapper(action, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
        }
    };
    const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
        const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
        const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
            storeUnchecked
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const handleAction = (action, state)=>{
                $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
            };
            store.addActionListener(handleAction);
            return ()=>store.removeActionListener(handleAction);
        }, [
            store,
            mapper,
            showFlag,
            dismissFlag
        ]);
        return null;
    };
    const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
        const store = (0, $kVVL1.useStore)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: store
        });
    };
    const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
        const Dispatcher8CustomStore = (props)=>customStore ? (0, ($parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
                ...props,
                store: customStore
            }) : null;
        return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
    };
});
parcelRegister("5MiFc", function(module, exports) {
    $parcel$export(module.exports, "ReduxConnector", ()=>$d6d887f51629efb1$export$c0c26a673bd1981c);
    var $5uXOq = parcelRequire("5uXOq");
    var $F2Mxm;
    var $bC2fB;
    const $d6d887f51629efb1$export$c0c26a673bd1981c = ({ storeName: storeName, initialState: initialState, initialActions: initialActions, rootReducer: rootReducer, rootEpic: rootEpic, children: children })=>{
        const createStoreRef = (0, $5uXOq.useRef)(()=>(0, (0, parcelRequire("F2Mxm")).default)({
                appName: storeName,
                initialState: initialState,
                rootReducer: rootReducer,
                rootEpic: rootEpic
            }));
        const store = (0, $5uXOq.useMemo)(createStoreRef.current, []);
        const initialActionsRef = (0, $5uXOq.useRef)(initialActions);
        (0, $5uXOq.useEffect)(()=>{
            initialActionsRef.current?.forEach((action)=>{
                store.dispatch(action());
            });
        }, [
            store
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bC2fB")).Provider), {
            store: store
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children)));
    };
});
parcelRegister("cf7yQ", function(module, exports) {
    $parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", ()=>$8aa55ef5824c4e4d$export$46976e0f90edfcfe);
    $parcel$export(module.exports, "JsdGettingStartedPanel", ()=>$8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
    $parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", ()=>$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
    $parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", ()=>$8aa55ef5824c4e4d$export$c7732c55900cf0b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("6MoH3")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("ejgPJ")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("2VzMc")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("ahFso")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
    });
    const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-should-render",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
    $8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
    const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-panel",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
    $8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
    const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-open-button",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
    $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
    const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-reopen-spotlight",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
    $8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';
});
parcelRegister("6MoH3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("chQyv").then(()=>parcelRequire('hZyYK'));
});
parcelRegister("ejgPJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3Xgpx")
    ]).then(()=>parcelRequire('2NciN'));
});
parcelRegister("2VzMc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hlGg7")
    ]).then(()=>parcelRequire('4F6ZA'));
});
parcelRegister("ahFso", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eXDqW")
    ]).then(()=>parcelRequire('6Wput'));
});
parcelRegister("cbMay", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$342ca5599182c99e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $825UM;
    var $ks7Ah;
    var $342ca5599182c99e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ks7Ah")).default), null, ({ isOpen: isOpen, onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("825UM")).default), {
                isOpen: isOpen,
                onClose: onClose
            }));
});
parcelRegister("825UM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6d18ceb0644bdde$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $i8Qvm;
    var $6z7Gx;
    var $gq0sA;
    var $dIdda = parcelRequire("dIdda");
    var $261Bl;
    var $lw2HC;
    var $7U3kA;
    const $a6d18ceb0644bdde$var$KnowledgeHubCreateCategory = (props)=>{
        const { isOpen: isOpen, onClose: onClose } = props;
        const { push: push } = (0, $dIdda.useRouterActions)();
        const [{ data: pageContextData }] = (0, (0, parcelRequire("gq0sA")).usePageContext)();
        const { projectContext: projectContext, tenantContext: tenantContext } = pageContextData || {};
        const { projectId: projectId, projectKey: projectKey } = projectContext || {};
        const [{ isSubmitting: isSubmitting, formValues: formValues, error: error, createdCategory: createdCategory }, { createCategory: createCategory, handleFormInputChange: handleFormInputChange, resetCreatedCategory: resetCreatedCategory }] = (0, (0, parcelRequire("lw2HC")).useCreateCategoryData)();
        const activationId = tenantContext?.activationId || '';
        const isValid = !!formValues.name && formValues.name.length !== 0;
        const onChange = (field, value)=>{
            handleFormInputChange(field, value);
        };
        (0, $5uXOq.useEffect)(()=>{
            if (!createdCategory) return;
            onClose();
            resetCreatedCategory();
            push(`/jira/servicedesk/projects/${projectKey}/knowledge/categories/${(0, (0, parcelRequire("261Bl")).categoryGuidToString)(createdCategory.id)}`);
        }, [
            createdCategory,
            projectKey,
            push,
            onClose,
            resetCreatedCategory
        ]);
        const onSubmit = (e, analyticsEvent)=>{
            e.preventDefault();
            if (isSubmitting || !isValid) return;
            projectId && createCategory(projectId, analyticsEvent, activationId);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                source: `knowledgeCreateCategory${(0, $4d5e0871c06cee03$export$1171103ea9083ffa)}`,
                actionSubject: 'category',
                attributes: {
                    context: (0, (0, parcelRequire("6z7Gx")).ANALYTIC_CONTEXTS).KNOWLEDGE
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7U3kA")).default), {
            onChange: onChange,
            onClose: onClose,
            onSubmit: onSubmit,
            formValues: formValues,
            formError: error.formError,
            fieldErrors: error.fieldErrors,
            isSubmitting: isSubmitting,
            isDisabled: !isValid
        })));
    };
    var $a6d18ceb0644bdde$export$2e2bcd8739ae039 = $a6d18ceb0644bdde$var$KnowledgeHubCreateCategory;
});
parcelRegister("gq0sA", function(module, exports) {
    $parcel$export(module.exports, "usePageContext", ()=>$2299d7a4f1092420$export$9c25024bdfe755f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $dxCvy;
    var $9OXo1;
    var $dFOAR;
    const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache);
    const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
        const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
        const pageContextData = (0, $5uXOq.useMemo)(()=>({
                data: projectContext && serviceDeskContext ? {
                    serviceDeskContext: {
                        portalId: serviceDeskContext.portalId,
                        portalUrl: serviceDeskContext.portalUrl,
                        canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                        userRole: serviceDeskContext.userRole,
                        serviceDeskId: serviceDeskContext.serviceDeskId
                    },
                    projectContext: {
                        projectId: projectContext.projectId,
                        projectKey: projectContext.projectKey,
                        projectName: projectContext.projectName,
                        projectType: projectContext.projectType,
                        isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                        isProjectSimplified: projectContext.simplified
                    },
                    tenantContext: {
                        baseUrl: tenantContext.baseUrl,
                        locale: tenantContext.locale,
                        userFullname: tenantContext.userFullname,
                        cloudId: tenantContext.cloudId,
                        fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                        atlassianAccountId: tenantContext.atlassianAccountId,
                        isJiraAdmin: tenantContext.isAdmin,
                        isSiteAdmin: tenantContext.isSiteAdmin,
                        activationId: tenantContext.activationId
                    }
                } : null,
                loading: projectContextLoading || serviceDeskLoading,
                error: serviceDeskError || projectContextError || null
            }), [
            tenantContext,
            projectContext,
            serviceDeskContext,
            projectContextLoading,
            serviceDeskLoading,
            serviceDeskError,
            projectContextError
        ]);
        return [
            pageContextData
        ];
    };
});
parcelRegister("dFOAR", function(module, exports) {
    $parcel$export(module.exports, "useServiceDeskContext", ()=>$6c09349e97fba749$export$712ead87353ac687);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $cAofY;
    const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, (0, parcelRequire("cAofY")).serviceDeskContextResource);
    const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
        const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
        (0, $5uXOq.useEffect)(()=>{
            if (!false) refreshCache();
        }, [
            projectKey,
            refreshCache
        ]);
        return [
            {
                data: data,
                loading: loading,
                error: error
            }
        ];
    };
});
parcelRegister("7U3kA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2ae948e58435135$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $2rqOp;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $hZHze;
    var $9fuVs;
    var $koVbs;
    var $9oIFN;
    var $5TOVG;
    const $c2ae948e58435135$var$KnowledgeHubCreateCategoryStateless = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { isSubmitting: isSubmitting = false, isDisabled: isDisabled = false, onChange: onChange, onClose: onClose, onSubmit: onSubmit, formError: formError, fieldErrors: fieldErrors } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: onClose,
            width: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, (0, parcelRequire("5TOVG")).default).title))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9oIFN")).default), {
            onChange: onChange,
            onSubmit: onSubmit,
            formError: formError,
            fieldErrors: fieldErrors,
            isDisabled: isSubmitting
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            appearance: "primary",
            onClick: onSubmit,
            isLoading: isSubmitting,
            isDisabled: isDisabled
        }, formatMessage((0, (0, parcelRequire("5TOVG")).default).createAction)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: onClose
        }, formatMessage((0, (0, parcelRequire("5TOVG")).default).cancelAction)))));
    };
    var $c2ae948e58435135$export$2e2bcd8739ae039 = $c2ae948e58435135$var$KnowledgeHubCreateCategoryStateless;
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("9oIFN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49788ff41cd45114$export$2e2bcd8739ae039);
    var $8oe80;
    var $3pn3a;
    var $49788ff41cd45114$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('form', {
        onSubmit: 'submitted'
    })((0, (0, parcelRequire("3pn3a")).default));
});
parcelRegister("3pn3a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da6b524a14a97bee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7O4UO;
    var $92Z2l;
    var $6LCpJ;
    var $kY99m;
    var $koVbs;
    var $7cbM0;
    var $7VpFm;
    const $da6b524a14a97bee$var$CreateCategoryForm = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { onSubmit: onSubmit, formError: formError, fieldErrors: fieldErrors, isDisabled: isDisabled = false, testId: testId } = props;
        const createOnChangeHandlerForField = (field)=>(e)=>{
                props.onChange(field, e.currentTarget.value);
            };
        const errorMessage = (field)=>fieldErrors && !!fieldErrors[field] ? formatMessage(fieldErrors[field].message) : undefined;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("form", {
            onSubmit: onSubmit,
            disabled: isDisabled
        }, formError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "error",
            testId: testId && `${testId}--section-message`
        }, formatMessage(formError.message)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("7VpFm")).default).helpText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            error: errorMessage('name'),
            label: formatMessage((0, (0, parcelRequire("7VpFm")).default).nameFieldLabel),
            isRequired: true,
            name: "name"
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7cbM0")).default), {
                error: errorMessage('name')
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                ...fieldProps,
                isRequired: true,
                autoComplete: "off",
                placeholder: formatMessage((0, (0, parcelRequire("7VpFm")).default).nameFieldPlaceholder),
                isInvalid: fieldErrors && !!fieldErrors.name,
                maxLength: 100,
                onChange: createOnChangeHandlerForField('name'),
                isDisabled: isDisabled,
                autoFocus: true
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            error: errorMessage('description'),
            label: formatMessage((0, (0, parcelRequire("7VpFm")).default).descriptionFieldLabel),
            name: "description"
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7cbM0")).default), {
                error: errorMessage('description')
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6LCpJ")).default), {
                ...fieldProps,
                maxLength: 150,
                minimumRows: 3,
                autoComplete: "off",
                placeholder: formatMessage((0, (0, parcelRequire("7VpFm")).default).descriptionFieldPlaceholder),
                isInvalid: fieldErrors && !!fieldErrors.description,
                isDisabled: isDisabled,
                onChange: createOnChangeHandlerForField('description')
            })))));
    };
    var $da6b524a14a97bee$export$2e2bcd8739ae039 = $da6b524a14a97bee$var$CreateCategoryForm;
});
parcelRegister("7O4UO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e20204ce79b642c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $9KnKW;
    var $dRN65;
    var $efXp3;
    var $2x3Cb;
    var $kxqHl;
    var $6cAn5 = parcelRequire("6cAn5");
    function $7e20204ce79b642c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7e20204ce79b642c$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $7e20204ce79b642c$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $7e20204ce79b642c$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $7e20204ce79b642c$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
        const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7e20204ce79b642c$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kxqHl")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("dRN65", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$706cd4dbd4574fd7$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $706cd4dbd4574fd7$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("efXp3", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$987e2ff089e89967$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$987e2ff089e89967$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$987e2ff089e89967$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $987e2ff089e89967$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $987e2ff089e89967$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("2x3Cb", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$987b76a5b7a0ea9b$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$987b76a5b7a0ea9b$export$ed247974535929c7);
    var $f8Sb3;
    function $987b76a5b7a0ea9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles
        }, children);
    };
    var $987b76a5b7a0ea9b$export$2e2bcd8739ae039 = $987b76a5b7a0ea9b$export$b04be29aa201d4f5;
});
parcelRegister("kxqHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55ac25356e81a33$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d55ac25356e81a33$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d55ac25356e81a33$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d55ac25356e81a33$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("6LCpJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$934f91ac04cc5aeb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $1qQmi;
    const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
    const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
    const $934f91ac04cc5aeb$var$analyticsParams = {
        componentName: 'textArea',
        packageName: $934f91ac04cc5aeb$var$packageName,
        packageVersion: $934f91ac04cc5aeb$var$packageVersion
    };
    const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
        el.style.height = 'auto';
        const borderHeight = (0, (0, parcelRequire("1qQmi")).borderWidth);
        const paddingBoxHeight = el.scrollHeight;
        const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
        el.style.height = `${borderBoxHeight}px`;
    };
    const $934f91ac04cc5aeb$var$InnerTextArea = (0, $5uXOq.forwardRef)((props, ref)=>{
        const ourRef = (0, $5uXOq.useRef)(null);
        const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
        (0, $5uXOq.useEffect)(()=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        }, [
            resize,
            value
        ]);
        const onBlurWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$934f91ac04cc5aeb$var$analyticsParams
        });
        const onFocusWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$934f91ac04cc5aeb$var$analyticsParams
        });
        const getTextAreaRef = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === 'object') ref.current = elementRef;
            if (ref && typeof ref === 'function') ref(elementRef);
        };
        const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
            onChange && onChange(e);
        }, [
            onChange,
            resize
        ]);
        const controlProps = {
            'data-invalid': isInvalid ? isInvalid : undefined,
            'data-compact': isCompact ? isCompact : undefined,
            'data-testid': testId ? testId : undefined
        };
        const baseStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1qQmi")).getBaseStyles)({
                minimumRows: minimumRows,
                resize: resize,
                appearance: appearance,
                isMonospaced: isMonospaced,
                maxHeight: maxHeight
            }), [
            minimumRows,
            resize,
            appearance,
            isMonospaced,
            maxHeight
        ]);
        const textAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)([
            baseStyles,
            (0, (0, parcelRequire("1qQmi")).dynamicStyles)(appearance)
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            css: textAreaStyles,
            ...rest
        });
    });
    const $934f91ac04cc5aeb$var$TextArea = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function TextArea(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
            ref: ref,
            ...props
        });
    }));
    $934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
    var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;
});
parcelRegister("1qQmi", function(module, exports) {
    $parcel$export(module.exports, "borderWidth", ()=>$0f8aaecc0e682a20$export$12879c7697ed953d);
    $parcel$export(module.exports, "getBaseStyles", ()=>$0f8aaecc0e682a20$export$bff8031d86bb089);
    $parcel$export(module.exports, "dynamicStyles", ()=>$0f8aaecc0e682a20$export$98856a888ef36079);
    var $f8Sb3;
    var $iaE2J;
    function $0f8aaecc0e682a20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0f8aaecc0e682a20$var$disabledRules = {
        backgroundColor: (0, parcelRequire("iaE2J")).disabledBackground,
        backgroundColorFocus: (0, parcelRequire("iaE2J")).disabledBackground,
        backgroundColorHover: (0, parcelRequire("iaE2J")).disabledBackground,
        borderColor: (0, parcelRequire("iaE2J")).disabledBorder,
        borderColorFocus: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        textColor: (0, parcelRequire("iaE2J")).disabledTextColor
    };
    const $0f8aaecc0e682a20$var$invalidRules = {
        borderColor: (0, parcelRequire("iaE2J")).invalidBorderColor,
        borderColorFocus: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        backgroundColor: (0, parcelRequire("iaE2J")).defaultBackgroundColor,
        backgroundColorFocus: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        backgroundColorHover: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover
    };
    const $0f8aaecc0e682a20$var$backgroundColor = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColor,
        subtle: (0, parcelRequire("iaE2J")).transparent,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$backgroundColorFocus = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        subtle: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$backgroundColorHover = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover,
        subtle: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColor = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColor,
        subtle: (0, parcelRequire("iaE2J")).transparent,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColorFocus = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        subtle: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColorHover = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColor,
        subtle: (0, parcelRequire("iaE2J")).subtleBorderColorHover,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$lineHeightBase = 20;
    const $0f8aaecc0e682a20$var$lineHeightCompact = 16;
    const $0f8aaecc0e682a20$var$compactVerticalPadding = 2;
    const $0f8aaecc0e682a20$var$verticalPadding = 6;
    const $0f8aaecc0e682a20$var$horizontalPadding = 8;
    const $0f8aaecc0e682a20$var$transitionDuration = '0.2s';
    const $0f8aaecc0e682a20$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
    const $0f8aaecc0e682a20$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
    const $0f8aaecc0e682a20$export$12879c7697ed953d = 2;
    const $0f8aaecc0e682a20$var$overrideSafariDisabledStyles = {
        WebkitTextFillColor: 'unset',
        WebkitOpacity: '1'
    };
    const $0f8aaecc0e682a20$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
        const contentHeight = $0f8aaecc0e682a20$var$lineHeightBase * minimumRows;
        return contentHeight + $0f8aaecc0e682a20$var$verticalPadding * 2 + borderHeight * 2;
    };
    const $0f8aaecc0e682a20$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
        const contentHeightCompact = $0f8aaecc0e682a20$var$lineHeightCompact * minimumRows;
        return contentHeightCompact + $0f8aaecc0e682a20$var$compactVerticalPadding * 2 + borderHeight * 2;
    };
    const $0f8aaecc0e682a20$var$bgAndBorderColorStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColorFocus[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$borderColorFocus[appearance]}`
            },
            '&:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColor[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColor[appearance]
            },
            '&[data-invalid]:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorFocus,
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColorFocus,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColorFocus}`
            },
            '&[data-invalid]:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColor,
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
            },
            ...appearance === 'standard' ? {
                '&:disabled:focus': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorFocus,
                    borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColorFocus
                },
                '&:disabled:not(:focus)': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColor,
                    borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColor
                }
            } : {}
        });
    const $0f8aaecc0e682a20$var$placeholderStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::placeholder': {
            color: (0, parcelRequire("iaE2J")).placeholderTextColor
        },
        '&:disabled::placeholder': {
            color: $0f8aaecc0e682a20$var$disabledRules.textColor
        }
    });
    const $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:hover:not(:read-only):not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColorHover[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColorHover[appearance],
                '&:disabled': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorHover
                },
                '&[data-invalid]': {
                    backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorHover,
                    borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
                }
            }
        });
    var $0f8aaecc0e682a20$var$_ref = {
        name: "utehjx",
        styles: "resize:none"
    };
    var $0f8aaecc0e682a20$var$_ref2 = {
        name: "bolgb9",
        styles: "resize:both"
    };
    const $0f8aaecc0e682a20$var$resizeStyle = (resize)=>{
        if (resize === 'horizontal' || resize === 'vertical') return (0, (0, parcelRequire("f8Sb3")).css)({
            resize: resize
        });
        if (resize === 'auto') return $0f8aaecc0e682a20$var$_ref2;
        return $0f8aaecc0e682a20$var$_ref;
    };
    const $0f8aaecc0e682a20$var$borderStyle = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)({
            borderStyle: appearance === 'none' ? 'none' : 'solid'
        });
    const $0f8aaecc0e682a20$var$fontFamilyStyle = (isMonospaced)=>(0, (0, parcelRequire("f8Sb3")).css)({
            fontFamily: isMonospaced ? $0f8aaecc0e682a20$var$codeFontFamily : $0f8aaecc0e682a20$var$fontFamily
        });
    const $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
        const borderWidth = appearance !== 'none' ? 1 : 2;
        const horizontalPaddingWithoutBorderWidth = $0f8aaecc0e682a20$var$horizontalPadding - borderWidth;
        const borderHeight = borderWidth;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '&[data-compact]': {
                minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
                padding: `${$0f8aaecc0e682a20$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $0f8aaecc0e682a20$var$lineHeightCompact / 14
            },
            '&:not([data-compact])': {
                minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeight(minimumRows, borderHeight),
                padding: `${$0f8aaecc0e682a20$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $0f8aaecc0e682a20$var$lineHeightBase / 14
            }
        });
    };
    const $0f8aaecc0e682a20$var$staticStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        boxSizing: 'border-box',
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        margin: 0,
        position: 'relative',
        flex: '1 1 100%',
        borderRadius: "var(--ds-border-radius, 3px)",
        borderWidth: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        outline: 'none',
        overflow: 'auto',
        transition: `background-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out,
               border-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out`,
        wordWrap: 'break-word',
        '&:disabled': {
            cursor: 'not-allowed',
            ...$0f8aaecc0e682a20$var$overrideSafariDisabledStyles
        },
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        }
    });
    const $0f8aaecc0e682a20$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>(0, (0, parcelRequire("f8Sb3")).css)($0f8aaecc0e682a20$var$staticStyles, $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles(minimumRows, appearance), $0f8aaecc0e682a20$var$resizeStyle(resize), $0f8aaecc0e682a20$var$borderStyle(appearance), $0f8aaecc0e682a20$var$fontFamilyStyle(isMonospaced), {
            maxHeight: maxHeight
        });
    const $0f8aaecc0e682a20$export$98856a888ef36079 = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)($0f8aaecc0e682a20$var$bgAndBorderColorStyles(appearance), $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles(appearance), $0f8aaecc0e682a20$var$placeholderStyles, {
            color: (0, parcelRequire("iaE2J")).textColor,
            '&:disabled': {
                color: $0f8aaecc0e682a20$var$disabledRules.textColor
            }
        });
});
parcelRegister("iaE2J", function(module, exports) {
    $parcel$export(module.exports, "disabledBackground", ()=>$f788b902061573a8$export$ae3cba7672df0890);
    $parcel$export(module.exports, "disabledBorder", ()=>$f788b902061573a8$export$fe505fe3c5edbdf6);
    $parcel$export(module.exports, "invalidBorderColor", ()=>$f788b902061573a8$export$7f333bbf7ddab792);
    $parcel$export(module.exports, "defaultBorderColor", ()=>$f788b902061573a8$export$dafd83031c202ca8);
    $parcel$export(module.exports, "defaultBorderColorFocus", ()=>$f788b902061573a8$export$e8320c09dc1e4012);
    $parcel$export(module.exports, "defaultBackgroundColor", ()=>$f788b902061573a8$export$b13414ee9ac9cae6);
    $parcel$export(module.exports, "defaultBackgroundColorHover", ()=>$f788b902061573a8$export$bca15982c103d57b);
    $parcel$export(module.exports, "defaultBackgroundColorFocus", ()=>$f788b902061573a8$export$21287e4b7f134f09);
    $parcel$export(module.exports, "subtleBorderColorHover", ()=>$f788b902061573a8$export$a87538d56ee366ec);
    $parcel$export(module.exports, "placeholderTextColor", ()=>$f788b902061573a8$export$5e076b2557ef7bbb);
    $parcel$export(module.exports, "textColor", ()=>$f788b902061573a8$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "disabledTextColor", ()=>$f788b902061573a8$export$eb4a7d363eec53c8);
    $parcel$export(module.exports, "transparent", ()=>$f788b902061573a8$export$f4d082c200a4b4b8);
    const $f788b902061573a8$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
    const $f788b902061573a8$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
    const $f788b902061573a8$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`;
    const $f788b902061573a8$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`;
    const $f788b902061573a8$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`;
    const $f788b902061573a8$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`;
    const $f788b902061573a8$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $f788b902061573a8$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $f788b902061573a8$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
    const $f788b902061573a8$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
    const $f788b902061573a8$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
    const $f788b902061573a8$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`;
    const $f788b902061573a8$export$f4d082c200a4b4b8 = 'transparent';
});
parcelRegister("7cbM0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78c9409ad575aa5f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    function $78c9409ad575aa5f$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, props.children, (0, ($parcel$interopDefault($5uXOq))).createElement($78c9409ad575aa5f$var$ErrorMessage, null, props.error));
    }
    $78c9409ad575aa5f$export$2e2bcd8739ae039.defaultProps = {
        error: undefined
    };
    const $78c9409ad575aa5f$var$ErrorMessage = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1l5o _1yt4swc3",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7VpFm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$185a0480b7dde273$export$2e2bcd8739ae039);
    var $7VHMR;
    var $185a0480b7dde273$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        helpText: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.help-text",
            "defaultMessage": "Group related articles in categories to help customers find what they need."
        },
        nameFieldLabel: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-label",
            "defaultMessage": "Name"
        },
        nameFieldPlaceholder: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-placeholder",
            "defaultMessage": "Category name, e.g \"Printers\" or \"Wifi\""
        },
        descriptionFieldLabel: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-label",
            "defaultMessage": "Description"
        },
        descriptionFieldPlaceholder: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-placeholder",
            "defaultMessage": "Tell customers more about this category"
        }
    });
});
parcelRegister("5TOVG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f748cc858c62ad0d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f748cc858c62ad0d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.title",
            "defaultMessage": "Create new category"
        },
        createAction: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-action",
            "defaultMessage": "Create"
        },
        cancelAction: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.cancel-action",
            "defaultMessage": "Cancel"
        }
    });
});
parcelRegister("ks7Ah", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30d72adc6eb603b4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kvQS7;
    const $30d72adc6eb603b4$var$NavDriver = (props)=>{
        const { children: children } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kvQS7")).KbCreateCategorySubscriber), null, ({ isOpen: isOpen }, { setCreateCategoryDisplay: setCreateCategoryDisplay })=>{
            const onClose = ()=>setCreateCategoryDisplay(false);
            return children({
                isOpen: isOpen,
                onClose: onClose
            });
        });
    };
    var $30d72adc6eb603b4$export$2e2bcd8739ae039 = $30d72adc6eb603b4$var$NavDriver;
});
parcelRegister("kvQS7", function(module, exports) {
    $parcel$export(module.exports, "useKbCreateCategoryActions", ()=>$fefcd82701364dc4$export$719df9e736f08a9);
    $parcel$export(module.exports, "KbCreateCategorySubscriber", ()=>$fefcd82701364dc4$export$2b9cf8c256011b51);
    var $7JoAD = parcelRequire("7JoAD");
    const $fefcd82701364dc4$export$d4c72bab9d6cc13a = {
        isOpen: false
    };
    const $fefcd82701364dc4$var$setCreateCategoryDisplay = (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        };
    const $fefcd82701364dc4$export$e324594224ef24da = {
        setCreateCategoryDisplay: $fefcd82701364dc4$var$setCreateCategoryDisplay
    };
    const $fefcd82701364dc4$var$Store = (0, $7JoAD.createStore)({
        name: 'kb-create-category',
        initialState: $fefcd82701364dc4$export$d4c72bab9d6cc13a,
        actions: $fefcd82701364dc4$export$e324594224ef24da
    });
    const $fefcd82701364dc4$export$719df9e736f08a9 = (0, $7JoAD.createHook)($fefcd82701364dc4$var$Store, {
        selector: null
    });
    const $fefcd82701364dc4$export$2b9cf8c256011b51 = (0, $7JoAD.createSubscriber)($fefcd82701364dc4$var$Store);
});
parcelRegister("h4S6Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e91b5defeecf9279$export$2e2bcd8739ae039);
    var $5sKH1;
    var $iHUHp;
    var $6zk4x;
    var $1hzgw;
    var $6VTSZ;
    const $e91b5defeecf9279$var$flagsMapper = (action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("6zk4x")).UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
            case 0, (0, parcelRequire("5sKH1")).ADD_CATEGORIES_FOR_ARTICLE_FAILURE:
                return (0, (0, parcelRequire("6VTSZ")).default)();
            case 0, (0, parcelRequire("iHUHp")).REMOVE_LABEL_FROM_ARTICLE_FAILURE:
                return (0, (0, parcelRequire("1hzgw")).default)();
            default:
                return undefined;
        }
    };
    var $e91b5defeecf9279$export$2e2bcd8739ae039 = $e91b5defeecf9279$var$flagsMapper;
});
parcelRegister("5sKH1", function(module, exports) {
    $parcel$export(module.exports, "ADD_CATEGORIES_FOR_ARTICLE_FAILURE", ()=>$a77e1c0ebfe8e6c5$export$734a6edf8f4ccc0d);
    $parcel$export(module.exports, "addCategoriesForArticleFailure", ()=>$a77e1c0ebfe8e6c5$export$98c16426b39dc19d);
    const $a77e1c0ebfe8e6c5$export$734a6edf8f4ccc0d = 'state.actions.add-categories-for-article-failure.ADD_CATEGORIES_FOR_ARTICLE_FAILURE';
    const $a77e1c0ebfe8e6c5$export$98c16426b39dc19d = (payload)=>({
            payload: payload,
            type: $a77e1c0ebfe8e6c5$export$734a6edf8f4ccc0d
        });
});
parcelRegister("iHUHp", function(module, exports) {
    $parcel$export(module.exports, "REMOVE_LABEL_FROM_ARTICLE_FAILURE", ()=>$36bd602e9276dc31$export$78c874904ae250ac);
    $parcel$export(module.exports, "removeLabelFromArticleFailure", ()=>$36bd602e9276dc31$export$b7ca01a9c0fd6afb);
    const $36bd602e9276dc31$export$78c874904ae250ac = 'state.actions.remove-label-from-article-failure.REMOVE_LABEL_FROM_ARTICLE_FAILURE';
    const $36bd602e9276dc31$export$b7ca01a9c0fd6afb = (payload)=>({
            payload: payload,
            type: $36bd602e9276dc31$export$78c874904ae250ac
        });
});
parcelRegister("6zk4x", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE", ()=>$ad606a0cff7a573c$export$f5f174c6323905d3);
    $parcel$export(module.exports, "updateCategoriesForArticleFailure", ()=>$ad606a0cff7a573c$export$4578d03141d71619);
    const $ad606a0cff7a573c$export$f5f174c6323905d3 = 'state.actions.update-categories-for-article-failure.UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE';
    const $ad606a0cff7a573c$export$4578d03141d71619 = (payload)=>({
            payload: payload,
            type: $ad606a0cff7a573c$export$f5f174c6323905d3
        });
});
parcelRegister("1hzgw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ecb51d5c83a378fb$export$2e2bcd8739ae039);
    var $fmcGe;
    var $ecb51d5c83a378fb$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: (0, (0, parcelRequire("fmcGe")).default).title,
            description: (0, (0, parcelRequire("fmcGe")).default).description
        });
});
parcelRegister("fmcGe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$372161f8a7552a21$export$2e2bcd8739ae039);
    var $7VHMR;
    var $372161f8a7552a21$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "servicedesk.knowledge-hub.flags.remove-label-from-article-failure.title",
            "defaultMessage": "We couldn\u2019t save the changes you made"
        },
        description: {
            "id": "servicedesk.knowledge-hub.flags.remove-label-from-article-failure.description",
            "defaultMessage": "Refresh the page and try again."
        }
    });
});
parcelRegister("6VTSZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53def11827375f52$export$2e2bcd8739ae039);
    var $kINlF;
    var $53def11827375f52$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: (0, (0, parcelRequire("kINlF")).default).title,
            description: (0, (0, parcelRequire("kINlF")).default).description
        });
});
parcelRegister("kINlF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f59c7a9bfc032690$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f59c7a9bfc032690$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "servicedesk.knowledge-hub.flags.update-categories-for-article-failure.title",
            "defaultMessage": "Article's categories not updated"
        },
        description: {
            "id": "servicedesk.knowledge-hub.flags.update-categories-for-article-failure.description",
            "defaultMessage": "We weren't able to update the article's categories. Try again in a minute."
        }
    });
});
parcelRegister("hYd1f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c850f2f9e57103ab$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $bdof7;
    var $eGP51;
    var $4DyVT;
    var $feRMu;
    var $kTAvA;
    var $bDRTj;
    var $cpM8i;
    var $a20m8;
    var $gTvcp;
    var $4JAV5;
    var $iYJ1l;
    var $92ShW;
    var $6OXm8;
    var $c850f2f9e57103ab$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("92ShW")).epic), (0, (0, parcelRequire("gTvcp")).epic), (0, (0, parcelRequire("cpM8i")).epic), (0, (0, parcelRequire("bDRTj")).epic), (0, (0, parcelRequire("a20m8")).epic), (0, (0, parcelRequire("4DyVT")).epic), (0, (0, parcelRequire("bdof7")).epic), (0, (0, parcelRequire("6OXm8")).epic), (0, (0, parcelRequire("4JAV5")).epic), (0, (0, parcelRequire("feRMu")).epic), (0, (0, parcelRequire("kTAvA")).epic), (0, (0, parcelRequire("eGP51")).epic), (0, (0, parcelRequire("iYJ1l")).epic));
});
parcelRegister("bdof7", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$8156adb89212081f$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $hhweD;
    var $cVUDi;
    var $fmmX1;
    var $5sKH1;
    var $5XgTr;
    var $6ovlC;
    var $gXg4u;
    var $gLt7z;
    const $8156adb89212081f$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("6ovlC")).ADD_CATEGORIES_FOR_ARTICLE)).mergeMap((action)=>{
            const { categoryIds: categoryIds, articleId: articleId, analyticsEvent: analyticsEvent, spaceKey: spaceKey } = action.payload;
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(store.getState());
            const currentCategoryIds = (0, (0, parcelRequire("gXg4u")).getCategoriesForArticle)(store.getState(), articleId).map((category)=>category.id);
            return (0, (0, parcelRequire("fmmX1")).addCategoriesForArticle)({
                projectId: projectId,
                categoryIds: categoryIds,
                articleId: articleId,
                spaceKey: spaceKey,
                activationId: activationId
            }).map(()=>{
                (0, (0, parcelRequire("hhweD")).fireTrackAnalytics)(analyticsEvent, {
                    action: 'update',
                    actionSubjectId: articleId
                });
                return (0, (0, parcelRequire("5XgTr")).addCategoriesForArticleSuccess)({
                    articleId: articleId,
                    categoryIds: categoryIds,
                    previousCategoryIds: currentCategoryIds
                });
            }).catch((error)=>{
                const { statusCode: statusCode, errorKey: errorKey, errorMessage: errorMessage, categories: categories } = error;
                (0, (0, parcelRequire("cVUDi")).fireCustomErrorAnalytics)({
                    error: error,
                    event: analyticsEvent,
                    id: 'articleUpdate Failure',
                    packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("5sKH1")).addCategoriesForArticleFailure)({
                    statusCode: statusCode,
                    errorKey: errorKey,
                    errorMessage: errorMessage,
                    failedCategoryIds: categories,
                    articleId: articleId
                }));
            });
        });
});
parcelRegister("fmmX1", function(module, exports) {
    $parcel$export(module.exports, "list", ()=>$0f36cff0fb97de2b$export$8837f4fc672e936d);
    $parcel$export(module.exports, "listCategoryArticles", ()=>$0f36cff0fb97de2b$export$897d9115a17b4c24);
    $parcel$export(module.exports, "getArticleWithExpandParams", ()=>$0f36cff0fb97de2b$export$fb27d96404fd219d);
    $parcel$export(module.exports, "addCategoriesForArticle", ()=>$0f36cff0fb97de2b$export$d93a983139fde0cc);
    $parcel$export(module.exports, "updateCategoriesForArticle", ()=>$0f36cff0fb97de2b$export$2613b83c3141003a);
    $parcel$export(module.exports, "getAllLinkedSpaces", ()=>$0f36cff0fb97de2b$export$6f4beca8ff3702f3);
    $parcel$export(module.exports, "addLabelsToArticles", ()=>$0f36cff0fb97de2b$export$f40640db2a9b7e80);
    $parcel$export(module.exports, "removeLabelsFromArticles", ()=>$0f36cff0fb97de2b$export$cba6b78bbfb96381);
    $parcel$export(module.exports, "fetchLabelSuggestions", ()=>$0f36cff0fb97de2b$export$8502c8a97aecfbad);
    $parcel$export(module.exports, "fetchArticleEditPermission", ()=>$0f36cff0fb97de2b$export$65396ff44dade790);
    parcelRequire("3q49N");
    parcelRequire("c66Ur");
    parcelRequire("d0pqD");
    var $ebyGx = parcelRequire("ebyGx");
    var $kVLXA = parcelRequire("kVLXA");
    var $7f4tk;
    var $5OrSA;
    var $2Lj35;
    const $0f36cff0fb97de2b$var$replaceArticleNullsWithUndefined = (article)=>{
        const parsedArticle = {
            ...article
        };
        if (parsedArticle.viewCount === null) parsedArticle.viewCount = undefined;
        if (parsedArticle.categories === null) parsedArticle.categories = undefined;
        if (parsedArticle.featuredInCategories === null) parsedArticle.featuredInCategories = undefined;
        return parsedArticle;
    };
    const $0f36cff0fb97de2b$var$transformArticleResponse = (articleResponse)=>{
        let bodyAdf;
        if (articleResponse.body) bodyAdf = JSON.parse(articleResponse.body);
        const transformedData = {
            ...articleResponse,
            body: bodyAdf
        };
        return $0f36cff0fb97de2b$var$replaceArticleNullsWithUndefined(transformedData);
    };
    const $0f36cff0fb97de2b$var$getQueryString = (opts)=>{
        const { expand: expand, ...otherOpts } = opts;
        if (expand) return (0, $ebyGx.stringify)({
            ...otherOpts,
            expand: expand.join(',')
        });
        return (0, $ebyGx.stringify)(otherOpts);
    };
    const $0f36cff0fb97de2b$export$8837f4fc672e936d = (projectId, opts, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const queryString = $0f36cff0fb97de2b$var$getQueryString(opts);
        const apiPath = `/api/project/${projectId}/article?${queryString}`;
        const url = `${apolloPath}/${activationId}${apiPath}`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(url).map((response)=>({
                ...response,
                results: response.results.map($0f36cff0fb97de2b$var$transformArticleResponse)
            }));
    };
    const $0f36cff0fb97de2b$export$897d9115a17b4c24 = (projectId, categoryId, opts, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const queryString = $0f36cff0fb97de2b$var$getQueryString(opts);
        const apiPath = `/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}/article?${queryString}`;
        const url = `${apolloPath}/${activationId}${apiPath}`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(url).map((response)=>({
                ...response,
                results: response.results.map($0f36cff0fb97de2b$var$transformArticleResponse)
            }));
    };
    const $0f36cff0fb97de2b$export$f8c0d0a39b0d7d4e = (projectId, articleId, withCategory, apolloPath = (0, $45c806b56a43da0e$export$8ce6d23ffa1a190a))=>{
        const url = `${apolloPath}/api/project/${projectId}/article/${articleId}`;
        const queryString = withCategory ? `?${(0, $ebyGx.stringify)({
            expand: 'category'
        })}` : '';
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${url}${queryString}`).map($0f36cff0fb97de2b$var$transformArticleResponse);
    };
    const $0f36cff0fb97de2b$export$fb27d96404fd219d = (projectId, articleId, activationId, expandParams, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const url = `${apolloPath}/${activationId}/api/project/${projectId}/article/${articleId}`;
        const queryString = expandParams.length ? `?${$0f36cff0fb97de2b$var$getQueryString({
            expand: expandParams
        })}` : '';
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${url}${queryString}`).map($0f36cff0fb97de2b$var$transformArticleResponse);
    };
    const $0f36cff0fb97de2b$export$d93a983139fde0cc = ({ projectId: projectId, categoryIds: categoryIds, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        const url = `${apolloPath}/${activationId}/api/project/${projectId}/space/${spaceKey}/article/${articleId}/category`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(url, {
            method: 'PATCH',
            body: JSON.stringify({
                categories: categoryIds
            })
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $0f36cff0fb97de2b$export$2613b83c3141003a = ({ projectId: projectId, categoryIds: categoryIds, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        const url = `${apolloPath}/${activationId}/api/project/${projectId}/article/${articleId}/category`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(url, {
            method: 'PUT',
            body: JSON.stringify({
                spaceKey: spaceKey,
                categories: categoryIds
            })
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $0f36cff0fb97de2b$export$6f4beca8ff3702f3 = (projectKey)=>{
        const url = `/rest/servicedesk/1/servicedesk/${projectKey}/kb`;
        const transformedResponse = (0, (0, parcelRequire("5OrSA")).fetchJson$)(url).map((response)=>({
                spaces: response.map((space)=>({
                        name: space.spaceName,
                        key: space.spaceKey,
                        appLinkId: space.appLinkId
                    }))
            }));
        return transformedResponse;
    };
    const $0f36cff0fb97de2b$export$f40640db2a9b7e80 = ({ projectId: projectId, labels: labels, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        const url = `${apolloPath}/${activationId}/api/project/${projectId}/space/${spaceKey}/article/${articleId}/label`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(url, {
            method: 'POST',
            body: JSON.stringify(labels)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $0f36cff0fb97de2b$export$cba6b78bbfb96381 = ({ projectId: projectId, label: label, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        const url = `${apolloPath}/${activationId}/api/project/${projectId}/space/${spaceKey}/article/${articleId}/label/${encodeURIComponent(label)}`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(url, {
            method: 'DELETE'
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $0f36cff0fb97de2b$export$8502c8a97aecfbad = (projectKey, queryString, articleId)=>{
        const url = `/rest/servicedesk/1/servicedesk/${projectKey}/kb/labels?query=${queryString}&contentId=${articleId}`;
        return (0, (0, parcelRequire("7f4tk")).default)(url).then(({ contentNameMatches: contentNameMatches })=>{
            if (!contentNameMatches?.length) return [];
            const suggestions = contentNameMatches.reduce((labelList, contentNameMatch)=>{
                if (contentNameMatch.length) return [
                    ...labelList,
                    ...contentNameMatch
                ];
                return labelList;
            }, []);
            return suggestions.length ? suggestions.map(({ name: name })=>({
                    label: name,
                    value: name
                })) : [];
        }).catch(()=>[]);
    };
    const $0f36cff0fb97de2b$export$65396ff44dade790 = (cloudId, articleId, projectId, accountId, sendCustomHeaders, spaceKey)=>{
        const body = {
            subject: {
                type: 'user',
                identifier: accountId
            },
            operation: 'update'
        };
        const headers = sendCustomHeaders ? {
            'Content-Type': 'application/json',
            'X-ATL-EmbeddablePage-EntityIds': JSON.stringify({
                spaceKey: spaceKey || '',
                parentProduct: 'JSM',
                parentProductContentContainerId: projectId,
                contentId: articleId
            })
        } : {
            'Content-Type': 'application/json'
        };
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/api/content/${articleId}/permission/check`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        }).catch((error)=>(0, $kVLXA.Observable).throw(error));
    };
});
parcelRegister("5XgTr", function(module, exports) {
    $parcel$export(module.exports, "ADD_CATEGORIES_FOR_ARTICLE_SUCCESS", ()=>$b60bbe4f4c92ec4f$export$6698bb1ac5b8cbe2);
    $parcel$export(module.exports, "addCategoriesForArticleSuccess", ()=>$b60bbe4f4c92ec4f$export$deab1340d30ad632);
    const $b60bbe4f4c92ec4f$export$6698bb1ac5b8cbe2 = 'state.actions.add-categories-for-article-success.ADD_CATEGORIES_FOR_ARTICLE_SUCCESS';
    const $b60bbe4f4c92ec4f$export$deab1340d30ad632 = (payload)=>({
            payload: payload,
            type: $b60bbe4f4c92ec4f$export$6698bb1ac5b8cbe2
        });
});
parcelRegister("6ovlC", function(module, exports) {
    $parcel$export(module.exports, "ADD_CATEGORIES_FOR_ARTICLE", ()=>$5b88d8b66d98e99f$export$c22494f1249599aa);
    $parcel$export(module.exports, "addCategoriesForArticle", ()=>$5b88d8b66d98e99f$export$d93a983139fde0cc);
    const $5b88d8b66d98e99f$export$c22494f1249599aa = 'state.actions.add-categories-for-article.ADD_CATEGORIES_FOR_ARTICLE';
    const $5b88d8b66d98e99f$export$d93a983139fde0cc = (payload)=>({
            payload: payload,
            type: $5b88d8b66d98e99f$export$c22494f1249599aa
        });
});
const $aaa081f4160162a5$export$b8b9d90f9e5bd72b = 'jiraServiceDeskKnowledgeHub';
parcelRegister("eGP51", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$b7199b09d6315b91$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $8zOmE;
    var $cVUDi;
    var $fmmX1;
    var $e8y9X;
    var $8j0bg;
    var $80A0Z;
    var $gLt7z;
    const $b7199b09d6315b91$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("80A0Z")).ADD_LABELS_TO_ARTICLE)).mergeMap((action)=>{
            const { labels: labels, articleId: articleId, spaceKey: spaceKey, analyticsEvent: analyticsEvent } = action.payload;
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(store.getState());
            return (0, (0, parcelRequire("fmmX1")).addLabelsToArticles)({
                projectId: projectId,
                labels: labels,
                articleId: articleId,
                spaceKey: spaceKey,
                activationId: activationId
            }).map((response)=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'onAddLabels success', {
                    articleId: articleId
                });
                return (0, (0, parcelRequire("8j0bg")).addLabelsToArticleSuccess)(response);
            }).catch((error)=>{
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, 'onAddLabelsFailure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("e8y9X")).addLabelsToArticleFailure)({
                    articleId: articleId
                }));
            });
        });
});
parcelRegister("e8y9X", function(module, exports) {
    $parcel$export(module.exports, "ADD_LABELS_TO_ARTICLE_FAILURE", ()=>$68db2bd167d08867$export$836fc3274a0c8c08);
    $parcel$export(module.exports, "addLabelsToArticleFailure", ()=>$68db2bd167d08867$export$46974ef034e5e1ff);
    const $68db2bd167d08867$export$836fc3274a0c8c08 = 'state.actions.add-labels-to-article-failure.ADD_LABELS_TO_ARTICLE_FAILURE';
    const $68db2bd167d08867$export$46974ef034e5e1ff = (payload)=>({
            payload: payload,
            type: $68db2bd167d08867$export$836fc3274a0c8c08
        });
});
parcelRegister("8j0bg", function(module, exports) {
    $parcel$export(module.exports, "ADD_LABELS_TO_ARTICLE_SUCCESS", ()=>$7cdb79ea2b68767f$export$fb41ea70dd3d20e7);
    $parcel$export(module.exports, "addLabelsToArticleSuccess", ()=>$7cdb79ea2b68767f$export$1d48c14841a2dd90);
    const $7cdb79ea2b68767f$export$fb41ea70dd3d20e7 = 'state.actions.add-labels-to-article-success.ADD_LABELS_TO_ARTICLE_SUCCESS';
    const $7cdb79ea2b68767f$export$1d48c14841a2dd90 = (payload)=>({
            payload: payload,
            type: $7cdb79ea2b68767f$export$fb41ea70dd3d20e7
        });
});
parcelRegister("80A0Z", function(module, exports) {
    $parcel$export(module.exports, "ADD_LABELS_TO_ARTICLE", ()=>$f87c53beb7b3ea22$export$2b91058f81222c91);
    $parcel$export(module.exports, "addLabelsToArticle", ()=>$f87c53beb7b3ea22$export$335c057b91702017);
    const $f87c53beb7b3ea22$export$2b91058f81222c91 = 'state.actions.add-labels-to-article.ADD_LABELS_TO_ARTICLE';
    const $f87c53beb7b3ea22$export$335c057b91702017 = (payload)=>({
            payload: payload,
            type: $f87c53beb7b3ea22$export$2b91058f81222c91
        });
});
parcelRegister("4DyVT", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$01135ff527d8b512$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $8zOmE;
    var $cVUDi;
    var $i4zGm;
    var $33YKl;
    var $4VDwv;
    var $kHzxc;
    var $gLt7z;
    var $fhG9v;
    const $01135ff527d8b512$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("kHzxc")).BROWSE_KNOWLEDGE)).mergeMap((action)=>{
            const page = action.payload.page || 1;
            const state = store.getState();
            const limit = action.payload.limit || (0, (0, parcelRequire("fhG9v")).getBrowseLimit)(state);
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(state);
            const spaceKey = action.payload.spaceKey ?? '';
            const cursor = action.payload.cursor ?? '';
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(state);
            let requestParams = {
                categoryId: action.payload.id,
                expand: action.payload.expand,
                orderby: action.payload.orderBy,
                limit: limit
            };
            const query = action.payload.query != null ? action.payload.query : '';
            if (query) requestParams = {
                ...requestParams,
                query: query
            };
            if (spaceKey) requestParams = {
                ...requestParams,
                spaceKey: spaceKey
            };
            if (cursor) requestParams = {
                ...requestParams,
                cursor: cursor
            };
            const { createAnalyticsEvent: createAnalyticsEvent } = action.payload;
            const EVENT_NAME = requestParams.categoryId !== 'all-articles' ? 'browseArticleInCategory' : 'browseArticles';
            return (0, (0, parcelRequire("i4zGm")).list)(projectId, activationId, requestParams).map((response)=>{
                if (createAnalyticsEvent) {
                    const analyticsEvent = createAnalyticsEvent({});
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${EVENT_NAME} success`, {
                        projectId: projectId
                    });
                }
                return (0, (0, parcelRequire("4VDwv")).browseKnowledgeSuccess)({
                    id: action.payload.id,
                    ...response,
                    page: page
                });
            }).catch((error)=>{
                const { statusCode: statusCode } = error;
                if (createAnalyticsEvent) (0, (0, parcelRequire("cVUDi")).fireCustomErrorAnalytics)({
                    error: error,
                    event: createAnalyticsEvent({}),
                    id: `${EVENT_NAME} failure`,
                    packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("33YKl")).browseKnowledgeFailure)({
                    id: action.payload.id,
                    page: page,
                    statusCode: statusCode
                }));
            });
        });
});
parcelRegister("i4zGm", function(module, exports) {
    $parcel$export(module.exports, "list", ()=>$45a2c0bfdac04a79$export$8837f4fc672e936d);
    $parcel$export(module.exports, "linkedSpaces", ()=>$45a2c0bfdac04a79$export$d3636d9abefdd232);
    var $fmmX1;
    const $45a2c0bfdac04a79$export$8837f4fc672e936d = (projectId, activationId, { categoryId: categoryId, ...opts })=>{
        if (categoryId === 'all-articles') return (0, (0, parcelRequire("fmmX1")).list)(projectId, opts, activationId);
        return (0, (0, parcelRequire("fmmX1")).listCategoryArticles)(projectId, categoryId, opts, activationId);
    };
    const $45a2c0bfdac04a79$export$d3636d9abefdd232 = (projectKey)=>(0, (0, parcelRequire("fmmX1")).getAllLinkedSpaces)(projectKey);
});
parcelRegister("33YKl", function(module, exports) {
    $parcel$export(module.exports, "BROWSE_KNOWLEDGE_FAILURE", ()=>$da91aed3c1c538b9$export$be396dbd2f8b61b5);
    $parcel$export(module.exports, "browseKnowledgeFailure", ()=>$da91aed3c1c538b9$export$a84d455b463b93e5);
    var $dMhXw;
    const $da91aed3c1c538b9$export$be396dbd2f8b61b5 = 'state.actions.browse-knowledge-failure.BROWSE_KNOWLEDGE_FAILURE';
    const $da91aed3c1c538b9$export$a84d455b463b93e5 = (opts)=>({
            type: $da91aed3c1c538b9$export$be396dbd2f8b61b5,
            payload: {
                id: opts.id,
                page: opts.page,
                error: {
                    message: (0, (0, parcelRequire("dMhXw")).default).genericMessage,
                    header: (0, (0, parcelRequire("dMhXw")).default).genericHeader
                }
            }
        });
});
parcelRegister("dMhXw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$060d0dd30f30d38c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $060d0dd30f30d38c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        genericHeader: {
            "id": "servicedesk.knowledge-hub.state.actions.browse-knowledge-failure.generic-header",
            "defaultMessage": "Something went wrong"
        },
        genericMessage: {
            "id": "servicedesk.knowledge-hub.state.actions.browse-knowledge-failure.generic-message",
            "defaultMessage": "We couldn't load the articles. Please refresh and try again."
        }
    });
});
parcelRegister("4VDwv", function(module, exports) {
    $parcel$export(module.exports, "BROWSE_KNOWLEDGE_SUCCESS", ()=>$fdd461c5c2f5f7b7$export$b9ec4df681504dbb);
    $parcel$export(module.exports, "browseKnowledgeSuccess", ()=>$fdd461c5c2f5f7b7$export$9cfc1cc1cc8e3e0d);
    const $fdd461c5c2f5f7b7$export$b9ec4df681504dbb = 'state.actions.browse-knowledge-success.BROWSE_KNOWLEDGE_SUCCESS';
    const $fdd461c5c2f5f7b7$export$9cfc1cc1cc8e3e0d = (payload)=>({
            type: $fdd461c5c2f5f7b7$export$b9ec4df681504dbb,
            payload: payload
        });
});
parcelRegister("kHzxc", function(module, exports) {
    $parcel$export(module.exports, "BROWSE_KNOWLEDGE", ()=>$e17bf0108bb950f1$export$8b6d2338550bad51);
    $parcel$export(module.exports, "browseKnowledge", ()=>$e17bf0108bb950f1$export$66132e21cee3da17);
    const $e17bf0108bb950f1$export$8b6d2338550bad51 = 'state.actions.browse-knowledge.BROWSE_KNOWLEDGE';
    const $e17bf0108bb950f1$export$66132e21cee3da17 = (payload)=>({
            type: $e17bf0108bb950f1$export$8b6d2338550bad51,
            payload: payload
        });
});
parcelRegister("fhG9v", function(module, exports) {
    $parcel$export(module.exports, "getArticleIdsForCategory", ()=>$da36dd250036e782$export$bb874ade4016b878);
    $parcel$export(module.exports, "getCategoryTotalSize", ()=>$da36dd250036e782$export$165fede49970bd0c);
    $parcel$export(module.exports, "getBrowseLimit", ()=>$da36dd250036e782$export$adc0ce73adb3dc4a);
    $parcel$export(module.exports, "getBrowseNextCursor", ()=>$da36dd250036e782$export$4b2e4efe9c0df2cd);
    $parcel$export(module.exports, "getBrowsePrevCursor", ()=>$da36dd250036e782$export$f7e999777526d95e);
    $parcel$export(module.exports, "isCategoriesSupported", ()=>$da36dd250036e782$export$cfb809beeaa82062);
    $parcel$export(module.exports, "isBrowseLoading", ()=>$da36dd250036e782$export$aecf0fb6e785d5e0);
    $parcel$export(module.exports, "getArticlesLoading", ()=>$da36dd250036e782$export$327a4e3439ce6c6a);
    const $da36dd250036e782$export$bb874ade4016b878 = (state, categoryId, page = 1)=>state.entities.browse[categoryId] ? state.entities.browse[categoryId].pages[`${page}`] : undefined;
    const $da36dd250036e782$export$165fede49970bd0c = (state, categoryId)=>state.entities.browse[categoryId].totalSize;
    const $da36dd250036e782$export$adc0ce73adb3dc4a = (state)=>state.entities.browse.limit;
    const $da36dd250036e782$export$4b2e4efe9c0df2cd = (state, categoryId)=>state.entities.browse[categoryId] != null ? state.entities.browse[categoryId].nextCursor ?? '' : '';
    const $da36dd250036e782$export$f7e999777526d95e = (state, categoryId)=>state.entities.browse[categoryId] != null ? state.entities.browse[categoryId].prevCursor ?? '' : '';
    const $da36dd250036e782$export$cfb809beeaa82062 = (state, categoryId)=>state.entities.browse[categoryId] != null ? state.entities.browse[categoryId].categoriesSupported ?? true : true;
    const $da36dd250036e782$export$aecf0fb6e785d5e0 = (state, categoryId)=>state.entities.browse[categoryId] === undefined;
    const $da36dd250036e782$export$327a4e3439ce6c6a = (state)=>!!state.entities.browse.loading;
});
parcelRegister("feRMu", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$40f3d7cc48e99b60$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $jrkeZ;
    var $6FRaa;
    var $aZdbu;
    var $gMZw6;
    var $gLt7z;
    const $40f3d7cc48e99b60$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("gMZw6")).FETCH_APPLINK)).mergeMap(()=>{
            const projectKey = (0, (0, parcelRequire("gLt7z")).getProjectKey)(store.getState());
            return (0, (0, parcelRequire("jrkeZ")).fetchCurrentAppLink)(projectKey).mergeMap((appLink)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("aZdbu")).fetchAppLinkSuccess)(appLink))).catch(({ statusCode: statusCode })=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("6FRaa")).fetchAppLinkFailure)({
                    statusCode: statusCode
                })));
        });
});
parcelRegister("jrkeZ", function(module, exports) {
    $parcel$export(module.exports, "fetchConfluenceAppLinks", ()=>$75401d703e62a5e6$export$411bec8e101d37ea);
    $parcel$export(module.exports, "fetchCurrentAppLink", ()=>$75401d703e62a5e6$export$f1e8c76efca169f3);
    $parcel$export(module.exports, "fetchCurrentAppLinkV2", ()=>$75401d703e62a5e6$export$a5d48ab772ff4e41);
    $parcel$export(module.exports, "fetchConfluenceLink", ()=>$75401d703e62a5e6$export$1eeb53c23f99ec16);
    $parcel$export(module.exports, "fetchConfluenceLinkRestful", ()=>$75401d703e62a5e6$export$c71d13c885efd437);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("3q49N");
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    var $7f4tk;
    var $kTM7r;
    var $5QK3R;
    const $75401d703e62a5e6$export$411bec8e101d37ea = (projectKey)=>(0, (0, parcelRequire("5QK3R")).fetchAppLinkNoEyeball)(projectKey);
    const $75401d703e62a5e6$export$916391fe3383489b = (projectKey)=>(0, (0, parcelRequire("5QK3R")).fetchAppLinkNoEyeball)(projectKey).map((data)=>data.appLinks.find((link)=>link.isSystem));
    const $75401d703e62a5e6$export$f1e8c76efca169f3 = (projectKey)=>(0, (0, parcelRequire("5QK3R")).fetchCurrentAppLinkNoEyeball)(projectKey);
    const $75401d703e62a5e6$export$a5d48ab772ff4e41 = (projectKey)=>(0, (0, parcelRequire("5QK3R")).fetchCurrentAppLinkNoEyeballV2)(projectKey);
    const $75401d703e62a5e6$export$1eeb53c23f99ec16 = (projectKey)=>{
        const kbLink = (0, (0, parcelRequire("kTM7r")).wrmClaimSafe)('sd-kb-link');
        if (kbLink) {
            if (kbLink && !kbLink.error) return (0, $kVLXA.Observable).of({
                projectKey: projectKey,
                id: kbLink.id,
                spaceKey: kbLink.spaceKey,
                baseUrl: kbLink.baseUrl
            });
            if (kbLink && kbLink.error) return (0, $kVLXA.Observable).throw(kbLink);
        }
        return (0, $kVLXA.Observable).throw({
            error: {
                key: 'sd.applinks.error.corrupt'
            }
        });
    };
    const $75401d703e62a5e6$var$ERROR_KEY_MAP = {
        '404': 'sd.kb.link.error.link.not.found',
        other: 'sd.applinks.error.corrupt'
    };
    const $75401d703e62a5e6$export$c71d13c885efd437 = (projectKey)=>{
        const url = `/rest/servicedesk/1/pages/agent/knowledge/${projectKey}`;
        return (0, (0, parcelRequire("7f4tk")).default)(url).catch((err)=>Promise.reject({
                error: {
                    key: $75401d703e62a5e6$var$ERROR_KEY_MAP[err.statusCode] || $75401d703e62a5e6$var$ERROR_KEY_MAP.other
                }
            }));
    };
});
parcelRegister("kTM7r", function(module, exports) {
    $parcel$export(module.exports, "wrmClaimSafe", ()=>$7a3f570973700129$export$6d04651d170462ec);
    const $7a3f570973700129$export$6d04651d170462ec = (key)=>{
        window.wrmDataCache = window.wrmDataCache || {};
        if (window.wrmDataCache[key]) return window.wrmDataCache[key];
        const data = window.WRM.data.claim(key);
        window.wrmDataCache[key] = data;
        return data;
    };
    const $7a3f570973700129$export$460d685a9ee326a8 = (key)=>{
        const claimedData = window.WRM.data.claim(key);
        if (claimedData === undefined) throw new Error(`Could not find WRM data for key: ${key}`);
        return claimedData;
    };
});
parcelRegister("5QK3R", function(module, exports) {
    $parcel$export(module.exports, "fetchAppLinkNoEyeball", ()=>$00051febdde61fec$export$d888e54a19706e84);
    $parcel$export(module.exports, "fetchCurrentAppLinkNoEyeball", ()=>$00051febdde61fec$export$91f2ef831add2534);
    $parcel$export(module.exports, "fetchCurrentAppLinkNoEyeballV2", ()=>$00051febdde61fec$export$2727b4e442c6787f);
    var $7f4tk;
    var $5OrSA;
    const $00051febdde61fec$export$d888e54a19706e84 = (projectKey)=>(0, (0, parcelRequire("5OrSA")).fetchJson$)(`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence`);
    const $00051febdde61fec$export$91f2ef831add2534 = (projectKey)=>(0, (0, parcelRequire("5OrSA")).fetchJson$)(`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence/current`);
    const $00051febdde61fec$export$2727b4e442c6787f = (projectKey)=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence/current`);
});
parcelRegister("6FRaa", function(module, exports) {
    $parcel$export(module.exports, "FETCH_APPLINK_FAILURE", ()=>$5c0435e88e4a5ddc$export$1763acbd33c374e5);
    $parcel$export(module.exports, "fetchAppLinkFailure", ()=>$5c0435e88e4a5ddc$export$635f69357a47e715);
    const $5c0435e88e4a5ddc$export$1763acbd33c374e5 = 'state.actions.fetch-applink-failure.FETCH_APPLINK_FAILURE';
    const $5c0435e88e4a5ddc$export$635f69357a47e715 = (error)=>({
            type: $5c0435e88e4a5ddc$export$1763acbd33c374e5,
            payload: error
        });
});
parcelRegister("aZdbu", function(module, exports) {
    $parcel$export(module.exports, "FETCH_APPLINK_SUCCESS", ()=>$cada50d61c624db3$export$5a66f7b0b7a57504);
    $parcel$export(module.exports, "fetchAppLinkSuccess", ()=>$cada50d61c624db3$export$d64417727a56e7f1);
    const $cada50d61c624db3$export$5a66f7b0b7a57504 = 'state.actions.fetch-applink-success.FETCH_APPLINK_SUCCESS';
    const $cada50d61c624db3$export$d64417727a56e7f1 = (payload)=>({
            type: $cada50d61c624db3$export$5a66f7b0b7a57504,
            payload: payload
        });
});
parcelRegister("kTAvA", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$034fe31e006c1c0e$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $jrkeZ;
    var $3XkGj;
    var $7GY3F;
    var $4dXi2;
    var $gLt7z;
    const $034fe31e006c1c0e$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("4dXi2")).FETCH_APPLINKS)).mergeMap(()=>{
            const projectKey = (0, (0, parcelRequire("gLt7z")).getProjectKey)(store.getState());
            return (0, (0, parcelRequire("jrkeZ")).fetchConfluenceAppLinks)(projectKey).mergeMap((appLinks)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("7GY3F")).fetchAppLinksSuccess)(appLinks.appLinks))).catch(({ statusCode: statusCode })=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("3XkGj")).fetchAppLinksFailure)({
                    statusCode: statusCode
                })));
        });
});
parcelRegister("3XkGj", function(module, exports) {
    $parcel$export(module.exports, "FETCH_APPLINKS_FAILURE", ()=>$daac65f7a8dc65e2$export$51c9d05978c1783b);
    $parcel$export(module.exports, "fetchAppLinksFailure", ()=>$daac65f7a8dc65e2$export$c460ed087c66a41d);
    const $daac65f7a8dc65e2$export$51c9d05978c1783b = 'state.actions.fetch-applinks-failure.FETCH_APPLINKS_FAILURE';
    const $daac65f7a8dc65e2$export$c460ed087c66a41d = (error)=>({
            type: $daac65f7a8dc65e2$export$51c9d05978c1783b,
            payload: error
        });
});
parcelRegister("7GY3F", function(module, exports) {
    $parcel$export(module.exports, "FETCH_APPLINKS_SUCCESS", ()=>$81371e274ff768f8$export$de0056b0bbdd21c8);
    $parcel$export(module.exports, "fetchAppLinksSuccess", ()=>$81371e274ff768f8$export$56072929934471cd);
    const $81371e274ff768f8$export$de0056b0bbdd21c8 = 'state.actions.fetch-applinks-success.FETCH_APPLINKS_SUCCESS';
    const $81371e274ff768f8$export$56072929934471cd = (payload)=>({
            type: $81371e274ff768f8$export$de0056b0bbdd21c8,
            payload: payload
        });
});
parcelRegister("4dXi2", function(module, exports) {
    $parcel$export(module.exports, "FETCH_APPLINKS", ()=>$01bf9f555ca0b395$export$e7bce13a560ead5e);
    $parcel$export(module.exports, "fetchAppLinks", ()=>$01bf9f555ca0b395$export$ee72e8e00b4fb176);
    const $01bf9f555ca0b395$export$e7bce13a560ead5e = 'state.actions.fetch-applinks.FETCH_APPLINKS';
    const $01bf9f555ca0b395$export$ee72e8e00b4fb176 = ()=>({
            type: $01bf9f555ca0b395$export$e7bce13a560ead5e
        });
});
parcelRegister("bDRTj", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$90f2b96f2a0068c3$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $8zOmE;
    var $cVUDi;
    var $fmmX1;
    var $39oW5;
    var $fTBH5;
    var $gLt7z;
    const $90f2b96f2a0068c3$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("39oW5")).FETCH_ARTICLE_EDIT_PERMISSION)).mergeMap((action)=>{
            const { id: id, accountId: accountId, createAnalyticsEvent: createAnalyticsEvent, spaceKey: spaceKey } = action.payload;
            const cloudId = (0, (0, parcelRequire("gLt7z")).getCloudId)(store.getState());
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            return (0, (0, parcelRequire("fmmX1")).fetchArticleEditPermission)(cloudId, id, projectId, accountId, true, spaceKey).mergeMap(({ hasPermission: hasPermission })=>{
                const analyticsEvent = createAnalyticsEvent({});
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'onFetchArticleEditPermission success', {
                    articleId: id
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("fTBH5")).setArticleEditPermission)(hasPermission, id));
            }).catch((error)=>{
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, 'onFetchArticleEditPermission failure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("fTBH5")).setArticleEditPermission)(false, id));
            });
        });
});
parcelRegister("39oW5", function(module, exports) {
    $parcel$export(module.exports, "FETCH_ARTICLE_EDIT_PERMISSION", ()=>$21d9f874c3cb8395$export$2f278bb19228e406);
    $parcel$export(module.exports, "fetchArticleEditPermission", ()=>$21d9f874c3cb8395$export$65396ff44dade790);
    const $21d9f874c3cb8395$export$2f278bb19228e406 = 'state.actions.fetch-article-edit-permission.FETCH_ARTICLE_EDIT_PERMISSION';
    const $21d9f874c3cb8395$export$65396ff44dade790 = (id, accountId, createAnalyticsEvent, spaceKey)=>({
            type: $21d9f874c3cb8395$export$2f278bb19228e406,
            payload: {
                id: id,
                spaceKey: spaceKey,
                accountId: accountId,
                createAnalyticsEvent: createAnalyticsEvent
            }
        });
});
parcelRegister("fTBH5", function(module, exports) {
    $parcel$export(module.exports, "SET_ARTICLE_EDIT_PERMISSION", ()=>$9fa31b3f751a812f$export$b3431c0d5e84092c);
    $parcel$export(module.exports, "setArticleEditPermission", ()=>$9fa31b3f751a812f$export$bb3e34eb2358e906);
    const $9fa31b3f751a812f$export$b3431c0d5e84092c = 'state.actions.set-article-edit-permission.SET_ARTICLE_EDIT_PERMISSION';
    const $9fa31b3f751a812f$export$bb3e34eb2358e906 = (isEditable, articleId)=>({
            type: $9fa31b3f751a812f$export$b3431c0d5e84092c,
            payload: {
                isEditable: isEditable,
                articleId: articleId
            }
        });
});
parcelRegister("cpM8i", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$f95e339a734ecb5c$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("jFVZ1");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $cVUDi;
    var $fmmX1;
    var $39oW5;
    var $4C8gV;
    var $agxSw;
    var $la4EY;
    var $gLt7z;
    const $f95e339a734ecb5c$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("la4EY")).FETCH_ARTICLE)).mergeMap((action)=>{
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(store.getState());
            const { id: id, accountId: accountId, createAnalyticsEvent: createAnalyticsEvent } = action.payload;
            const getArticleObservable = (0, (0, parcelRequire("fmmX1")).getArticleWithExpandParams)(projectId, id, activationId, [
                'category',
                'labels'
            ]);
            return getArticleObservable.mergeMap((article)=>(0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, (0, parcelRequire("agxSw")).fetchArticleSuccess)(article)), (0, $kVLXA.Observable).of((0, (0, parcelRequire("39oW5")).fetchArticleEditPermission)(id, accountId, createAnalyticsEvent, article.spaceKey || '')))).catch((error)=>{
                (0, (0, parcelRequire("cVUDi")).fireCustomErrorAnalytics)({
                    error: error,
                    event: createAnalyticsEvent({}),
                    id: 'fetchArticle failure',
                    packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("4C8gV")).fetchArticleFailure)({
                    id: id,
                    statusCode: error.statusCode
                }));
            });
        });
});
parcelRegister("4C8gV", function(module, exports) {
    $parcel$export(module.exports, "FETCH_ARTICLE_FAILURE", ()=>$e3473a94e4383912$export$862d1fc538bf047c);
    $parcel$export(module.exports, "fetchArticleFailure", ()=>$e3473a94e4383912$export$b135c19fc249d3ab);
    var $4zIHa;
    const $e3473a94e4383912$export$862d1fc538bf047c = 'state.actions.fetch-article-failure.FETCH_ARTICLE_FAILURE';
    const $e3473a94e4383912$export$b135c19fc249d3ab = (opts)=>({
            type: $e3473a94e4383912$export$862d1fc538bf047c,
            payload: {
                id: opts.id,
                error: opts.statusCode === 404 ? {
                    message: (0, (0, parcelRequire("4zIHa")).default).notFoundMessage,
                    header: (0, (0, parcelRequire("4zIHa")).default).notFoundHeader,
                    ctaText: (0, (0, parcelRequire("4zIHa")).default).genericSearchCta,
                    ctaLink: '/knowledge'
                } : {
                    message: (0, (0, parcelRequire("4zIHa")).default).genericMessage,
                    header: (0, (0, parcelRequire("4zIHa")).default).genericHeader,
                    ctaText: (0, (0, parcelRequire("4zIHa")).default).genericSearchCta,
                    ctaLink: '/knowledge'
                }
            }
        });
});
parcelRegister("4zIHa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1714dd9e0ac9ecf4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1714dd9e0ac9ecf4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        notFoundHeader: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.not-found-header",
            "defaultMessage": "Can't find this article"
        },
        notFoundMessage: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.not-found-message",
            "defaultMessage": "You may not have permission to view this article, you may not have permission to access Confluence, or this article may not exist."
        },
        genericHeader: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-header",
            "defaultMessage": "Something went wrong"
        },
        genericMessage: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-message",
            "defaultMessage": "We couldn't load this article. Please refresh after a few minutes."
        },
        genericSearchCta: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-article-failure.generic-search-cta",
            "defaultMessage": "Browse all articles"
        }
    });
});
parcelRegister("agxSw", function(module, exports) {
    $parcel$export(module.exports, "FETCH_ARTICLE_SUCCESS", ()=>$345896be0e3d6472$export$2d213dcac7fc3339);
    $parcel$export(module.exports, "fetchArticleSuccess", ()=>$345896be0e3d6472$export$6910c63a4b3017af);
    const $345896be0e3d6472$export$2d213dcac7fc3339 = 'state.actions.fetch-article-success.FETCH_ARTICLE_SUCCESS';
    const $345896be0e3d6472$export$6910c63a4b3017af = (payload)=>({
            type: $345896be0e3d6472$export$2d213dcac7fc3339,
            payload: payload
        });
});
parcelRegister("a20m8", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$e17a2d6c79b83d30$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $8zOmE;
    var $cVUDi;
    var $guSo6;
    var $4COnH;
    var $7gdJb;
    var $jpaaK;
    var $gLt7z;
    const $e17a2d6c79b83d30$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("jpaaK")).FETCH_CATEGORIES)).mergeMap((action)=>{
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            const { analyticsEvent: analyticsEvent } = action.payload;
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(store.getState());
            return (0, (0, parcelRequire("guSo6")).listCategories)(projectId, activationId).mergeMap((categories)=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'onFetchCategories success', {
                    projectId: projectId
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("7gdJb")).fetchCategoriesSuccess)(categories));
            }).catch((error)=>{
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, 'onFetchCategoriesFailure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("4COnH")).fetchCategoriesFailure)(error));
            });
        });
});
parcelRegister("4COnH", function(module, exports) {
    $parcel$export(module.exports, "FETCH_CATEGORIES_FAILURE", ()=>$ab63acaf2733bdc5$export$4425a101b60fad1);
    $parcel$export(module.exports, "fetchCategoriesFailure", ()=>$ab63acaf2733bdc5$export$10b1ac5b71f5513e);
    const $ab63acaf2733bdc5$export$4425a101b60fad1 = 'state.actions.fetch-categories-failure.FETCH_CATEGORIES_FAILURE';
    const $ab63acaf2733bdc5$export$10b1ac5b71f5513e = (error)=>({
            type: $ab63acaf2733bdc5$export$4425a101b60fad1,
            payload: error
        });
});
parcelRegister("7gdJb", function(module, exports) {
    $parcel$export(module.exports, "FETCH_CATEGORIES_SUCCESS", ()=>$abc28ada0f8a3d9a$export$8fe15054f89178e3);
    $parcel$export(module.exports, "fetchCategoriesSuccess", ()=>$abc28ada0f8a3d9a$export$1372a078b0bbb728);
    const $abc28ada0f8a3d9a$export$8fe15054f89178e3 = 'state.actions.fetch-categories-success.FETCH_CATEGORIES_SUCCESS';
    const $abc28ada0f8a3d9a$export$1372a078b0bbb728 = (payload)=>({
            type: $abc28ada0f8a3d9a$export$8fe15054f89178e3,
            payload: payload
        });
});
parcelRegister("jpaaK", function(module, exports) {
    $parcel$export(module.exports, "FETCH_CATEGORIES", ()=>$b9a08106a74df812$export$cce9a7031b65f96c);
    const $b9a08106a74df812$export$cce9a7031b65f96c = 'state.actions.fetch-categories.FETCH_CATEGORIES';
    const $b9a08106a74df812$export$416ec9f5729de215 = (payload)=>({
            type: $b9a08106a74df812$export$cce9a7031b65f96c,
            payload: payload
        });
});
parcelRegister("gTvcp", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$ab48fc04d604b95e$export$8ec5145af6f76965);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("9o0uh");
    parcelRequire("fp4O3");
    parcelRequire("6hSeW");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $jrkeZ;
    var $eIzL1;
    var $dtw6v;
    var $791HF;
    var $gLt7z;
    var $knU3A;
    const $ab48fc04d604b95e$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("791HF")).FETCH_KB_HUB)).mergeMap((action)=>{
            const state = store.getState();
            const projectKey = (0, (0, parcelRequire("gLt7z")).getProjectKey)(state);
            const linkedState = (0, (0, parcelRequire("knU3A")).getHubLinkedState)(state);
            if (linkedState === 'linked') return (0, $kVLXA.Observable).empty();
            return (0, (0, parcelRequire("jrkeZ")).fetchConfluenceLink)(action.payload.projectKey).mergeMap((link)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("dtw6v")).fetchKbHubSuccess)(link))).catch(()=>(0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("jrkeZ")).fetchConfluenceLinkRestful)(projectKey)).map((link)=>(0, (0, parcelRequire("dtw6v")).fetchKbHubSuccess)(link)).catch((err)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("eIzL1")).fetchKbHubFailure)(err))));
        });
});
parcelRegister("eIzL1", function(module, exports) {
    $parcel$export(module.exports, "FETCH_KB_HUB_FAILURE", ()=>$be2f3f4be23b75f6$export$100d6710da08cb59);
    $parcel$export(module.exports, "fetchKbHubFailure", ()=>$be2f3f4be23b75f6$export$7b9ad8413eaffe44);
    const $be2f3f4be23b75f6$export$100d6710da08cb59 = 'state.actions.fetch-knowledge-hub-failure.FETCH_KB_HUB_FAILURE';
    const $be2f3f4be23b75f6$export$7b9ad8413eaffe44 = (payload)=>({
            type: $be2f3f4be23b75f6$export$100d6710da08cb59,
            payload: payload
        });
});
parcelRegister("dtw6v", function(module, exports) {
    $parcel$export(module.exports, "FETCH_KB_HUB_SUCCESS", ()=>$db188543ec32993c$export$52043214fd798dd);
    $parcel$export(module.exports, "fetchKbHubSuccess", ()=>$db188543ec32993c$export$3b2b22c5e24bfc30);
    const $db188543ec32993c$export$52043214fd798dd = 'state.actions.fetch-knowledge-hub-success.FETCH_KB_HUB_SUCCESS';
    const $db188543ec32993c$export$3b2b22c5e24bfc30 = (payload)=>({
            type: $db188543ec32993c$export$52043214fd798dd,
            payload: payload
        });
});
parcelRegister("791HF", function(module, exports) {
    $parcel$export(module.exports, "FETCH_KB_HUB", ()=>$2cbea12bc7a00f0f$export$6838769d7df96fbb);
    const $2cbea12bc7a00f0f$export$6838769d7df96fbb = 'state.actions.fetch-knowledge-hub.FETCH_KB_HUB';
    const $2cbea12bc7a00f0f$export$647aec6b80785904 = (projectKey)=>({
            type: $2cbea12bc7a00f0f$export$6838769d7df96fbb,
            payload: {
                projectKey: projectKey
            }
        });
});
parcelRegister("knU3A", function(module, exports) {
    $parcel$export(module.exports, "getHubLinkedState", ()=>$13b0808aee851dca$export$9b336974117966dd);
    $parcel$export(module.exports, "getLinkedConfluenceUrl", ()=>$13b0808aee851dca$export$fea8defd3093e8e3);
    $parcel$export(module.exports, "getLinkedConfluenceSpace", ()=>$13b0808aee851dca$export$6c88aaaf8fc8b7f1);
    const $13b0808aee851dca$export$9b336974117966dd = (state)=>state.entities.hub.linkedState;
    const $13b0808aee851dca$export$fea8defd3093e8e3 = (state)=>state.entities.hub.linkedState === 'linked' ? state.entities.hub.confluenceUrl : undefined;
    const $13b0808aee851dca$export$6c88aaaf8fc8b7f1 = (state)=>state.entities.hub.linkedState === 'linked' ? state.entities.hub.spaceKey : undefined;
});
parcelRegister("4JAV5", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$f044973d8abb6a80$export$8ec5145af6f76965);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $i4zGm;
    var $azjdP;
    var $jzG6G;
    var $goH2j;
    const $f044973d8abb6a80$export$8ec5145af6f76965 = (action$)=>action$.ofType((0, (0, parcelRequire("goH2j")).FETCH_LINKED_SPACES)).mergeMap((action)=>{
            const { projectKey: projectKey } = action.payload;
            return (0, (0, parcelRequire("i4zGm")).linkedSpaces)(projectKey).map((response)=>(0, (0, parcelRequire("jzG6G")).fetchLinkedSpacesSuccess)(response)).catch(()=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("azjdP")).fetchLinkedSpacesFailure)()));
        });
});
parcelRegister("azjdP", function(module, exports) {
    $parcel$export(module.exports, "FETCH_LINKED_SPACES_FAILURE", ()=>$cf0b03dea91f2721$export$9c186423b974805a);
    $parcel$export(module.exports, "fetchLinkedSpacesFailure", ()=>$cf0b03dea91f2721$export$e63a5f7249c4e5d6);
    var $NEu0c;
    const $cf0b03dea91f2721$export$9c186423b974805a = 'state.actions.fetch-linked-spaces-failure.FETCH_LINKED_SPACES_FAILURE';
    const $cf0b03dea91f2721$export$e63a5f7249c4e5d6 = ()=>({
            type: $cf0b03dea91f2721$export$9c186423b974805a,
            payload: {
                error: {
                    message: (0, (0, parcelRequire("NEu0c")).default).genericMessage,
                    header: (0, (0, parcelRequire("NEu0c")).default).genericHeader
                }
            }
        });
});
parcelRegister("NEu0c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc9fdd816f4c370f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fc9fdd816f4c370f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        genericHeader: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-linked-spaces-failure.generic-header",
            "defaultMessage": "Something went wrong"
        },
        genericMessage: {
            "id": "servicedesk.knowledge-hub.state.actions.fetch-linked-spaces-failure.generic-message",
            "defaultMessage": "We couldn't load the linked spaces. Please refresh and try again."
        }
    });
});
parcelRegister("jzG6G", function(module, exports) {
    $parcel$export(module.exports, "FETCH_LINKED_SPACE_SUCCESS", ()=>$366933797ff4c171$export$5142badf262ccc86);
    $parcel$export(module.exports, "fetchLinkedSpacesSuccess", ()=>$366933797ff4c171$export$ad2cc5272eef487);
    const $366933797ff4c171$export$5142badf262ccc86 = 'state.actions.fetch-linked-spaces-success.FETCH_LINKED_SPACE_SUCCESS';
    const $366933797ff4c171$export$ad2cc5272eef487 = (payload)=>({
            type: $366933797ff4c171$export$5142badf262ccc86,
            payload: payload
        });
});
parcelRegister("goH2j", function(module, exports) {
    $parcel$export(module.exports, "FETCH_LINKED_SPACES", ()=>$c793be7dffec599b$export$3d78263a729bb91);
    $parcel$export(module.exports, "fetchLinkedSpaces", ()=>$c793be7dffec599b$export$1999596e4ea30c16);
    const $c793be7dffec599b$export$3d78263a729bb91 = 'state.actions.fetch-linked-spaces.FETCH_LINKED_SPACES';
    const $c793be7dffec599b$export$1999596e4ea30c16 = (payload)=>({
            type: $c793be7dffec599b$export$3d78263a729bb91,
            payload: payload
        });
});
parcelRegister("iYJ1l", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$c4c23b3440ef4ce4$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $8zOmE;
    var $cVUDi;
    var $fmmX1;
    var $iHUHp;
    var $9aNfZ;
    var $l1APE;
    var $gLt7z;
    const $c4c23b3440ef4ce4$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("l1APE")).REMOVE_LABEL_FROM_ARTICLE)).mergeMap((action)=>{
            const { label: label, articleId: articleId, spaceKey: spaceKey, analyticsEvent: analyticsEvent } = action.payload;
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(store.getState());
            return (0, (0, parcelRequire("fmmX1")).removeLabelsFromArticles)({
                projectId: projectId,
                label: label,
                articleId: articleId,
                spaceKey: spaceKey,
                activationId: activationId
            }).map(()=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'onRemoveLabel success', {
                    articleId: articleId
                });
                return (0, (0, parcelRequire("9aNfZ")).removeLabelFromArticleSuccess)({
                    articleId: articleId,
                    label: label
                });
            }).catch((error)=>{
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, 'onRemoveLabelFailure', (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("iHUHp")).removeLabelFromArticleFailure)({
                    articleId: articleId
                }));
            });
        });
});
parcelRegister("9aNfZ", function(module, exports) {
    $parcel$export(module.exports, "REMOVE_LABEL_FROM_ARTICLE_SUCCESS", ()=>$16ef0dd8936a9692$export$a9305d58f2d32098);
    $parcel$export(module.exports, "removeLabelFromArticleSuccess", ()=>$16ef0dd8936a9692$export$2aaf552c4301b8b9);
    const $16ef0dd8936a9692$export$a9305d58f2d32098 = 'state.actions.remove-label-from-article-success.REMOVE_LABEL_FROM_ARTICLE_SUCCESS';
    const $16ef0dd8936a9692$export$2aaf552c4301b8b9 = (payload)=>({
            payload: payload,
            type: $16ef0dd8936a9692$export$a9305d58f2d32098
        });
});
parcelRegister("l1APE", function(module, exports) {
    $parcel$export(module.exports, "REMOVE_LABEL_FROM_ARTICLE", ()=>$6c5650e2e1eb67b6$export$ad78add1bc20cf2e);
    $parcel$export(module.exports, "removeLabelFromArticle", ()=>$6c5650e2e1eb67b6$export$c7cf56492591fe0f);
    const $6c5650e2e1eb67b6$export$ad78add1bc20cf2e = 'state.actions.remove-label-from-article.REMOVE_LABEL_FROM_ARTICLE';
    const $6c5650e2e1eb67b6$export$c7cf56492591fe0f = (payload)=>({
            payload: payload,
            type: $6c5650e2e1eb67b6$export$ad78add1bc20cf2e
        });
});
parcelRegister("92ShW", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$699ec73c490fb4c9$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("8n054");
    parcelRequire("6cbqE");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $cab1K = parcelRequire("cab1K");
    parcelRequire("2agIZ");
    var $i4zGm;
    var $hkbfC;
    var $gLt7z;
    const $699ec73c490fb4c9$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("hkbfC")).SEARCH_ARTICLES)).mergeMap(()=>(0, (0, parcelRequire("gLt7z")).getBaseUrl)(store.getState()));
    const $699ec73c490fb4c9$export$83f762cb3c8bb65a = (activationId)=>{
        const stream$ = new (0, $cab1K.Subject)();
        const results$ = stream$.debounce(({ term: term })=>(0, $kVLXA.Observable).timer(term ? 300 : 0)).switchMap(({ term: term, projectId: projectId, limit: limit, searchOnEmptyTerm: searchOnEmptyTerm, categoryId: categoryId, expansions: expansions, orderBy: orderBy })=>{
            if (!searchOnEmptyTerm && !term) {
                const empty = {
                    results: [],
                    totalSize: 0,
                    start: 0,
                    limit: 0,
                    size: 0,
                    categoriesSupported: true
                };
                return (0, $kVLXA.Observable).of(empty);
            }
            return (0, (0, parcelRequire("i4zGm")).list)(projectId, activationId, {
                limit: limit,
                categoryId: categoryId,
                query: term,
                expand: expansions,
                orderby: orderBy
            });
        });
        return {
            search: (args)=>stream$.next(args),
            results$: results$
        };
    };
});
parcelRegister("hkbfC", function(module, exports) {
    $parcel$export(module.exports, "SEARCH_ARTICLES", ()=>$b106701f9da61eca$export$9d662e85b068d1ae);
    const $b106701f9da61eca$export$9d662e85b068d1ae = 'state.actions.search-articles.SEARCH_ARTICLES';
    const $b106701f9da61eca$export$ce4856e0aa50b880 = (payload)=>({
            type: $b106701f9da61eca$export$9d662e85b068d1ae,
            payload: payload
        });
});
parcelRegister("6OXm8", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$611d4a2326bd0c8a$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $hhweD;
    var $cVUDi;
    var $fmmX1;
    var $6zk4x;
    var $ffNrT;
    var $19Gv3;
    var $gXg4u;
    var $gLt7z;
    const $611d4a2326bd0c8a$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("19Gv3")).UPDATE_CATEGORIES_FOR_ARTICLE)).mergeMap((action)=>{
            const { categoryIds: categoryIds, articleId: articleId, analyticsEvent: analyticsEvent, spaceKey: spaceKey } = action.payload;
            const projectId = (0, (0, parcelRequire("gLt7z")).getProjectId)(store.getState());
            const activationId = (0, (0, parcelRequire("gLt7z")).getActivationId)(store.getState());
            const currentCategoryIds = (0, (0, parcelRequire("gXg4u")).getCategoriesForArticle)(store.getState(), articleId).map((category)=>category.id);
            return (0, (0, parcelRequire("fmmX1")).updateCategoriesForArticle)({
                projectId: projectId,
                categoryIds: categoryIds,
                articleId: articleId,
                spaceKey: spaceKey,
                activationId: activationId
            }).map(()=>{
                (0, (0, parcelRequire("hhweD")).fireTrackAnalytics)(analyticsEvent, {
                    action: 'update',
                    actionSubjectId: articleId
                });
                return (0, (0, parcelRequire("ffNrT")).updateCategoriesForArticleSuccess)({
                    articleId: articleId,
                    categoryIds: categoryIds,
                    previousCategoryIds: currentCategoryIds
                });
            }).catch((error)=>{
                const { statusCode: statusCode, errorKey: errorKey, errorMessage: errorMessage, categories: categories } = error;
                (0, (0, parcelRequire("cVUDi")).fireCustomErrorAnalytics)({
                    error: error,
                    event: analyticsEvent,
                    id: 'articleUpdate Failure',
                    packageName: (0, $aaa081f4160162a5$export$b8b9d90f9e5bd72b)
                });
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("6zk4x")).updateCategoriesForArticleFailure)({
                    statusCode: statusCode,
                    errorKey: errorKey,
                    errorMessage: errorMessage,
                    failedCategoryIds: categories,
                    articleId: articleId
                }));
            });
        });
});
parcelRegister("ffNrT", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS", ()=>$80acc745b1c17a99$export$1c5489fde8a5332f);
    $parcel$export(module.exports, "updateCategoriesForArticleSuccess", ()=>$80acc745b1c17a99$export$c725200756c4c1a2);
    const $80acc745b1c17a99$export$1c5489fde8a5332f = 'state.actions.update-categories-for-article-success.UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS';
    const $80acc745b1c17a99$export$c725200756c4c1a2 = (payload)=>({
            payload: payload,
            type: $80acc745b1c17a99$export$1c5489fde8a5332f
        });
});
parcelRegister("19Gv3", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_CATEGORIES_FOR_ARTICLE", ()=>$44779a20dce37d77$export$a58f1691e9b5c9e3);
    $parcel$export(module.exports, "updateCategoriesForArticle", ()=>$44779a20dce37d77$export$2613b83c3141003a);
    const $44779a20dce37d77$export$a58f1691e9b5c9e3 = 'state.actions.update-categories-for-article.UPDATE_CATEGORIES_FOR_ARTICLE';
    const $44779a20dce37d77$export$2613b83c3141003a = (payload)=>({
            payload: payload,
            type: $44779a20dce37d77$export$a58f1691e9b5c9e3
        });
});
parcelRegister("1eweq", function(module, exports) {
    $parcel$export(module.exports, "KnowledgeHubContainer", ()=>$248571581b729595$export$bb94633c27dcd0a4);
    $parcel$export(module.exports, "KnowledgeHubActionsSubscriber", ()=>$248571581b729595$export$3982d9a4b6ad6814);
    var $7JoAD = parcelRequire("7JoAD");
    var $1xzCS;
    const $248571581b729595$export$168a0875d66dd4b7 = (newState)=>({ setState: setState })=>{
            setState(newState);
        };
    const $248571581b729595$export$e155678cbf296809 = ()=>({ getState: getState })=>getState();
    const $248571581b729595$export$e324594224ef24da = {
        updateStore: $248571581b729595$export$168a0875d66dd4b7,
        getStoreState: $248571581b729595$export$e155678cbf296809
    };
    const $248571581b729595$export$390f32400eaf98c9 = (0, $7JoAD.createStore)({
        name: 'knowledge-hub',
        initialState: (0, parcelRequire("1xzCS")).defaultState,
        actions: $248571581b729595$export$e324594224ef24da
    });
    const $248571581b729595$export$bb94633c27dcd0a4 = (0, $7JoAD.createContainer)($248571581b729595$export$390f32400eaf98c9);
    const $248571581b729595$export$44bc38849b4bbf73 = (0, $7JoAD.createSubscriber)($248571581b729595$export$390f32400eaf98c9, {
        displayName: 'KnowledgeHubState'
    });
    const $248571581b729595$export$3982d9a4b6ad6814 = (0, $7JoAD.createSubscriber)($248571581b729595$export$390f32400eaf98c9, {
        displayName: 'KnowledgeHubActions',
        selector: null
    });
    const $248571581b729595$export$81f6ad95dee7b9c = (0, $7JoAD.createHook)($248571581b729595$export$390f32400eaf98c9, {
        selector: null
    });
});
parcelRegister("1xzCS", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$349a74123be4d8a0$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$349a74123be4d8a0$export$2e2bcd8739ae039);
    var $3f2cs = parcelRequire("3f2cs");
    var $kChFH;
    var $3nEyX;
    var $lJvk4;
    const $349a74123be4d8a0$var$reducer = (0, $3f2cs.combineReducers)({
        app: (0, parcelRequire("kChFH")).default,
        ui: (0, parcelRequire("lJvk4")).default,
        entities: (0, parcelRequire("3nEyX")).default
    });
    const $349a74123be4d8a0$export$49d5fc8cba920a0 = {
        app: (0, (0, parcelRequire("kChFH")).defaultState),
        ui: (0, (0, parcelRequire("lJvk4")).defaultState),
        entities: (0, (0, parcelRequire("3nEyX")).defaultState)
    };
    var $349a74123be4d8a0$export$2e2bcd8739ae039 = (sweetStateUpdater)=>(state = $349a74123be4d8a0$export$49d5fc8cba920a0, action)=>{
            const outputState = $349a74123be4d8a0$var$reducer(state, action);
            sweetStateUpdater(outputState);
            return outputState;
        };
});
parcelRegister("kChFH", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$1551bcf88a1371a5$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$1551bcf88a1371a5$export$2e2bcd8739ae039);
    var $lzeFL;
    var $g5X3G;
    var $kstMB;
    const $1551bcf88a1371a5$export$49d5fc8cba920a0 = {
        baseUrl: (0, (0, parcelRequire("g5X3G")).toBaseUrl)(''),
        atlassianAccountId: '',
        cloudId: '',
        fabricPfDirUrl: '',
        locale: (0, (0, parcelRequire("lzeFL")).defaultLocale),
        userFullname: '',
        portalId: -1,
        projectKey: (0, (0, parcelRequire("g5X3G")).toProjectKey)(''),
        projectId: -1,
        projectName: '',
        projectType: '',
        isAdmin: false,
        isJiraAdmin: false,
        isProjectSimplified: false,
        sidebarCategoryLabel: '',
        activationId: 'ee20ebad-e5a1-42f6-899b-18706f0559e7'
    };
    var $1551bcf88a1371a5$export$2e2bcd8739ae039 = (state = $1551bcf88a1371a5$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("kstMB")).INITIALIZE_APP_PROPS:
                return {
                    ...state,
                    ...action.payload
                };
            case 0, (0, parcelRequire("kstMB")).UPDATE_CATEGORY_SIDEBAR_LABEL:
                return {
                    ...state,
                    sidebarCategoryLabel: action.payload
                };
            default:
                return state;
        }
    };
});
parcelRegister("kstMB", function(module, exports) {
    $parcel$export(module.exports, "INITIALIZE_APP_PROPS", ()=>$802af204f69179eb$export$84856e4ae7cd7538);
    $parcel$export(module.exports, "UPDATE_CATEGORY_SIDEBAR_LABEL", ()=>$802af204f69179eb$export$52e22c956d5c6839);
    const $802af204f69179eb$export$84856e4ae7cd7538 = 'state.actions.app.INITIALIZE_APP_PROPS';
    const $802af204f69179eb$export$52e22c956d5c6839 = 'state.actions.app.UPDATE_CATEGORY_SIDEBAR_LABEL';
    const $802af204f69179eb$export$5f0e35553cecddfe = (payload)=>({
            type: $802af204f69179eb$export$84856e4ae7cd7538,
            payload: payload
        });
    const $802af204f69179eb$export$c2eea28c04c00544 = (payload)=>({
            type: $802af204f69179eb$export$52e22c956d5c6839,
            payload: payload
        });
});
parcelRegister("3nEyX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$599b129cc2fb02a8$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "defaultState", ()=>$599b129cc2fb02a8$export$49d5fc8cba920a0);
    var $3f2cs = parcelRequire("3f2cs");
    var $fmcS9;
    var $gS1i9;
    var $kahXZ;
    var $5ev1t;
    var $aCUFo;
    var $jsmdo;
    var $3h2aI;
    var $599b129cc2fb02a8$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
        hub: (0, parcelRequire("jsmdo")).default,
        articles: (0, parcelRequire("kahXZ")).default,
        browse: (0, parcelRequire("5ev1t")).default,
        categories: (0, parcelRequire("aCUFo")).default,
        spaces: (0, parcelRequire("3h2aI")).default,
        appLink: (0, parcelRequire("fmcS9")).default,
        appLinks: (0, parcelRequire("gS1i9")).default
    });
    const $599b129cc2fb02a8$export$49d5fc8cba920a0 = {
        hub: (0, (0, parcelRequire("jsmdo")).defaultState),
        articles: (0, (0, parcelRequire("kahXZ")).defaultState),
        browse: (0, (0, parcelRequire("5ev1t")).defaultState),
        categories: (0, (0, parcelRequire("aCUFo")).defaultState),
        spaces: (0, (0, parcelRequire("3h2aI")).defaultState),
        appLink: (0, (0, parcelRequire("fmcS9")).defaultState),
        appLinks: (0, (0, parcelRequire("gS1i9")).defaultState)
    };
});
parcelRegister("fmcS9", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$f5121befb21ec1b4$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$f5121befb21ec1b4$export$2e2bcd8739ae039);
    var $6FRaa;
    var $aZdbu;
    var $gMZw6;
    const $f5121befb21ec1b4$export$49d5fc8cba920a0 = {
        isLoaded: false,
        appLink: undefined
    };
    var $f5121befb21ec1b4$export$2e2bcd8739ae039 = (state = $f5121befb21ec1b4$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("gMZw6")).FETCH_APPLINK:
                {
                    const { error: error, ...stateWithoutError } = state;
                    const newState = {
                        ...stateWithoutError,
                        isLoaded: false
                    };
                    return newState;
                }
            case 0, (0, parcelRequire("aZdbu")).FETCH_APPLINK_SUCCESS:
                return {
                    ...state,
                    isLoaded: true,
                    appLink: action.payload
                };
            case 0, (0, parcelRequire("6FRaa")).FETCH_APPLINK_FAILURE:
                return {
                    ...state,
                    error: action.payload,
                    isLoaded: true
                };
            default:
                return state;
        }
    };
});
parcelRegister("gS1i9", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$39212e89b0790fee$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$39212e89b0790fee$export$2e2bcd8739ae039);
    var $3XkGj;
    var $7GY3F;
    var $4dXi2;
    const $39212e89b0790fee$export$49d5fc8cba920a0 = {
        isLoaded: false
    };
    var $39212e89b0790fee$export$2e2bcd8739ae039 = (state = $39212e89b0790fee$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("4dXi2")).FETCH_APPLINKS:
                return {
                    ...state,
                    error: undefined,
                    isLoaded: false
                };
            case 0, (0, parcelRequire("7GY3F")).FETCH_APPLINKS_SUCCESS:
                return {
                    appLinks: action.payload,
                    error: undefined,
                    hasConfluenceServer: action.payload.some((appLink)=>appLink.isServer),
                    isLoaded: true
                };
            case 0, (0, parcelRequire("3XkGj")).FETCH_APPLINKS_FAILURE:
                return {
                    appLinks: [],
                    error: action.payload,
                    hasConfluenceServer: false,
                    isLoaded: true
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("kahXZ", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$16983ab139c0b8e5$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$16983ab139c0b8e5$export$2e2bcd8739ae039);
    var $4wVpT = parcelRequire("4wVpT");
    var $1UikQ = parcelRequire("1UikQ");
    var $hqULQ;
    var $5sKH1;
    var $5XgTr;
    var $6ovlC;
    var $e8y9X;
    var $8j0bg;
    var $80A0Z;
    var $4VDwv;
    var $4C8gV;
    var $agxSw;
    var $la4EY;
    var $iMgsY;
    var $e4spq;
    var $3pXRi;
    var $iHUHp;
    var $9aNfZ;
    var $l1APE;
    var $hsOR7;
    var $fTBH5;
    var $6zk4x;
    var $ffNrT;
    var $19Gv3;
    const $16983ab139c0b8e5$export$49d5fc8cba920a0 = {};
    const $16983ab139c0b8e5$var$articleListToObject = (articles)=>articles.reduce((acc, article)=>({
                ...acc,
                [article.id]: {
                    ...article,
                    title: (0, (0, parcelRequire("hqULQ")).removeHighlightText)(article.title),
                    categories: article.categories && article.categories.map((category)=>category.id)
                }
            }), {});
    var $16983ab139c0b8e5$export$2e2bcd8739ae039 = (state = $16983ab139c0b8e5$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("3pXRi")).REMOVE_ARTICLE_FROM_CATEGORY:
            case 0, (0, parcelRequire("6ovlC")).ADD_CATEGORIES_FOR_ARTICLE:
            case 0, (0, parcelRequire("19Gv3")).UPDATE_CATEGORIES_FOR_ARTICLE:
                if (state[action.payload.articleId]) return {
                    ...state,
                    [action.payload.articleId]: {
                        ...state[action.payload.articleId],
                        isBusy: true
                    }
                };
                return state;
            case 0, (0, parcelRequire("iMgsY")).REMOVE_ARTICLE_FROM_CATEGORY_FAILURE:
            case 0, (0, parcelRequire("5sKH1")).ADD_CATEGORIES_FOR_ARTICLE_FAILURE:
            case 0, (0, parcelRequire("6zk4x")).UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
                if (state[action.payload.articleId]) return {
                    ...state,
                    [action.payload.articleId]: {
                        ...state[action.payload.articleId],
                        isBusy: false
                    }
                };
                return state;
            case 0, (0, parcelRequire("e4spq")).REMOVE_ARTICLE_FROM_CATEGORY_SUCCESS:
                if (state[action.payload.articleId]) {
                    const existingArticle = state[action.payload.articleId];
                    const { categoryId: categoryId } = action.payload;
                    const newCategoriesList = (existingArticle.categories || []).filter((id)=>id !== categoryId);
                    const featuredInCategoryList = (existingArticle.featuredInCategories || []).filter((id)=>id !== categoryId);
                    return {
                        ...state,
                        [action.payload.articleId]: {
                            ...existingArticle,
                            categories: newCategoriesList,
                            featuredInCategories: featuredInCategoryList,
                            isBusy: false
                        }
                    };
                }
                return state;
            case 0, (0, parcelRequire("5XgTr")).ADD_CATEGORIES_FOR_ARTICLE_SUCCESS:
                {
                    const { articleId: articleId, categoryIds: newlyAddedCategoryIds, previousCategoryIds: previousCategoryIds } = action.payload;
                    const allCategoryIds = [
                        ...previousCategoryIds,
                        ...newlyAddedCategoryIds
                    ];
                    const existingArticle = state[articleId];
                    if (existingArticle) {
                        const existingFeaturedInCategoryIds = existingArticle.featuredInCategories || [];
                        const featuredInCategories = (0, ($parcel$interopDefault($4wVpT)))(allCategoryIds, existingFeaturedInCategoryIds);
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                featuredInCategories: featuredInCategories,
                                categories: allCategoryIds,
                                isBusy: false
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("ffNrT")).UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS:
                {
                    const { articleId: articleId, categoryIds: categoryIds } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle) {
                        const existingFeaturedInCategoryIds = existingArticle.featuredInCategories || [];
                        const featuredInCategories = (0, ($parcel$interopDefault($4wVpT)))(categoryIds, existingFeaturedInCategoryIds);
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                featuredInCategories: featuredInCategories,
                                categories: categoryIds,
                                isBusy: false
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("4VDwv")).BROWSE_KNOWLEDGE_SUCCESS:
                return (0, ($parcel$interopDefault($1UikQ)))({}, state, $16983ab139c0b8e5$var$articleListToObject(action.payload.results));
            case 0, (0, parcelRequire("hsOR7")).SEARCH_ARTICLES_SUCCESS:
                return (0, ($parcel$interopDefault($1UikQ)))({}, state, $16983ab139c0b8e5$var$articleListToObject(action.payload));
            case 0, (0, parcelRequire("la4EY")).FETCH_ARTICLE:
                if (state[action.payload.id] && state[action.payload.id].error) {
                    const newState = {
                        ...state
                    };
                    delete newState[action.payload.id];
                    return newState;
                }
                return state;
            case 0, (0, parcelRequire("agxSw")).FETCH_ARTICLE_SUCCESS:
                {
                    const { payload: payload } = action;
                    const categories = payload.categories ? {
                        categories: payload.categories.map((category)=>category.id)
                    } : {};
                    const featuredInCategories = payload.featuredInCategories ? {
                        featuredInCategories: payload.featuredInCategories
                    } : {};
                    const labels = payload.labels?.length ? payload.labels.map(({ id: id, label: label, name: name })=>({
                            id: id,
                            label: label,
                            name: name
                        })) : [];
                    const labelState = {
                        labels: labels,
                        isLoading: false,
                        addLabelError: false
                    };
                    const { labels: existingLabels, isEditable: isEditable, ...payloadWithoutLabels } = payload;
                    const articleState = {
                        ...payloadWithoutLabels,
                        ...categories,
                        ...featuredInCategories,
                        labelState: labelState,
                        isEditable: false
                    };
                    return {
                        ...state,
                        [action.payload.id]: (0, ($parcel$interopDefault($1UikQ)))({}, state[action.payload.id], articleState)
                    };
                }
            case 0, (0, parcelRequire("4C8gV")).FETCH_ARTICLE_FAILURE:
                return {
                    ...state,
                    [action.payload.id]: {
                        error: action.payload.error
                    }
                };
            case 0, (0, parcelRequire("8j0bg")).ADD_LABELS_TO_ARTICLE_SUCCESS:
                {
                    const { articleId: articleId, labels: labels } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle) {
                        const updatedLabels = labels.length ? labels.map(({ id: id, label: label, name: name })=>({
                                id: id,
                                label: label,
                                name: name
                            })) : [];
                        const labelState = {
                            labels: updatedLabels,
                            isLoading: false,
                            addLabelError: false
                        };
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                labelState: labelState
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("9aNfZ")).REMOVE_LABEL_FROM_ARTICLE_SUCCESS:
                {
                    const { label: label, articleId: articleId } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle) {
                        const labelState = existingArticle.labelState || {};
                        const existingLabels = labelState.labels || [];
                        const updatedLabels = existingLabels?.length ? existingLabels.filter(({ label: existingLabel })=>label !== existingLabel) : [];
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                labelState: {
                                    labels: updatedLabels,
                                    isLoading: false,
                                    addLabelError: false
                                }
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("e8y9X")).ADD_LABELS_TO_ARTICLE_FAILURE:
                {
                    const { articleId: articleId } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle && existingArticle.labelState) {
                        const existingLabels = existingArticle.labelState.labels || [];
                        const labelState = {
                            labels: existingLabels,
                            isLoading: false,
                            addLabelError: true
                        };
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                labelState: labelState
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("l1APE")).REMOVE_LABEL_FROM_ARTICLE:
            case 0, (0, parcelRequire("80A0Z")).ADD_LABELS_TO_ARTICLE:
                {
                    const { articleId: articleId } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle && existingArticle.labelState) {
                        const existingLabels = existingArticle.labelState.labels || [];
                        const labelState = {
                            labels: existingLabels,
                            isLoading: true,
                            addLabelError: false
                        };
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                labelState: labelState
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("iHUHp")).REMOVE_LABEL_FROM_ARTICLE_FAILURE:
                {
                    const { articleId: articleId } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle && existingArticle.labelState) {
                        const existingLabels = existingArticle.labelState.labels || [];
                        const labelState = {
                            labels: existingLabels,
                            isLoading: false,
                            addLabelError: false
                        };
                        return {
                            ...state,
                            [articleId]: {
                                ...existingArticle,
                                labelState: labelState
                            }
                        };
                    }
                    return state;
                }
            case 0, (0, parcelRequire("fTBH5")).SET_ARTICLE_EDIT_PERMISSION:
                {
                    const { articleId: articleId, isEditable: isEditable } = action.payload;
                    const existingArticle = state[articleId];
                    if (existingArticle) return {
                        ...state,
                        [articleId]: {
                            ...existingArticle,
                            isEditable: isEditable
                        }
                    };
                    return state;
                }
            default:
                return state;
        }
    };
});
parcelRegister("4wVpT", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $9dThv = parcelRequire("9dThv");
    var $g7i7g = parcelRequire("g7i7g");
    var $d9Hx6 = parcelRequire("d9Hx6");
    var $34c6b050456654f8$var$intersection = $g7i7g(function(arrays) {
        var mapped = $1nIHN(arrays, $d9Hx6);
        return mapped.length && mapped[0] === arrays[0] ? $9dThv(mapped) : [];
    });
    module.exports = $34c6b050456654f8$var$intersection;
});
parcelRegister("9dThv", function(module, exports) {
    var $ijRUK = parcelRequire("ijRUK");
    var $fUP98 = parcelRequire("fUP98");
    var $dA3tP = parcelRequire("dA3tP");
    var $1nIHN = parcelRequire("1nIHN");
    var $cW28x = parcelRequire("cW28x");
    var $40I25 = parcelRequire("40I25");
    var $6b7035a795ecd274$var$nativeMin = Math.min;
    function $6b7035a795ecd274$var$baseIntersection(arrays, iteratee, comparator) {
        var includes = comparator ? $dA3tP : $fUP98, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
        while(othIndex--){
            var array = arrays[othIndex];
            if (othIndex && iteratee) array = $1nIHN(array, $cW28x(iteratee));
            maxLength = $6b7035a795ecd274$var$nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $ijRUK(othIndex && array) : undefined;
        }
        array = arrays[0];
        var index = -1, seen = caches[0];
        outer: while(++index < length && result.length < maxLength){
            var value = array[index], computed = iteratee ? iteratee(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? $40I25(seen, computed) : includes(result, computed, comparator))) {
                othIndex = othLength;
                while(--othIndex){
                    var cache = caches[othIndex];
                    if (!(cache ? $40I25(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                }
                if (seen) seen.push(computed);
                result.push(value);
            }
        }
        return result;
    }
    module.exports = $6b7035a795ecd274$var$baseIntersection;
});
parcelRegister("d9Hx6", function(module, exports) {
    var $f3SOL = parcelRequire("f3SOL");
    function $993de25d5a02863a$var$castArrayLikeObject(value) {
        return $f3SOL(value) ? value : [];
    }
    module.exports = $993de25d5a02863a$var$castArrayLikeObject;
});
parcelRegister("hqULQ", function(module, exports) {
    $parcel$export(module.exports, "removeHighlightText", ()=>$483996128e1ce34e$export$4fe678a311e29d1a);
    const $483996128e1ce34e$export$4fe678a311e29d1a = (text)=>text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
});
parcelRegister("iMgsY", function(module, exports) {
    $parcel$export(module.exports, "REMOVE_ARTICLE_FROM_CATEGORY_FAILURE", ()=>$e6e2e62b66b39b7e$export$30c079f32002614a);
    const $e6e2e62b66b39b7e$export$30c079f32002614a = 'state.actions.remove-article-from-category-failure.REMOVE_ARTICLE_FROM_CATEGORY_FAILURE';
    const $e6e2e62b66b39b7e$export$9c7b80de1b92cc2 = (payload)=>({
            payload: payload,
            type: $e6e2e62b66b39b7e$export$30c079f32002614a
        });
});
parcelRegister("e4spq", function(module, exports) {
    $parcel$export(module.exports, "REMOVE_ARTICLE_FROM_CATEGORY_SUCCESS", ()=>$1b3b33db699d8db2$export$8bab89f0adf16580);
    const $1b3b33db699d8db2$export$8bab89f0adf16580 = 'state.actions.remove-article-from-category-success.REMOVE_ARTICLE_FROM_CATEGORY_SUCCESS';
    const $1b3b33db699d8db2$export$37035f42efedefca = (payload)=>({
            type: $1b3b33db699d8db2$export$8bab89f0adf16580,
            payload: payload
        });
});
parcelRegister("3pXRi", function(module, exports) {
    $parcel$export(module.exports, "REMOVE_ARTICLE_FROM_CATEGORY", ()=>$df3a27bd08a194ec$export$ffc4687de776860c);
    $parcel$export(module.exports, "removeArticleFromCategory", ()=>$df3a27bd08a194ec$export$b6002acecf935894);
    const $df3a27bd08a194ec$export$ffc4687de776860c = 'state.actions.remove-article-from-category.REMOVE_ARTICLE_FROM_CATEGORY';
    const $df3a27bd08a194ec$export$b6002acecf935894 = (payload)=>({
            payload: payload,
            type: $df3a27bd08a194ec$export$ffc4687de776860c
        });
});
parcelRegister("hsOR7", function(module, exports) {
    $parcel$export(module.exports, "SEARCH_ARTICLES_SUCCESS", ()=>$4257b84175002daa$export$b377bab65795997b);
    const $4257b84175002daa$export$b377bab65795997b = 'state.actions.search-articles-success.SEARCH_ARTICLES_SUCCESS';
    const $4257b84175002daa$export$327940e72204ca9b = (payload)=>({
            type: $4257b84175002daa$export$b377bab65795997b,
            payload: payload
        });
});
parcelRegister("5ev1t", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$22d8828255293e73$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$22d8828255293e73$export$2e2bcd8739ae039);
    var $16dzj = parcelRequire("16dzj");
    var $33YKl;
    var $4VDwv;
    var $kHzxc;
    var $0523Q;
    var $ffNrT;
    const $22d8828255293e73$export$49d5fc8cba920a0 = {
        limit: 20
    };
    var $22d8828255293e73$export$2e2bcd8739ae039 = (state = $22d8828255293e73$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("ffNrT")).UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS:
                {
                    const { categoryIds: categoryIds, previousCategoryIds: previousCategoryIds } = action.payload;
                    if (categoryIds) {
                        const newState = {
                            ...state
                        };
                        const categoryIdsNeededCacheClear = (0, ($parcel$interopDefault($16dzj)))(categoryIds, previousCategoryIds);
                        categoryIdsNeededCacheClear.forEach((categoryId)=>{
                            if (newState[categoryId]) newState[categoryId].shouldClearCacheOnNextFetch = true;
                        });
                        return newState;
                    }
                    return state;
                }
            case 0, (0, parcelRequire("0523Q")).CLEAR_BROWSE:
                {
                    const newState = {
                        ...state
                    };
                    delete newState[action.payload];
                    return newState;
                }
            case 0, (0, parcelRequire("kHzxc")).BROWSE_KNOWLEDGE:
                if (state[action.payload.id] && state[action.payload.id].pages[`${action.payload.page}`] && state[action.payload.id].pages[`${action.payload.page}`].error) {
                    const newState = {
                        ...state,
                        loading: true
                    };
                    delete newState[action.payload.id].pages[`${action.payload.page}`];
                    return newState;
                }
                if (state[action.payload.id] && state[action.payload.id].shouldClearCacheOnNextFetch) {
                    const newState = {
                        ...state,
                        loading: true,
                        [action.payload.id]: {
                            ...state[action.payload.id],
                            shouldClearCacheOnNextFetch: false,
                            pages: {}
                        }
                    };
                    return newState;
                }
                return {
                    ...state,
                    loading: true
                };
            case 0, (0, parcelRequire("33YKl")).BROWSE_KNOWLEDGE_FAILURE:
                const newFailureState = {
                    ...state,
                    loading: false,
                    [action.payload.id]: {
                        pages: {
                            [`${action.payload.page}`]: {
                                error: action.payload.error
                            }
                        }
                    }
                };
                return newFailureState;
            case 0, (0, parcelRequire("4VDwv")).BROWSE_KNOWLEDGE_SUCCESS:
                const newSuccessState = {
                    ...state,
                    loading: false,
                    [action.payload.id]: {
                        totalSize: action.payload.totalSize,
                        categoriesSupported: action.payload.categoriesSupported,
                        pages: {
                            ...state[action.payload.id] ? state[action.payload.id].pages : {},
                            [`${action.payload.page}`]: action.payload.results.map((article)=>article.id)
                        },
                        nextCursor: action.payload.nextCursor || '',
                        prevCursor: action.payload.prevCursor || ''
                    }
                };
                return newSuccessState;
            default:
                return state;
        }
    };
});
parcelRegister("16dzj", function(module, exports) {
    var $2GdQn = parcelRequire("2GdQn");
    var $g7i7g = parcelRequire("g7i7g");
    var $7txx8 = parcelRequire("7txx8");
    var $f3SOL = parcelRequire("f3SOL");
    var $0cd0e06461d5e057$var$xor = $g7i7g(function(arrays) {
        return $7txx8($2GdQn(arrays, $f3SOL));
    });
    module.exports = $0cd0e06461d5e057$var$xor;
});
parcelRegister("7txx8", function(module, exports) {
    var $55pzo = parcelRequire("55pzo");
    var $ekcP3 = parcelRequire("ekcP3");
    var $7CoLY = parcelRequire("7CoLY");
    function $571540db172adafd$var$baseXor(arrays, iteratee, comparator) {
        var length = arrays.length;
        if (length < 2) return length ? $7CoLY(arrays[0]) : [];
        var index = -1, result = Array(length);
        while(++index < length){
            var array = arrays[index], othIndex = -1;
            while(++othIndex < length)if (othIndex != index) result[index] = $55pzo(result[index] || array, arrays[othIndex], iteratee, comparator);
        }
        return $7CoLY($ekcP3(result, 1), iteratee, comparator);
    }
    module.exports = $571540db172adafd$var$baseXor;
});
parcelRegister("0523Q", function(module, exports) {
    $parcel$export(module.exports, "CLEAR_BROWSE", ()=>$bf00c744d75604af$export$6795bd145eb16b7e);
    const $bf00c744d75604af$export$6795bd145eb16b7e = 'state.actions.clear-browse.CLEAR_BROWSE';
    const $bf00c744d75604af$export$862ad1bcf49b6105 = (categoryId)=>({
            type: $bf00c744d75604af$export$6795bd145eb16b7e,
            payload: categoryId
        });
});
parcelRegister("aCUFo", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$67411d71966dddb0$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$67411d71966dddb0$export$2e2bcd8739ae039);
    var $4VDwv;
    var $agxSw;
    var $4COnH;
    var $7gdJb;
    var $jpaaK;
    var $hsOR7;
    const $67411d71966dddb0$export$49d5fc8cba920a0 = {
        isLoaded: false,
        categories: [],
        isCategoriesSupported: false
    };
    const $67411d71966dddb0$var$reduceCategoriesFromArticles = (articles, existingCategories)=>{
        const categories = [
            ...existingCategories
        ];
        articles.reduce((acc, article)=>acc.concat(article.categories), []).forEach((category)=>{
            if (category && !categories.find((existingCategory)=>category.id === existingCategory.id)) categories.push(category);
        });
        return categories;
    };
    var $67411d71966dddb0$export$2e2bcd8739ae039 = (state = $67411d71966dddb0$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("7gdJb")).FETCH_CATEGORIES_SUCCESS:
                return {
                    categories: action.payload.categories,
                    isCategoriesSupported: action.payload.categoriesSupported,
                    isLoaded: true
                };
            case 0, (0, parcelRequire("4COnH")).FETCH_CATEGORIES_FAILURE:
                return {
                    ...state,
                    error: action.payload,
                    isLoaded: true
                };
            case 0, (0, parcelRequire("jpaaK")).FETCH_CATEGORIES:
                {
                    const newState = {
                        ...state,
                        isLoaded: false
                    };
                    delete newState.error;
                    return newState;
                }
            case 0, (0, parcelRequire("4VDwv")).BROWSE_KNOWLEDGE_SUCCESS:
                {
                    const newState = {
                        ...state,
                        categories: $67411d71966dddb0$var$reduceCategoriesFromArticles(action.payload.results, state.categories)
                    };
                    return newState;
                }
            case 0, (0, parcelRequire("hsOR7")).SEARCH_ARTICLES_SUCCESS:
                {
                    const newState = {
                        ...state,
                        categories: $67411d71966dddb0$var$reduceCategoriesFromArticles(action.payload, state.categories)
                    };
                    return newState;
                }
            case 0, (0, parcelRequire("agxSw")).FETCH_ARTICLE_SUCCESS:
                {
                    const newState = {
                        ...state,
                        categories: $67411d71966dddb0$var$reduceCategoriesFromArticles([
                            action.payload
                        ], state.categories)
                    };
                    return newState;
                }
            default:
                return state;
        }
    };
});
parcelRegister("jsmdo", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$8ca7f66155305974$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$8ca7f66155305974$export$2e2bcd8739ae039);
    var $eIzL1;
    var $dtw6v;
    var $bHD2d;
    var $k9iYw;
    const $8ca7f66155305974$export$49d5fc8cba920a0 = {
        linkedState: 'loading'
    };
    var $8ca7f66155305974$export$2e2bcd8739ae039 = (state = $8ca7f66155305974$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("dtw6v")).FETCH_KB_HUB_SUCCESS:
                {
                    const { projectKey: _, ...data } = action.payload;
                    return {
                        id: data.id,
                        confluenceUrl: (0, (0, parcelRequire("k9iYw")).removeTrailingSlash)(data.baseUrl),
                        spaceKey: data.spaceKey,
                        linkedState: 'linked'
                    };
                }
            case 0, (0, parcelRequire("eIzL1")).FETCH_KB_HUB_FAILURE:
                if (action.payload.error.key === 'sd.kb.link.error.link.not.found') return {
                    linkedState: 'unlinked'
                };
                return {
                    messageKey: action.payload.error.key,
                    linkedState: 'error'
                };
            case 0, (0, parcelRequire("bHD2d")).SET_KB_HUB:
                return action.payload;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("bHD2d", function(module, exports) {
    $parcel$export(module.exports, "SET_KB_HUB", ()=>$35c3183d0ed1f802$export$5d4aeddc17f0cd0f);
    $parcel$export(module.exports, "setKbHub", ()=>$35c3183d0ed1f802$export$3f646e047bd99e08);
    const $35c3183d0ed1f802$export$5d4aeddc17f0cd0f = 'state.actions.set-knowledge-hub.SET_KB_HUB';
    const $35c3183d0ed1f802$export$3f646e047bd99e08 = (payload)=>({
            type: $35c3183d0ed1f802$export$5d4aeddc17f0cd0f,
            payload: payload
        });
});
parcelRegister("k9iYw", function(module, exports) {
    $parcel$export(module.exports, "removeTrailingSlash", ()=>$f5e36f4cfb7d0348$export$b6d465111d914331);
    const $f5e36f4cfb7d0348$export$b6d465111d914331 = (str)=>str.replace(/\/$/, '');
});
parcelRegister("3h2aI", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$c0be59ff1e3dfebc$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$c0be59ff1e3dfebc$export$2e2bcd8739ae039);
    var $azjdP;
    var $jzG6G;
    var $goH2j;
    const $c0be59ff1e3dfebc$export$49d5fc8cba920a0 = {
        linkedSpaces: {
            data: [],
            error: null,
            loading: false
        }
    };
    var $c0be59ff1e3dfebc$export$2e2bcd8739ae039 = (state = $c0be59ff1e3dfebc$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("goH2j")).FETCH_LINKED_SPACES:
                return {
                    ...state,
                    linkedSpaces: {
                        data: [],
                        error: null,
                        loading: true
                    }
                };
            case 0, (0, parcelRequire("jzG6G")).FETCH_LINKED_SPACE_SUCCESS:
                return {
                    ...state,
                    linkedSpaces: {
                        error: null,
                        loading: false,
                        data: action.payload.spaces
                    }
                };
            case 0, (0, parcelRequire("azjdP")).FETCH_LINKED_SPACES_FAILURE:
                return {
                    ...state,
                    linkedSpaces: {
                        loading: false,
                        data: [],
                        error: action.payload.error
                    }
                };
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("lJvk4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61fc5aff003b114a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "defaultState", ()=>$61fc5aff003b114a$export$49d5fc8cba920a0);
    var $3f2cs = parcelRequire("3f2cs");
    var $daO3a;
    var $61fc5aff003b114a$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
        articles: (0, parcelRequire("daO3a")).default
    });
    const $61fc5aff003b114a$export$49d5fc8cba920a0 = {
        articles: (0, (0, parcelRequire("daO3a")).defaultState)
    };
});
parcelRegister("daO3a", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$ffb3ac562043eddf$export$49d5fc8cba920a0);
    $parcel$export(module.exports, "default", ()=>$ffb3ac562043eddf$export$2e2bcd8739ae039);
    var $5sKH1;
    var $5XgTr;
    var $6ovlC;
    var $9fA8j;
    var $5ZGnB;
    var $6zk4x;
    var $ffNrT;
    var $19Gv3;
    var $fQZG5;
    const $ffb3ac562043eddf$export$49d5fc8cba920a0 = {};
    var $ffb3ac562043eddf$export$2e2bcd8739ae039 = (state = $ffb3ac562043eddf$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("6ovlC")).ADD_CATEGORIES_FOR_ARTICLE:
            case 0, (0, parcelRequire("19Gv3")).UPDATE_CATEGORIES_FOR_ARTICLE:
                {
                    const { categoryIds: categoryIds, articleId: articleId } = action.payload;
                    return {
                        ...state,
                        [articleId]: {
                            isShowingBulkCategoryAdder: !!(state[articleId] && state[articleId].isShowingBulkCategoryAdder),
                            categoriesInBulkCategoryAdder: state[articleId] ? state[articleId].categoriesInBulkCategoryAdder : [],
                            categoryIds: categoryIds
                        }
                    };
                }
            case 0, (0, parcelRequire("ffNrT")).UPDATE_CATEGORIES_FOR_ARTICLE_SUCCESS:
            case 0, (0, parcelRequire("5XgTr")).ADD_CATEGORIES_FOR_ARTICLE_SUCCESS:
                {
                    const { articleId: articleId } = action.payload;
                    const newState = {
                        ...state
                    };
                    delete newState[articleId];
                    return newState;
                }
            case 0, (0, parcelRequire("6zk4x")).UPDATE_CATEGORIES_FOR_ARTICLE_FAILURE:
            case 0, (0, parcelRequire("5sKH1")).ADD_CATEGORIES_FOR_ARTICLE_FAILURE:
                {
                    const { failedCategoryIds: failedCategoryIds, errorMessage: errorMessage, articleId: articleId } = action.payload;
                    return {
                        ...state,
                        [articleId]: {
                            ...state[articleId],
                            failedCategoryIds: failedCategoryIds,
                            error: errorMessage
                        }
                    };
                }
            case 0, (0, parcelRequire("5ZGnB")).SHOW_BULK_CATEGORY_ADDER:
                {
                    const { articleId: articleId } = action.payload;
                    return {
                        ...state,
                        [articleId]: {
                            ...state[articleId],
                            isShowingBulkCategoryAdder: true
                        }
                    };
                }
            case 0, (0, parcelRequire("9fA8j")).HIDE_BULK_CATEGORY_ADDER:
                {
                    const { articleId: articleId } = action.payload;
                    return {
                        ...state,
                        [articleId]: {
                            ...state[articleId],
                            isShowingBulkCategoryAdder: false,
                            categoriesInBulkCategoryAdder: []
                        }
                    };
                }
            case 0, (0, parcelRequire("fQZG5")).UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER:
                {
                    const { articleId: articleId, categoryIds: categoryIds } = action.payload;
                    return {
                        ...state,
                        [articleId]: {
                            ...state[articleId],
                            categoriesInBulkCategoryAdder: categoryIds
                        }
                    };
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("9fA8j", function(module, exports) {
    $parcel$export(module.exports, "HIDE_BULK_CATEGORY_ADDER", ()=>$ed66b70bc3006a26$export$63cec6f97de61b9a);
    $parcel$export(module.exports, "hideBulkCategoryAdder", ()=>$ed66b70bc3006a26$export$541e941f3628edb2);
    const $ed66b70bc3006a26$export$63cec6f97de61b9a = 'state.actions.hide-bulk-category-adder.HIDE_BULK_CATEGORY_ADDER';
    const $ed66b70bc3006a26$export$541e941f3628edb2 = (payload)=>({
            payload: payload,
            type: $ed66b70bc3006a26$export$63cec6f97de61b9a
        });
});
parcelRegister("5ZGnB", function(module, exports) {
    $parcel$export(module.exports, "SHOW_BULK_CATEGORY_ADDER", ()=>$27a097cc2a8fd1f3$export$848c1458a48faa31);
    $parcel$export(module.exports, "showBulkCategoryAdder", ()=>$27a097cc2a8fd1f3$export$aea09bcda8ca9577);
    const $27a097cc2a8fd1f3$export$848c1458a48faa31 = 'state.actions.show-bulk-category-adder.SHOW_BULK_CATEGORY_ADDER';
    const $27a097cc2a8fd1f3$export$aea09bcda8ca9577 = (payload)=>({
            payload: payload,
            type: $27a097cc2a8fd1f3$export$848c1458a48faa31
        });
});
parcelRegister("fQZG5", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER", ()=>$3b0b6b45936d49fc$export$e08673e3855cdb43);
    $parcel$export(module.exports, "updateCategoriesInBulkCategoryAdder", ()=>$3b0b6b45936d49fc$export$f603b0637b290a5e);
    const $3b0b6b45936d49fc$export$e08673e3855cdb43 = 'state.actions.update-categories-in-bulk-category-adder.UPDATE_CATEGORIES_IN_BULK_CATEGORY_ADDER';
    const $3b0b6b45936d49fc$export$f603b0637b290a5e = (payload)=>({
            payload: payload,
            type: $3b0b6b45936d49fc$export$e08673e3855cdb43
        });
});
parcelRegister("7FkcY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f01143916800e31c$export$2e2bcd8739ae039);
    var $bC2fB;
    var $7gdJb;
    var $bHD2d;
    var $8WLSX;
    var $f01143916800e31c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)(()=>({}), {
        onSetKbHub: (0, (0, parcelRequire("bHD2d")).setKbHub),
        setCategoriesData: (0, (0, parcelRequire("7gdJb")).fetchCategoriesSuccess)
    })((0, (0, parcelRequire("8WLSX")).default));
});
parcelRegister("8WLSX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8de5c2338e3adc79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $8de5c2338e3adc79$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.onSetKbHub();
            this.setCategoriesData();
        }
        componentDidUpdate() {
            this.onSetKbHub();
            this.setCategoriesData();
        }
        onSetKbHub() {
            const { onSetKbHub: onSetKbHub, setCategoriesData: setCategoriesData, children: children, categories: categories, isCategoriesSupported: isCategoriesSupported, ...confluenceLink } = this.props;
            onSetKbHub(confluenceLink);
        }
        setCategoriesData() {
            const { setCategoriesData: setCategoriesData, categories: categories, isCategoriesSupported: isCategoriesSupported } = this.props;
            setCategoriesData({
                categories: categories,
                categoriesSupported: isCategoriesSupported
            });
        }
        render() {
            return this.props.children;
        }
    }
});
parcelRegister("6GLlD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1e4a0c92f65aa33$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $9noxX;
    var $e9YVH;
    var $9dbF6;
    var $9NiTW;
    var $cYaqS;
    const $b1e4a0c92f65aa33$var$ServiceDeskAppBase = ({ appName: appName, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cYaqS")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "serviceDesk"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9noxX")).ServiceDeskAnalyticsContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: (0, (0, parcelRequire("e9YVH")).toPackageName)(appName),
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, children))));
    var $b1e4a0c92f65aa33$export$2e2bcd8739ae039 = $b1e4a0c92f65aa33$var$ServiceDeskAppBase;
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("cYaqS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f72fff5a1e4c8937$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $4UFLs;
    var $g3A84;
    const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
        const isSettingsRoute = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
        const Gate = isSettingsRoute ? (0, (0, parcelRequire("g3A84")).default) : (0, (0, parcelRequire("4UFLs")).default);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
    };
    var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;
});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';
parcelRegister("4UFLs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9befbeaff9f5385d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daoB1;
    var $dIdda = parcelRequire("dIdda");
    var $iDvG9;
    const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
        const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        const [projectKey = ''] = (0, $dIdda.usePathParam)('projectKey');
        if (projectKey) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iDvG9")).default), null, children);
        return hasServiceDeskAccess ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: "/jira"
        });
    };
    var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;
});
parcelRegister("iDvG9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34dd3dc578b1a167$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    var $dFOAR;
    var $fhAnU;
    const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
        const [projectKey = ''] = (0, $dIdda.usePathParam)('projectKey');
        const [{ data: data, error: error }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)();
        if (data || error) {
            if (!(0, (0, parcelRequire("fhAnU")).isAccessError)(error)) {
                const { userRole: userRole = '' } = data || {};
                if (userRole === 'agent' || userRole === 'agent-project-admin') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
                if (error) throw error;
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
            });
        }
        return null;
    };
    var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;
});
parcelRegister("fhAnU", function(module, exports) {
    $parcel$export(module.exports, "isAccessError", ()=>$1a790f4bb1355504$export$ddaebe4928e793cb);
    const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
        (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
        (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
        (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
    ];
    const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;
});
parcelRegister("g3A84", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60e7d6646168c089$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8pMQX;
    var $dFOAR;
    var $fhAnU;
    const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
        const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)();
        const userRole = serviceDeskContext?.userRole;
        const hasAccessError = (0, (0, parcelRequire("fhAnU")).isAccessError)(serviceDeskContextError);
        if (userRole === 'agent-project-admin' && !hasAccessError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        if (userRole !== undefined || hasAccessError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pMQX")).ProjectNotFound), null);
        if (serviceDeskContextError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pMQX")).GenericError), null);
        return null;
    };
    var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;
});
parcelRegister("8pMQX", function(module, exports) {
    $parcel$export(module.exports, "ProjectNotFound", ()=>$951f6bd200bf8b89$export$849d319c342682a2);
    $parcel$export(module.exports, "GenericError", ()=>$951f6bd200bf8b89$export$7d465be8efa67280);
    var $5uXOq = parcelRequire("5uXOq");
    var $hTEpF;
    var $dC5iT;
    var $8CUq3;
    var $gLj7z;
    var $4R6GH;
    var $ew1Lk;
    var $bTyOW;
    var $fC09Q;
    var $iVgQf;
    var $koVbs;
    var $dIdda = parcelRequire("dIdda");
    var $tcn7E;
    var $4AdE6;
    const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectsPath = '/jira/projects';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("fC09Q")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundTitle),
            description: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDescription),
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
                to: projectsPath
            }, formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundAction))
        }));
    };
    const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const traceId = (0, $5uXOq.useMemo)(()=>{
            const traceContext = (0, (0, parcelRequire("tcn7E")).getActiveTrace)();
            return traceContext?.traceId;
        }, []);
        let description = formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorDescription);
        if (traceId && (0, (0, parcelRequire("4R6GH")).fg)('jfp-trace-id-in-error-boundaries')) {
            const error = new Error('An error occurred while loading this page');
            description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, description), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $951f6bd200bf8b89$var$styles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gLj7z")).ErrorHashAndTraceId), {
                error: error,
                traceId: traceId
            })));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("bTyOW")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorTitle),
            description: description
        }));
    };
    const $951f6bd200bf8b89$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.100'
    });
});
parcelRegister("gLj7z", function(module, exports) {
    $parcel$export(module.exports, "ErrorHashAndTraceId", ()=>$fe273132a82b30fc$export$61354a7dde2c2d3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5oFIy;
    var $kobfu;
    var $ftF7i;
    const $fe273132a82b30fc$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
        const errorHash = (0, (0, parcelRequire("kobfu")).getErrorHash)(error);
        const source = `Hash ${errorHash}\nTrace ${traceId}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
            action: "rendered",
            actionSubject: "errorHashAndTraceId",
            attributes: {
                errorHash: errorHash,
                traceId: traceId
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "note"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ftF7i")).CodeBlockWithCopyButton), {
            source: source,
            copyCodeActionSubjectId: "copyErrorHashAndTraceId"
        })));
    };
});
parcelRegister("ftF7i", function(module, exports) {
    $parcel$export(module.exports, "CodeBlockWithCopyButton", ()=>$92e21bbf80c400af$export$ced1fc74d907d387);
    var $5uXOq = parcelRequire("5uXOq");
    var $b8Qxt;
    var $dC5iT;
    var $8CUq3;
    var $lOZGq;
    const $92e21bbf80c400af$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $92e21bbf80c400af$var$wrapperStyles,
            role: "region"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).ActionContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).CopyAction), {
            source: source,
            actionSubjectId: copyCodeActionSubjectId
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b8Qxt")).default), {
            text: source,
            showLineNumbers: false,
            shouldWrapLongLines: false
        })));
    const $92e21bbf80c400af$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        position: 'relative'
    });
});
parcelRegister("b8Qxt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4fd53c1f9dbca185$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $e4VnT;
    var $1HkQx;
    var $eCBnN;
    var $9Xp6L;
    const $4fd53c1f9dbca185$var$CodeBlock = (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
        const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
        const theme = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1HkQx")).getCodeBlockTheme)(numLines), [
            numLines
        ]);
        const getStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1HkQx")).getCodeBlockStyles)(theme), [
            theme
        ]);
        const styles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("f8Sb3")).css)(getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
            highlightedStartText,
            highlightedEndText,
            showLineNumbers,
            shouldWrapLongLines,
            getStyles
        ]);
        const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, (0, parcelRequire("e4VnT")).useHighlightLines)({
            highlight: highlight,
            testId: testId
        });
        const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
            getHighlightStyles,
            highlightedLines
        ]);
        const language = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("eCBnN")).normalizeLanguage)(providedLanguage), [
            providedLanguage
        ]);
        const languageToUse = text ? language : 'text';
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Xp6L")).default), {
            "data-code-lang": language,
            "data-ds--code--code-block": "",
            testId: testId,
            language: languageToUse,
            css: styles,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber,
            lineProps: getLineProps,
            shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
            shouldWrapLongLines: shouldWrapLongLines,
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
            text: text
        });
    });
    $4fd53c1f9dbca185$var$CodeBlock.displayName = 'CodeBlock';
    var $4fd53c1f9dbca185$export$2e2bcd8739ae039 = $4fd53c1f9dbca185$var$CodeBlock;
});
parcelRegister("e4VnT", function(module, exports) {
    $parcel$export(module.exports, "useHighlightLines", ()=>$a32b74c088f4b53f$export$84415a200bdf33ed);
    var $5uXOq = parcelRequire("5uXOq");
    const $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ = {
        'data-ds--code--row': ''
    };
    const $a32b74c088f4b53f$var$getLineStyleObject = (lineNumber, testId)=>{
        return testId ? {
            'data-testid': `${testId}-line-${lineNumber}`,
            ...$a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ
        } : $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ;
    };
    const $a32b74c088f4b53f$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
        const highlightedLines = (0, $5uXOq.useMemo)(()=>{
            if (!highlight) return [];
            return highlight.split(',').map((num)=>{
                if (num.indexOf('-') > 0) {
                    const [from, to] = num.split('-').map(Number).sort((a, b)=>a - b);
                    return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
                }
                return Number(num);
            }).reduce((acc, val)=>acc.concat(val), []) || [];
        }, [
            highlight
        ]);
        const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
            if (!highlight || highlightedLines.length === 0) return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
            if (highlightedLines.includes(lineNumber)) {
                const highlightedDataAttrObj = {
                    'data-ds--code--row--highlight': ''
                };
                return {
                    ...highlightedDataAttrObj,
                    ...$a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId)
                };
            }
            return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
        }, [
            highlight,
            testId
        ]);
        return {
            getHighlightStyles: getHighlightStyles,
            highlightedLines: highlightedLines
        };
    };
});
parcelRegister("1HkQx", function(module, exports) {
    $parcel$export(module.exports, "getCodeBlockStyles", ()=>$a9c1aabaca189fa1$export$b571c24d82780698);
    $parcel$export(module.exports, "getCodeStyles", ()=>$a9c1aabaca189fa1$export$d5fcf1b7ff23707b);
    $parcel$export(module.exports, "getCodeBlockTheme", ()=>$a9c1aabaca189fa1$export$57a2d4b573afd64a);
    var $lBXbx;
    var $8CJbG;
    const $a9c1aabaca189fa1$export$cb7aec0206b595d2 = (numLines)=>{
        if (!numLines) return '1ch';
        return `${numLines.toFixed(0).length}ch`;
    };
    const $a9c1aabaca189fa1$var$lineNumberStyle = (theme)=>({
            minWidth: `calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px) !important`,
            fontStyle: 'normal !important',
            color: `${theme.lineNumberColor} !important`,
            flexShrink: 0,
            boxSizing: 'border-box',
            paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
            paddingLeft: (0, (0, parcelRequire("lBXbx")).SPACING),
            marginRight: (0, (0, parcelRequire("lBXbx")).SPACING),
            textAlign: 'right',
            userSelect: 'none',
            display: 'block',
            '&::after': {
                content: `attr(data-ds--line-number)`
            }
        });
    const $a9c1aabaca189fa1$var$syntaxKeywordColors = (theme)=>({
            '.token': {
                '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                    all: 'unset'
                },
                '&.key,&.keyword': {
                    color: theme.keywordColor,
                    fontWeight: 'bolder'
                },
                '&.attr-name': {
                    color: theme.attributeColor
                },
                '&.selector': {
                    color: theme.selectorTagColor
                },
                '&.comment,&.block-comment': {
                    color: theme.commentColor,
                    fontFamily: theme.fontFamilyItalic,
                    fontStyle: 'italic'
                },
                '&.function-name': {
                    color: theme.sectionColor
                },
                '&.doctype': {
                    color: theme.docTagColor
                },
                '&.substr': {
                    color: theme.substringColor
                },
                '&.namespace': {
                    color: theme.nameColor
                },
                '&.builtin': {
                    color: theme.builtInColor
                },
                '&.entity': {
                    color: theme.literalColor
                },
                '&.bullet': {
                    color: theme.bulletColor
                },
                '&.code': {
                    color: theme.codeColor
                },
                '&.regex': {
                    color: theme.regexpColor
                },
                '&.symbol': {
                    color: theme.symbolColor
                },
                '&.variable': {
                    color: theme.variableColor
                },
                '&.url': {
                    color: theme.linkColor
                },
                '&.selector-attr': {
                    color: theme.selectorAttributeColor
                },
                '&.selector-pseudo': {
                    color: theme.selectorPseudoColor
                },
                '&.type': {
                    color: theme.typeColor
                },
                '&.quote': {
                    color: theme.quoteColor
                },
                '&.tag': {
                    color: theme.templateTagColor
                },
                '&.string': {
                    color: theme.stringColor
                },
                '&.class-name': {
                    color: theme.sectionColor
                },
                '&.title': {
                    color: theme.titleColor
                },
                '&.section': {
                    color: theme.sectionColor
                },
                '&.meta-keyword': {
                    color: theme.metaKeywordColor
                },
                '&.meta': {
                    color: theme.metaColor
                },
                '&.italic': {
                    fontStyle: 'italic'
                },
                '&.bold': {
                    fontWeight: 'bolder'
                },
                '&.function': {
                    color: theme.functionColor
                },
                '&.number': {
                    color: theme.numberColor
                },
                '&.attr-value': {
                    color: theme.attributeColor
                },
                '&.prolog': {
                    color: theme.prologColor
                },
                '&.cdata': {
                    color: theme.cdataColor
                },
                '&.punctuation': {
                    color: theme.punctuationColor
                },
                '&.property': {
                    color: theme.propertyColor
                },
                '&.constant': {
                    color: theme.constantColor
                },
                '&.deleted': {
                    color: theme.deletedColor
                },
                '&.boolean': {
                    color: theme.booleanColor
                },
                '&.char': {
                    color: theme.charColor
                },
                '&.inserted': {
                    color: theme.insertedColor
                },
                '&.operator': {
                    color: theme.operatorColor
                },
                '&.atrule': {
                    color: theme.atruleColor
                },
                '&.important': {
                    color: theme.importantColor,
                    fontWeight: 'bold'
                }
            }
        });
    const $a9c1aabaca189fa1$export$ee58a26b5d612ac1 = (theme)=>({
            fontSize: (0, (0, parcelRequire("lBXbx")).CODE_FONT_SIZE),
            fontFamily: theme.fontFamily,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            backgroundColor: `var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
            color: theme.textColor,
            borderStyle: 'none',
            borderRadius: "var(--ds-border-radius, 3px)"
        });
    const $a9c1aabaca189fa1$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
                'code[class*="language-"], pre[class*="language-"], code': {
                    all: 'unset',
                    padding: showLineNumbers ? `${0, (0, parcelRequire("lBXbx")).SPACING}px 0` : (0, (0, parcelRequire("lBXbx")).SPACING),
                    tabSize: 4
                },
                display: 'flex',
                lineHeight: (0, (0, parcelRequire("lBXbx")).CODE_LINE_HEIGHT),
                overflowX: 'auto',
                whiteSpace: 'pre',
                direction: 'ltr',
                ...$a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme),
                ...$a9c1aabaca189fa1$var$syntaxKeywordColors(theme),
                '& .linenumber, .ds-sh-line-number': $a9c1aabaca189fa1$var$lineNumberStyle(theme),
                '& .linenumber': {
                    display: 'inline-block !important',
                    float: 'left'
                },
                '& [data-ds--code--row]': {
                    display: showLineNumbers ? 'flex' : 'block',
                    paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
                    marginRight: `-${0, (0, parcelRequire("lBXbx")).SPACING}px`
                },
                '& [data-ds--code--row--highlight]': {
                    background: `${theme.highlightedLineBgColor}`,
                    '&::before, &::after': {
                        clipPath: 'inset(100%)',
                        clip: 'rect(1px, 1px, 1px, 1px)',
                        height: '1px',
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px'
                    },
                    '&::before': {
                        content: `" [${highlightedStartText}] "`
                    },
                    '&::after': {
                        content: `" [${highlightedEndText}] "`
                    }
                },
                '& [data-ds--code--row--highlight] .linenumber': {
                    borderLeft: `${0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                    paddingLeft: `${(0, (0, parcelRequire("lBXbx")).SPACING) / 2}px !important`,
                    position: 'relative'
                },
                '& [data-ds--code--row--highlight] .linenumber::before': {
                    content: '""',
                    position: 'absolute',
                    width: (0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH),
                    top: '-1px',
                    left: `-${0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH}`,
                    borderTop: `1px solid ${theme.highlightedLineBorderColor}`
                },
                '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                    borderTop: '1px dashed transparent'
                },
                '[data-ds--code--row--highlight]:last-child': {
                    borderBottom: '1px dashed transparent'
                },
                '& code:first-of-type': {
                    paddingRight: `0px !important`,
                    backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px), transparent)` : undefined
                },
                '& code:last-of-type': {
                    paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
                    flexBasis: 'auto',
                    flexGrow: 1,
                    flexShrink: shouldWrapLongLines ? 1 : 0,
                    wordBreak: 'break-word'
                },
                'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                    content: '" "'
                }
            });
    const $a9c1aabaca189fa1$export$d5fcf1b7ff23707b = ()=>{
        const theme = (0, (0, parcelRequire("8CJbG")).getBaseTheme)();
        const baseStyles = $a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme);
        return {
            ...baseStyles,
            display: 'inline',
            padding: '2px 0.5ch',
            boxDecorationBreak: 'clone',
            fontSize: '0.875em',
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        };
    };
    const $a9c1aabaca189fa1$export$57a2d4b573afd64a = (maxLines)=>{
        return {
            ...(0, (0, parcelRequire("8CJbG")).getBaseTheme)(),
            ...(0, (0, parcelRequire("8CJbG")).getColorPalette)(),
            lineNumberWidth: maxLines ? $a9c1aabaca189fa1$export$cb7aec0206b595d2(maxLines) : undefined
        };
    };
});
parcelRegister("lBXbx", function(module, exports) {
    $parcel$export(module.exports, "CODE_FONT_SIZE", ()=>$6ec31795911692d1$export$431ac46d758d98c8);
    $parcel$export(module.exports, "CODE_LINE_HEIGHT", ()=>$6ec31795911692d1$export$8e3c04032121c606);
    $parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", ()=>$6ec31795911692d1$export$c8b5dc30e9f2b86e);
    $parcel$export(module.exports, "SPACING", ()=>$6ec31795911692d1$export$82ea42e772d49e5b);
    $parcel$export(module.exports, "LINE_NUMBER_GUTTER", ()=>$6ec31795911692d1$export$eeeea0ff98e06fff);
    $parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", ()=>$6ec31795911692d1$export$254015fe817dcb9e);
    $parcel$export(module.exports, "VAR_CODE_BG_COLOR", ()=>$6ec31795911692d1$export$1758fda69688282e);
    var $k5uoT;
    const $6ec31795911692d1$export$431ac46d758d98c8 = 12;
    const $6ec31795911692d1$export$8e3c04032121c606 = '20px';
    const $6ec31795911692d1$export$c8b5dc30e9f2b86e = '4px';
    const $6ec31795911692d1$export$82ea42e772d49e5b = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $6ec31795911692d1$export$eeeea0ff98e06fff = $6ec31795911692d1$export$82ea42e772d49e5b * 2;
    const $6ec31795911692d1$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
    const $6ec31795911692d1$export$1758fda69688282e = '--ds--code--bg-color';
    const $6ec31795911692d1$export$2cd00c745c539a1 = `data-ds--code--code-block`;
});
parcelRegister("8CJbG", function(module, exports) {
    $parcel$export(module.exports, "getBaseTheme", ()=>$eac5fe855702cfc1$export$4464aa303b3e4fda);
    $parcel$export(module.exports, "getColorPalette", ()=>$eac5fe855702cfc1$export$fe2a6478976e8b17);
    var $8QpSo;
    var $kTHGn;
    const $eac5fe855702cfc1$var$T800 = '#067384';
    const $eac5fe855702cfc1$var$Y1100 = '#7A5D1A';
    const $eac5fe855702cfc1$export$4464aa303b3e4fda = ()=>({
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            fontFamilyItalic: `SFMono-MediumItalic, ${(0, (0, parcelRequire("kTHGn")).default)('font.family.code')}`,
            backgroundColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            textColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            lineNumberColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            lineNumberBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
        });
    const $eac5fe855702cfc1$export$fe2a6478976e8b17 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return {
            highlightedLineBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
            highlightedLineBorderColor: `var(--ds-border-focused, ${$829f609a65d26a98$export$215b7063051591f1})`,
            substringColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            keywordColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            attributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorTagColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            docTagColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`,
            nameColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            builtInColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            literalColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            bulletColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            codeColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            regexpColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            symbolColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            variableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            templateVariableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            linkColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            selectorAttributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorPseudoColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            typeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            stringColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            selectorIdColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorClassColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            quoteColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            templateTagColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            titleColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            sectionColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            commentColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            metaKeywordColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            metaColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            functionColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            numberColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            prologColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            cdataColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            punctuationColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            propertyColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            constantColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            booleanColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            charColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            insertedColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            deletedColor: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
            operatorColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            atruleColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            importantColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`
        };
    });
    const $eac5fe855702cfc1$var$getTheme = ()=>({
            ...$eac5fe855702cfc1$export$4464aa303b3e4fda(),
            ...$eac5fe855702cfc1$export$fe2a6478976e8b17()
        });
    var $eac5fe855702cfc1$export$2e2bcd8739ae039 = $eac5fe855702cfc1$var$getTheme;
});
parcelRegister("eCBnN", function(module, exports) {
    $parcel$export(module.exports, "normalizeLanguage", ()=>$d00516a0f8207944$export$f38728011c178796);
    var $8QpSo;
    var $8Y2ZY;
    const $d00516a0f8207944$export$f38728011c178796 = (0, (0, parcelRequire("8QpSo")).default)((language)=>{
        if (!language) return '';
        const match = (0, (0, parcelRequire("8Y2ZY")).SUPPORTED_LANGUAGES).find((val)=>{
            return val.name === language || val.alias.includes(language);
        });
        return match ? match.value : 'text';
    });
});
parcelRegister("8Y2ZY", function(module, exports) {
    $parcel$export(module.exports, "SUPPORTED_LANGUAGES", ()=>$012a854d92762508$export$7c77c3a9bb93870d);
    const $012a854d92762508$export$7c77c3a9bb93870d = [
        {
            name: 'PHP',
            alias: [
                'php',
                'php3',
                'php4',
                'php5'
            ],
            value: 'php'
        },
        {
            name: 'Java',
            alias: [
                'java'
            ],
            value: 'java'
        },
        {
            name: 'CSharp',
            alias: [
                'csharp',
                'c#'
            ],
            value: 'cs'
        },
        {
            name: 'Python',
            alias: [
                'python',
                'py'
            ],
            value: 'python'
        },
        {
            name: 'JavaScript',
            alias: [
                'javascript',
                'js'
            ],
            value: 'javascript'
        },
        {
            name: 'Html',
            alias: [
                'html'
            ],
            value: 'xml'
        },
        {
            name: 'C++',
            alias: [
                'c++',
                'cpp',
                'clike'
            ],
            value: 'cpp'
        },
        {
            name: 'Ruby',
            alias: [
                'ruby',
                'rb',
                'duby'
            ],
            value: 'ruby'
        },
        {
            name: 'Objective-C',
            alias: [
                'objective-c',
                'objectivec',
                'obj-c',
                'objc'
            ],
            value: 'objectivec'
        },
        {
            name: 'C',
            alias: [
                'c'
            ],
            value: 'cpp'
        },
        {
            name: 'Swift',
            alias: [
                'swift'
            ],
            value: 'swift'
        },
        {
            name: 'TeX',
            alias: [
                'tex',
                'latex'
            ],
            value: 'tex'
        },
        {
            name: 'Shell',
            alias: [
                'shell',
                'bash',
                'sh',
                'ksh',
                'zsh'
            ],
            value: 'shell'
        },
        {
            name: 'Scala',
            alias: [
                'scala'
            ],
            value: 'scala'
        },
        {
            name: 'Go',
            alias: [
                'go'
            ],
            value: 'go'
        },
        {
            name: 'ActionScript',
            alias: [
                'actionscript',
                'actionscript3',
                'as'
            ],
            value: 'actionscript'
        },
        {
            name: 'ColdFusion',
            alias: [
                'coldfusion'
            ],
            value: 'xml'
        },
        {
            name: 'JavaFX',
            alias: [
                'javafx',
                'jfx'
            ],
            value: 'java'
        },
        {
            name: 'VbNet',
            alias: [
                'vbnet',
                'vb.net',
                'vfp',
                'clipper',
                'xbase'
            ],
            value: 'vbnet'
        },
        {
            name: 'JSON',
            alias: [
                'json'
            ],
            value: 'json'
        },
        {
            name: 'MATLAB',
            alias: [
                'matlab'
            ],
            value: 'matlab'
        },
        {
            name: 'Groovy',
            alias: [
                'groovy'
            ],
            value: 'groovy'
        },
        {
            name: 'SQL',
            alias: [
                'sql',
                'postgresql',
                'postgres',
                'plpgsql',
                'psql',
                'postgresql-console',
                'postgres-console',
                'tsql',
                't-sql',
                'mysql',
                'sqlite'
            ],
            value: 'sql'
        },
        {
            name: 'R',
            alias: [
                'r'
            ],
            value: 'r'
        },
        {
            name: 'Perl',
            alias: [
                'perl',
                'pl'
            ],
            value: 'perl'
        },
        {
            name: 'Lua',
            alias: [
                'lua'
            ],
            value: 'lua'
        },
        {
            name: 'Pascal',
            alias: [
                'pas',
                'pascal',
                'objectpascal',
                'delphi'
            ],
            value: 'pascal'
        },
        {
            name: 'XML',
            alias: [
                'xml'
            ],
            value: 'xml'
        },
        {
            name: 'TypeScript',
            alias: [
                'typescript',
                'ts'
            ],
            value: 'typescript'
        },
        {
            name: 'CoffeeScript',
            alias: [
                'coffeescript',
                'coffee-script',
                'coffee'
            ],
            value: 'coffeescript'
        },
        {
            name: 'Haskell',
            alias: [
                'haskell',
                'hs'
            ],
            value: 'haskell'
        },
        {
            name: 'Puppet',
            alias: [
                'puppet'
            ],
            value: 'puppet'
        },
        {
            name: 'Arduino',
            alias: [
                'arduino'
            ],
            value: 'arduino'
        },
        {
            name: 'Fortran',
            alias: [
                'fortran'
            ],
            value: 'fortran'
        },
        {
            name: 'Erlang',
            alias: [
                'erlang',
                'erl'
            ],
            value: 'erlang'
        },
        {
            name: 'PowerShell',
            alias: [
                'powershell',
                'posh',
                'ps1',
                'psm1'
            ],
            value: 'powershell'
        },
        {
            name: 'Haxe',
            alias: [
                'haxe',
                'hx',
                'hxsl'
            ],
            value: 'haxe'
        },
        {
            name: 'Elixir',
            alias: [
                'elixir',
                'ex',
                'exs'
            ],
            value: 'elixir'
        },
        {
            name: 'Verilog',
            alias: [
                'verilog',
                'v'
            ],
            value: 'verilog'
        },
        {
            name: 'Rust',
            alias: [
                'rust'
            ],
            value: 'rust'
        },
        {
            name: 'VHDL',
            alias: [
                'vhdl'
            ],
            value: 'vhdl'
        },
        {
            name: 'Sass',
            alias: [
                'sass'
            ],
            value: 'less'
        },
        {
            name: 'OCaml',
            alias: [
                'ocaml'
            ],
            value: 'ocaml'
        },
        {
            name: 'Dart',
            alias: [
                'dart'
            ],
            value: 'dart'
        },
        {
            name: 'CSS',
            alias: [
                'css'
            ],
            value: 'css'
        },
        {
            name: 'reStructuredText',
            alias: [
                'restructuredtext',
                'rst',
                'rest'
            ],
            value: 'rest'
        },
        {
            name: 'Kotlin',
            alias: [
                'kotlin'
            ],
            value: 'kotlin'
        },
        {
            name: 'D',
            alias: [
                'd'
            ],
            value: 'd'
        },
        {
            name: 'Octave',
            alias: [
                'octave'
            ],
            value: 'matlab'
        },
        {
            name: 'QML',
            alias: [
                'qbs',
                'qml'
            ],
            value: 'qml'
        },
        {
            name: 'Prolog',
            alias: [
                'prolog'
            ],
            value: 'prolog'
        },
        {
            name: 'FoxPro',
            alias: [
                'foxpro',
                'purebasic'
            ],
            value: 'purebasic'
        },
        {
            name: 'Scheme',
            alias: [
                'scheme',
                'scm'
            ],
            value: 'scheme'
        },
        {
            name: 'CUDA',
            alias: [
                'cuda',
                'cu'
            ],
            value: 'cpp'
        },
        {
            name: 'Julia',
            alias: [
                'julia',
                'jl'
            ],
            value: 'julia'
        },
        {
            name: 'Racket',
            alias: [
                'racket',
                'rkt'
            ],
            value: 'lisp'
        },
        {
            name: 'Ada',
            alias: [
                'ada',
                'ada95',
                'ada2005'
            ],
            value: 'ada'
        },
        {
            name: 'Tcl',
            alias: [
                'tcl'
            ],
            value: 'tcl'
        },
        {
            name: 'Mathematica',
            alias: [
                'mathematica',
                'mma',
                'nb'
            ],
            value: 'mathematica'
        },
        {
            name: 'Autoit',
            alias: [
                'autoit'
            ],
            value: 'autoit'
        },
        {
            name: 'StandardML',
            alias: [
                'standardmL',
                'sml',
                'standardml'
            ],
            value: 'sml'
        },
        {
            name: 'Objective-J',
            alias: [
                'objective-j',
                'objectivej',
                'obj-j',
                'objj'
            ],
            value: 'objectivec'
        },
        {
            name: 'Smalltalk',
            alias: [
                'smalltalk',
                'squeak',
                'st'
            ],
            value: 'smalltalk'
        },
        {
            name: 'Vala',
            alias: [
                'vala',
                'vapi'
            ],
            value: 'vala'
        },
        {
            name: 'ABAP',
            alias: [
                'abap'
            ],
            value: 'sql'
        },
        {
            name: 'LiveScript',
            alias: [
                'livescript',
                'live-script'
            ],
            value: 'livescript'
        },
        {
            name: 'XQuery',
            alias: [
                'xquery',
                'xqy',
                'xq',
                'xql',
                'xqm'
            ],
            value: 'xquery'
        },
        {
            name: 'PlainText',
            alias: [
                'text',
                'plaintext'
            ],
            value: 'text'
        },
        {
            name: 'Yaml',
            alias: [
                'yaml',
                'yml'
            ],
            value: 'yaml'
        },
        {
            name: 'GraphQL',
            alias: [
                'graphql'
            ],
            value: 'graphql'
        },
        {
            name: 'AppleScript',
            alias: [
                'applescript'
            ],
            value: 'applescript'
        },
        {
            name: 'Clojure',
            alias: [
                'clojure'
            ],
            value: 'clojure'
        },
        {
            name: 'Diff',
            alias: [
                'diff'
            ],
            value: 'diff'
        },
        {
            name: 'VisualBasic',
            alias: [
                'visualbasic'
            ],
            value: 'visual-basic'
        },
        {
            name: 'JSX',
            alias: [
                'jsx'
            ],
            value: 'jsx'
        },
        {
            name: 'TSX',
            alias: [
                'tsx'
            ],
            value: 'tsx'
        },
        {
            name: 'SplunkSPL',
            alias: [
                'splunk-spl'
            ],
            value: 'splunk-spl'
        },
        {
            name: 'Dockerfile',
            alias: [
                'docker',
                'dockerfile'
            ],
            value: 'dockerfile'
        },
        {
            name: 'HCL',
            alias: [
                'hcl',
                'terraform'
            ],
            value: 'hcl'
        },
        {
            name: 'NGINX',
            alias: [
                'nginx'
            ],
            value: 'nginx'
        },
        {
            name: 'Protocol Buffers',
            alias: [
                'protobuf',
                'proto'
            ],
            value: 'protobuf'
        }
    ];
});
parcelRegister("9Xp6L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e296c4d390ff4a21$export$2e2bcd8739ae039);
    var $c8FD2;
    var $e296c4d390ff4a21$export$2e2bcd8739ae039 = (0, (0, parcelRequire("c8FD2")).default);
});
parcelRegister("c8FD2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64df4f4e00539958$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lp89O;
    const $64df4f4e00539958$var$generator = (options)=>{
        const { loader: loader } = options;
        class AsyncHighlighter extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
            static{
                this.astGenerator = null;
            }
            static{
                this.highlightInstance = (0, (0, parcelRequire("lp89O")).default);
            }
            static preload() {
                return AsyncHighlighter.loadAstGenerator();
            }
            static loadAstGenerator() {
                AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                    AsyncHighlighter.astGenerator = astGenerator;
                    return astGenerator;
                });
                return AsyncHighlighter.astGeneratorPromise;
            }
            componentDidMount() {
                if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
                if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                    this.forceUpdate();
                });
            }
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(AsyncHighlighter.highlightInstance, {
                    ...this.props,
                    astGenerator: AsyncHighlighter.astGenerator
                });
            }
        }
        return AsyncHighlighter;
    };
    const $64df4f4e00539958$var$asyncGenerator = $64df4f4e00539958$var$generator({
        loader: ()=>(parcelRequire("kN6qz")).then((module)=>{
                return module.default || module;
            })
    });
    var $64df4f4e00539958$export$2e2bcd8739ae039 = $64df4f4e00539958$var$asyncGenerator;
});
parcelRegister("lp89O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a813ccd1d5fae376$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iQkqt;
    var $jVB7m;
    const $a813ccd1d5fae376$var$Highlight = (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
        className: `language-${language}`
    }, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
        const code = text;
        const generatorClassName = 'prismjs';
        const containerProps = {
            ...rest,
            'data-testid': testId,
            className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
        };
        if (shouldWrapLongLines) codeTagProps.style = {
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
        };
        else codeTagProps.style = {
            whiteSpace: 'pre'
        };
        const codeBidiWarningConfig = {
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
        const rows = (0, (0, parcelRequire("iQkqt")).default)({
            astGenerator: astGenerator,
            code: code,
            language: language,
            shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
            lineProps: lineProps,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber
        });
        return (0, (0, parcelRequire("jVB7m")).default)({
            containerProps: containerProps,
            codeTagProps: codeTagProps,
            rows: rows,
            codeBidiWarningConfig: codeBidiWarningConfig
        });
    });
    var $a813ccd1d5fae376$export$2e2bcd8739ae039 = $a813ccd1d5fae376$var$Highlight;
});
parcelRegister("iQkqt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55dc1424d34091d6$export$2e2bcd8739ae039);
    var $eJUOt;
    var $eTMIA;
    var $8bliZ;
    var $g6MVu;
    const $55dc1424d34091d6$var$newLineRegex = /\n/g;
    function $55dc1424d34091d6$var$getNewLines(str) {
        return str.match($55dc1424d34091d6$var$newLineRegex);
    }
    function $55dc1424d34091d6$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
        const codeTree = (0, (0, parcelRequire("g6MVu")).default)(language, code, astGenerator);
        const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
        const createLine = (0, (0, parcelRequire("eJUOt")).default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
        const newTree = [];
        let lastLineBreakIndex = -1;
        let index = 0;
        const tree = (0, (0, parcelRequire("8bliZ")).default)(codeTree);
        while(index < tree.length){
            const testNode = tree[index];
            if (testNode.type === 'text') {
                index++;
                continue;
            }
            const node = testNode;
            const firstChildNode = node.children[0];
            if (firstChildNode.type === 'text') {
                const { value: value } = firstChildNode;
                const newLines = $55dc1424d34091d6$var$getNewLines(value);
                if (newLines) {
                    const splitValue = value.split('\n');
                    splitValue.forEach((text, i)=>{
                        const lineNumber = newTree.length + startingLineNumber;
                        const newChild = {
                            type: 'text',
                            value: `${text}\n`
                        };
                        if (i === 0) {
                            const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, (0, parcelRequire("eTMIA")).default)({
                                children: [
                                    newChild
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            }));
                            const line = createLine(children, lineNumber);
                            newTree.push(line);
                        } else if (i === splitValue.length - 1) {
                            const nextNode = tree[index + 1];
                            const stringChild = nextNode && nextNode.children && nextNode.children[0];
                            const lastLineInPreviousSpan = {
                                type: 'text',
                                value: `${text}`
                            };
                            if (stringChild) {
                                const newElem = (0, (0, parcelRequire("eTMIA")).default)({
                                    children: [
                                        lastLineInPreviousSpan
                                    ],
                                    className: node.properties.className,
                                    lineNumber: lineNumber
                                });
                                tree.splice(index + 1, 0, newElem);
                            } else {
                                const children = [
                                    lastLineInPreviousSpan
                                ];
                                const line = createLine(children, lineNumber, node.properties.className);
                                newTree.push(line);
                            }
                        } else {
                            const children = [
                                newChild
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    });
                    lastLineBreakIndex = index;
                }
            }
            index++;
        }
        if (lastLineBreakIndex !== tree.length - 1) {
            const children = tree.slice(lastLineBreakIndex + 1, tree.length);
            if (children && children.length) {
                const lineNumber = newTree.length + startingLineNumber;
                const line = createLine(children, lineNumber);
                newTree.push(line);
            }
        }
        if (shouldCreateParentElementForLines) return newTree;
        return newTree.flat(1);
    }
});
parcelRegister("eJUOt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9ccdbf71436a137$export$2e2bcd8739ae039);
    var $eTMIA;
    var $5FOwT;
    function $b9ccdbf71436a137$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
        return (children, lineNumber, className = [])=>{
            if (shouldCreateParentElementForLines || className.length > 0) return (0, (0, parcelRequire("eTMIA")).default)({
                children: children,
                lineNumber: lineNumber,
                showLineNumbers: showLineNumbers,
                lineProps: lineProps,
                className: className
            });
            else {
                if (showLineNumbers && lineNumber) children.unshift((0, (0, parcelRequire("5FOwT")).default)(lineNumber));
                return children;
            }
        };
    }
    var $b9ccdbf71436a137$export$2e2bcd8739ae039 = $b9ccdbf71436a137$var$createLineGenerator;
});
parcelRegister("eTMIA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6df5b208b9d23752$export$2e2bcd8739ae039);
    var $5FOwT;
    function $6df5b208b9d23752$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
        const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
        const properties = {
            ...propsPassedInFromCodeBlock,
            className: className
        };
        let currentChildren = children;
        if (lineNumber && showLineNumbers) {
            if (currentChildren.length === 1) currentChildren = [
                (0, (0, parcelRequire("5FOwT")).default)(lineNumber),
                ...currentChildren
            ];
            else currentChildren = [
                (0, (0, parcelRequire("5FOwT")).default)(lineNumber),
                {
                    type: 'element',
                    tagName: 'span',
                    properties: {
                        className: []
                    },
                    children: currentChildren
                }
            ];
        }
        return {
            type: 'element',
            tagName: 'span',
            properties: properties,
            children: currentChildren
        };
    }
});
parcelRegister("5FOwT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6257c3f70e94feb$export$2e2bcd8739ae039);
    function $c6257c3f70e94feb$export$2e2bcd8739ae039(lineNumber) {
        return {
            type: 'element',
            tagName: 'span',
            properties: {
                key: `line-number--${lineNumber}`,
                className: [
                    'comment',
                    'linenumber',
                    'ds-line-number'
                ],
                'data-ds--line-number': lineNumber
            },
            children: []
        };
    }
});
parcelRegister("8bliZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9f6debfd276481a$export$2e2bcd8739ae039);
    var $eTMIA;
    function $c9f6debfd276481a$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
        let newTree = [];
        for(let i = 0; i < tree.length; i++){
            const node = tree[i];
            if (node.type === 'text') newTree.push((0, (0, parcelRequire("eTMIA")).default)({
                children: [
                    node
                ],
                lineNumber: offset,
                className: className
            }));
            else if (node.children) {
                const classNames = className.concat(node.properties.className || []);
                $c9f6debfd276481a$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
            }
        }
        return newTree;
    }
});
parcelRegister("g6MVu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8213b6c690eefe35$export$2e2bcd8739ae039);
    function $8213b6c690eefe35$export$2e2bcd8739ae039(language, code, astGenerator) {
        if (language === 'text' || !astGenerator) return [
            {
                type: 'text',
                value: code
            }
        ];
        try {
            return astGenerator.highlight(code, language);
        } catch (e) {
            return [
                {
                    type: 'text',
                    value: code
                }
            ];
        }
    }
});
parcelRegister("jVB7m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b98c01cbb865d4c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fBvqm;
    function $b98c01cbb865d4c1$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
        const renderedRows = rows.map((node, i)=>(0, (0, parcelRequire("fBvqm")).default)({
                node: node,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment${i}`
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", containerProps, (0, ($parcel$interopDefault($5uXOq))).createElement("code", codeTagProps, renderedRows));
    }
});
parcelRegister("fBvqm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fdda3a2c4411588$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lrHA4;
    var $31cgS;
    var $d3zI6;
    function $2fdda3a2c4411588$var$createClassNameString(classNames) {
        return classNames ? classNames.join(' ') : '';
    }
    function $2fdda3a2c4411588$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
        if (node.type === 'text') {
            const { value: value } = node;
            const textValue = `${value}`;
            if (codeBidiWarningConfig.codeBidiWarnings) {
                const decorated = (0, (0, parcelRequire("31cgS")).default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lrHA4")).default), {
                        bidiCharacter: bidiCharacter,
                        key: index,
                        label: codeBidiWarningConfig.codeBidiWarningLabel,
                        tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                    }));
                return decorated;
            }
            return textValue;
        } else {
            const { properties: properties, tagName: tagName } = node;
            const childrenCreator = (0, (0, parcelRequire("d3zI6")).default)(codeBidiWarningConfig);
            const props = {
                ...properties,
                className: $2fdda3a2c4411588$var$createClassNameString(properties.className)
            };
            const children = childrenCreator(node.children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(tagName, {
                key: key,
                ...props
            }, children);
        }
    }
});
parcelRegister("lrHA4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e6443bd1dfeaac7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $abxiq;
    function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
        if (tooltipEnabled) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label,
            tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abxiq")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abxiq")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter);
    }
    const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...rest,
            ref: ref
        }, children);
    });
});
parcelRegister("abxiq", function(module, exports) {
    $parcel$export(module.exports, "Decorator", ()=>$59fdc1b7b0ae96c9$export$a592b67c93d52467);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jldZL;
    const $59fdc1b7b0ae96c9$var$decoration = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        ':before': {
            display: 'inline-flex',
            padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            background: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #7F5F01)",
            content: '"<"attr(data-bidi-character-code)">"',
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '18px',
            pointerEvents: 'auto'
        },
        ':hover:before': {
            background: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #533F04)"
        }
    });
    function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
        const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $59fdc1b7b0ae96c9$var$decoration,
            "data-testid": testId,
            "data-bidi-character-code": bidiCharacterCode,
            "aria-hidden": "true"
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
            testId: testId && `${testId}--visually-hidden`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("mark", null, bidiCharacterCode)));
    }
    function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
        const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
        return `U+${bidiCharacterCode}`;
    }
});
parcelRegister("31cgS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e16562bd8c2aca9b$export$2e2bcd8739ae039);
    const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
    function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
        const matches = [
            ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
        ];
        if (matches.length === 0) return originalText;
        let children = [];
        let mappedTo = 0;
        for (const match of matches){
            if (mappedTo !== match.index) children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            mappedTo = match.index + match[0].length;
        }
        if (mappedTo !== originalText.length) children.push(originalText.substring(mappedTo, originalText.length));
        return children;
    }
});
parcelRegister("d3zI6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcbc4a00f80b5d8f$export$2e2bcd8739ae039);
    var $fBvqm;
    function $dcbc4a00f80b5d8f$export$2e2bcd8739ae039(codeBidiWarningConfig) {
        let childrenCount = 0;
        return (children)=>{
            childrenCount += 1;
            return children.map((child, i)=>(0, (0, parcelRequire("fBvqm")).default)({
                    node: child,
                    codeBidiWarningConfig: codeBidiWarningConfig,
                    key: `code-segment-${childrenCount}-${i}`
                }));
        };
    }
});
parcelRegister("kN6qz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("as9qs").then(()=>parcelRequire('5zvIl'));
});
parcelRegister("lOZGq", function(module, exports) {
    $parcel$export(module.exports, "CopyAction", ()=>$b3c0013295f8779c$export$958df07cbf9735fc);
    $parcel$export(module.exports, "ActionContainer", ()=>$b3c0013295f8779c$export$37ab3bdebc286ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $ldJSL;
    var $3Fq5M;
    var $dC5iT;
    var $8CUq3;
    var $8zOmE;
    var $fEogx;
    const $b3c0013295f8779c$export$2ce9877c9c1aa16 = {
        PROMPT: 'Copy',
        SUCCESS: 'Copied!',
        FAILURE: 'Copy to clipboard failed'
    };
    const $b3c0013295f8779c$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        const handleSuccess = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.SUCCESS);
        }, [
            setTooltipMessage
        ]);
        const handleError = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.FAILURE);
        }, [
            setTooltipMessage
        ]);
        const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            actionSubjectId && (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
            navigator.clipboard.writeText(source).then(handleSuccess, handleError);
        }, [
            source,
            handleSuccess,
            handleError,
            actionSubjectId
        ]);
        const resetMessage = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        }, [
            setTooltipMessage
        ]);
        function shouldRender() {
            if (typeof document !== 'undefined') return Boolean(navigator?.clipboard?.writeText);
        }
        return shouldRender() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fEogx")).Action), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("3Fq5M"))))),
            label: tooltipMessage,
            onClick: writeToClipboard,
            onMouseOver: resetMessage,
            onFocus: resetMessage,
            "aria-live": "assertive",
            "aria-atomic": "true",
            name: "Copy"
        }) : null;
    };
    const $b3c0013295f8779c$var$stopPropagation = (event)=>event.stopPropagation();
    const $b3c0013295f8779c$export$37ab3bdebc286ca = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b3c0013295f8779c$var$absolutePositionWrapperStyles,
            onMouseDown: $b3c0013295f8779c$var$stopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), {
            label: "actions"
        }, children));
    const $b3c0013295f8779c$var$absolutePositionWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: 'space.0',
        right: 'space.0',
        padding: 'space.050',
        zIndex: 'flag'
    });
});
parcelRegister("fEogx", function(module, exports) {
    $parcel$export(module.exports, "Action", ()=>$e6da05ade6347218$export$e19cd5f9376f8cee);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $3bDjY;
    const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
        const updateTooltip = (0, $5uXOq.useRef)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            updateTooltip.current?.();
        }, [
            tooltipLabel,
            label
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: ({ update: update })=>{
                updateTooltip.current = update;
                return tooltipLabel || label;
            },
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            isLoading: isLoading,
            appearance: "subtle",
            icon: icon,
            label: label,
            spacing: "compact",
            ...buttonProps
        }));
    };
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("bTyOW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5073396748f92b4e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "viewBox", ()=>$5073396748f92b4e$export$a179c88182cb9d56);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("5I4tL")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("h8kvT")))));
    var $dCLgq;
    var $h8kvT = parcelRequire("h8kvT");
    var $5I4tL = parcelRequire("5I4tL");
    const $5073396748f92b4e$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($5I4tL)),
        srcDark: ($parcel$interopDefault($h8kvT))
    });
    var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
    const $5073396748f92b4e$export$a179c88182cb9d56 = [
        0,
        0,
        164,
        218
    ];
});
parcelRegister("h8kvT", function(module, exports) {
    module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();
});
parcelRegister("5I4tL", function(module, exports) {
    module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();
});
parcelRegister("fC09Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb376757c4acc5ab$export$2e2bcd8739ae039);
    var $dCLgq;
    var $3pGSh = parcelRequire("3pGSh");
    const $bb376757c4acc5ab$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($3pGSh)),
        srcDark: ($parcel$interopDefault($3pGSh))
    });
    var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
    const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
        0,
        0,
        167,
        226
    ];
});
parcelRegister("3pGSh", function(module, exports) {
    module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();
});
parcelRegister("4AdE6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$135a9e70a6f11b3e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        notFoundDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
            "defaultMessage": "Project not found - Service project"
        },
        notFoundTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
            "defaultMessage": "This project isn't available"
        },
        notFoundDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
            "defaultMessage": "It may have been deleted or your permissions may have changed"
        },
        notFoundAction: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
            "defaultMessage": "View a list of all projects"
        },
        genericDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
            "defaultMessage": "Error - Service project"
        },
        genericErrorTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
            "defaultMessage": "An error occurred"
        },
        genericErrorDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
            "defaultMessage": "An error occurred while loading this page"
        }
    });
});
parcelRegister("e33py", function(module, exports) {
    $parcel$export(module.exports, "PageTitle", ()=>$ae40b537a934bf9c$export$155581e8dc02007a);
    $parcel$export(module.exports, "ServiceDeskDocumentTitle", ()=>$ae40b537a934bf9c$export$c7841d2c1c13065e);
    var $5uXOq = parcelRequire("5uXOq");
    var $9sGI6;
    var $ew1Lk;
    var $koVbs;
    var $2BHCj;
    const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
        const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const title = subsection ? `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${subsection} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}` : `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
            title: title
        });
    };
    const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, (0, parcelRequire("9sGI6")).default)($ae40b537a934bf9c$export$155581e8dc02007a, {
        DocumentTitle: (0, (0, parcelRequire("ew1Lk")).DocumentTitle)
    });
    var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;
});
parcelRegister("2BHCj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d7eb5ce3479323e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        atlassianAnalytics: {
            "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
            "defaultMessage": "Atlassian Analytics"
        },
        serviceProject: {
            "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
            "defaultMessage": "Service project"
        },
        knowledge: {
            "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
            "defaultMessage": "Knowledge base"
        },
        itsmFeatures: {
            "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
            "defaultMessage": "Features"
        },
        queues: {
            "id": "servicedesk-spa-commons.common.utils.document-title.queues",
            "defaultMessage": "Queues"
        },
        customers: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customers",
            "defaultMessage": "Customers"
        },
        organizations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
            "defaultMessage": "Organizations"
        },
        customerServiceEscalations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
            "defaultMessage": "Developer escalations"
        },
        reports: {
            "id": "servicedesk-spa-commons.common.utils.document-title.reports",
            "defaultMessage": "Reports"
        },
        services: {
            "id": "servicedesk-spa-commons.common.utils.document-title.services",
            "defaultMessage": "Services"
        },
        oncall: {
            "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
            "defaultMessage": "On-call"
        },
        email: {
            "id": "servicedesk-spa-commons.common.utils.document-title.email",
            "defaultMessage": "Email request"
        },
        sla: {
            "id": "servicedesk-spa-commons.common.utils.document-title.sla",
            "defaultMessage": "Service level agreements"
        },
        csat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.csat",
            "defaultMessage": "Customer satisfaction"
        },
        details: {
            "id": "servicedesk-spa-commons.common.utils.document-title.details",
            "defaultMessage": "Details"
        },
        portal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal",
            "defaultMessage": "Customer portal"
        },
        externalLinks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
            "defaultMessage": "External resources"
        },
        portalSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
            "defaultMessage": "Portal settings"
        },
        automation: {
            "id": "servicedesk-spa-commons.common.utils.document-title.automation",
            "defaultMessage": "Automation"
        },
        advanced: {
            "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
            "defaultMessage": "Advanced"
        },
        languageSupport: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
            "defaultMessage": "Language support"
        },
        languageTranslations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
            "defaultMessage": "Language translations"
        },
        notificationEmail: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
            "defaultMessage": "Notification email"
        },
        notifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
            "defaultMessage": "Notifications"
        },
        internalNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
            "defaultMessage": "Internal notifications"
        },
        customerNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
            "defaultMessage": "Customer notifications"
        },
        widget: {
            "id": "servicedesk-spa-commons.common.utils.document-title.widget",
            "defaultMessage": "Widget"
        },
        customerPermissions: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
            "defaultMessage": "Customer permissions"
        },
        people: {
            "id": "servicedesk-spa-commons.common.utils.document-title.people",
            "defaultMessage": "Internal access"
        },
        issueType: {
            "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
            "defaultMessage": "Request types"
        },
        connectAppControls: {
            "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
            "defaultMessage": "Apps"
        },
        features: {
            "id": "servicedesk-spa-commons.common.utils.document-title.features",
            "defaultMessage": "Features"
        },
        calendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
            "defaultMessage": "Calendar"
        },
        projectSummary: {
            "id": "servicedesk-spa-commons.common.utils.document-title.project-summary",
            "defaultMessage": "Summary"
        },
        changeCalendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
            "defaultMessage": "Change calendar"
        },
        changeManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
            "defaultMessage": "Change management"
        },
        incidentManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
            "defaultMessage": "Incident management"
        },
        virtualAgentConversations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
            "defaultMessage": "Conversations"
        },
        virtualAgentIntents: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
            "defaultMessage": "Intents"
        },
        virtualAgentStandardFlows: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
            "defaultMessage": "Standard flows"
        },
        virtualAgentSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
            "defaultMessage": "Settings"
        },
        virtualAgentLanding: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
            "defaultMessage": "Virtual agent"
        },
        chat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.chat",
            "defaultMessage": "Chat"
        },
        proformaForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
            "defaultMessage": "Forms"
        },
        playbooks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
            "defaultMessage": "Playbooks"
        },
        dataClassifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
            "defaultMessage": "Data classification"
        },
        fieldsNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
            "defaultMessage": "Fields"
        },
        workflowScheme: {
            "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
            "defaultMessage": "Workflows"
        },
        journeysNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
            "defaultMessage": "Journeys"
        },
        journeyConfigNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
            "defaultMessage": "Journey configuration"
        },
        helpCenterForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-forms",
            "defaultMessage": "Forms"
        }
    });
});
parcelRegister("6FTcZ", function(module, exports) {
    $parcel$export(module.exports, "useKbConfluenceContext", ()=>$5955acba1bcddf7a$export$a8450b4f39918e6d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bjZiV;
    var $dIdda = parcelRequire("dIdda");
    const $5955acba1bcddf7a$var$getKbConfluenceContextResource = ()=>(0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource);
    const $5955acba1bcddf7a$export$a8450b4f39918e6d = (projectKey)=>{
        const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $dIdda.useResource)($5955acba1bcddf7a$var$getKbConfluenceContextResource());
        (0, $5uXOq.useEffect)(()=>{
            if (!false) refreshCache();
        }, [
            projectKey,
            refreshCache
        ]);
        return [
            {
                data: data,
                loading: loading,
                error: error
            }
        ];
    };
    var $5955acba1bcddf7a$export$2e2bcd8739ae039 = $5955acba1bcddf7a$export$a8450b4f39918e6d;
});
parcelRegister("4S0uJ", function(module, exports) {
    $parcel$export(module.exports, "PageStyle", ()=>$7307247c9fc02c84$export$c59987a647e9a55);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bAkIV;
    const $7307247c9fc02c84$export$c59987a647e9a55 = ({ Page: Page, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7307247c9fc02c84$var$JSDSpaPageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Page, null, children));
    $7307247c9fc02c84$export$c59987a647e9a55.defaultProps = {
        Page: (0, (0, parcelRequire("bAkIV")).default)
    };
    var $7307247c9fc02c84$export$2e2bcd8739ae039 = $7307247c9fc02c84$export$c59987a647e9a55;
    const $7307247c9fc02c84$var$JSDSpaPageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8zdiv",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bAkIV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e769a1b108c1b03$export$2e2bcd8739ae039);
    var $cE92Q;
    var $bJcWY;
    var $aZdfU;
    var $5e769a1b108c1b03$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cE92Q")).default);
});
parcelRegister("cE92Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f4d1a89146de6ed$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $f1WIN;
    function $2f4d1a89146de6ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2f4d1a89146de6ed$var$bannerStyles = {
        name: "4oew4k",
        styles: "width:100%;position:fixed"
    };
    const $2f4d1a89146de6ed$var$bannerContainerStyles = {
        name: "1x3pv69",
        styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
    };
    const $2f4d1a89146de6ed$var$pageContentStyles = {
        name: "15n167b",
        styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
    };
    const $2f4d1a89146de6ed$var$wrapperStyles = {
        name: "m5v4sl",
        styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
    };
    const $2f4d1a89146de6ed$var$mainContainerStyles = {
        name: "1cete8c",
        styles: "display:flex;flex:1 1 auto"
    };
    const $2f4d1a89146de6ed$var$navigationStyles = {
        name: "wrqbg1",
        styles: "position:relative;z-index:2"
    };
    const $2f4d1a89146de6ed$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, (0, parcelRequire("f1WIN")).defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2f4d1a89146de6ed$var$wrapperStyles,
            "data-testid": testId
        }, banner ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2f4d1a89146de6ed$var$bannerContainerStyles,
            style: {
                height: isBannerOpen ? `${bannerHeight}px` : '0'
            },
            "aria-hidden": !isBannerOpen,
            "data-testid": testId ? `${testId}--banner-container` : undefined
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2f4d1a89146de6ed$var$bannerStyles
        }, banner)) : null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2f4d1a89146de6ed$var$mainContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2f4d1a89146de6ed$var$navigationStyles
        }, navigation), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2f4d1a89146de6ed$var$pageContentStyles
        }, children)));
    };
    var $2f4d1a89146de6ed$export$2e2bcd8739ae039 = $2f4d1a89146de6ed$var$Page;
});
